export const cities = [
  { value: 'tel-aviv', label: 'תל אביב' },
  { value: 'ramat-gan', label: 'רמת גן' },
  { value: 'givataim', label: 'גבעתיים' },
//  { value: 'ofakim', label: 'אופקים' },//
  { value: 'jerusalem', label: 'ירושלים' },
//  { value: 'haifa', label: 'חיפה' },//
//  { value: 'rishon', label: 'ראשון לציון' },//
 // { value: 'netanya', label: 'נתניה' },//
//  { value: 'eilat', label: 'אילת' },//
//  { value: 'ashdod', label: 'אשדוד' },//
 // { value: 'beer-sheva', label: 'באר שבע' },//
//  { value: 'ashkelon', label: 'אשקלון' },//
 //  { value: 'herzliya', label: 'הרצליה' },//
//  { value: 'shoam', label: 'שוהם' },//
//  { value: 'bat-yam', label: 'בת-ים' }//
];

export const neighborhoods: Record<string, Array<{ value: string; label: string }>> = {
  'or-yehuda': [
    { value: 'kiryat-giora-north', label: 'קריית גיורא (צפון)' },
    { value: 'kiryat-giora-south', label: 'קריית גיורא (דרום)' },
    { value: 'histadrut-north', label: 'ההסתדרות (צפון)' },
    { value: 'histadrut-south', label: 'ההסתדרות (דרום)' },
    { value: 'industrial-almog-yahalom', label: 'אזור תעשייה אלמוג ויהלום (נתניהו)' },
    { value: 'city-center', label: 'מרכז העיר' },
    { value: 'amidar', label: 'עמידר' },
    { value: 'pardes-neve-hadarim', label: 'הפרדס, נווה הדרים' },
    { value: 'neve-savyon', label: 'נווה סביון' },
    { value: 'industrial-sapir', label: 'אזור תעשייה ספיר' },
    { value: 'governmental-housing', label: 'שיכון ממשלתי' },
    { value: 'ramat-pinkas', label: 'רמת פנקס' }
 ], 
   'givataim': [
    { value: 'borochov', label: 'בורוכוב' },
    { value: 'kiryat-yosef', label: 'קריית יוסף' },
    { value: 'halamedhe', label: 'הל"ה' },
    { value: 'poale-harakevet', label: 'פועלי הרכבת' },
    { value: 'shenkin', label: 'שינקין' },
    {value: 'givat-kosolovski', label: 'גבעת קוזלובסקי' },
    { value: 'arlosorov', label: 'ארלוזורוב' },
    { value: 'givat-rambam', label: 'גבעת רמב"ם' },
    { value: 'shtach-9', label: 'שטח 9' },
    { value: 'shikon-elec', label: 'שיכון חברת חשמל' },
    { value: 'tel-ganim', label: 'תל גנים' },
     { value: 'city', label: 'סיטי' }
        
  ],
  'bat-yam': [
    { value: 'tzhvon-maarav', label: 'צפון-מערב' },
    { value: 'merkaz-ha-ir', label: 'מרכז העיר' },
    { value: 'ramat-hanasi', label: 'רמת הנשיא' },
    { value: 'darom-maarav', label: 'דרום-מערב' },
    { value: 'ramat-yosef', label: 'רמת יוסף' },
    { value: 'amidar', label: 'עמידר' },
    { value: 'ezor-taasiya', label: 'אזור תעשיה' },
    { value: 'beit-vegan', label: 'בית וגן' },
    { value: 'vatikim', label: 'ותיקים' },
    { value: 'mitkham-gan-ha-ir', label: 'מתחם גן העיר' }
  ],

  'shoam': [
  { value: 'hadasim', label: 'הדסים' },
  { value: 'rakafot', label: 'רקפות' },
  { value: 'veradim', label: 'ורדים' },
  { value: 'yovelim', label: 'יובלים' },
  { value: 'alonim', label: 'אלונים' },
  { value: 'broshim', label: 'ברושים' },
  { value: 'eyalim', label: 'יעלים' },
  { value: 'sahlavim', label: 'סחלבים' },
  { value: 'kramim', label: 'כרמים' },
  { value: 'tlalim', label: 'טללים' },
  { value: 'hamaniyot', label: 'חמניות' },
  { value: 'givaolim', label: 'גבעולים' }
],

  'ramat-gan': [
  { value: 'yad-levanim', label: 'יד לבנים' },
  { value: 'tal-givim', label: 'תל גנים' },
  { value: 'ramat-amidar', label: 'רמת עמידר' },
  { value: 'shkhunat-mizrahit', label: 'שיכון המזרחי' },
  { value: 'mitkham-givah', label: 'מתחם נגבה' },
  { value: 'tal-yehuda', label: 'תל יהודה' },
  { value: 'bar-ilan', label: 'בר אילן' },
  { value: 'ben-goryon', label: 'בן גוריון' },
  { value: 'merkaz-hair-g', label: ' מרכז העיר' },
  { value: 'merkaz-hair-b', label: 'יהלום' },
  { value: 'merkaz-hair-a', label: 'החשמונאים' },
  { value: 'vatikim', label: 'שיכון ותיקים' },
  { value: 'habursa', label: 'הבורסה' },
  { value: 'ramat-afal', label: 'רמת אפעל' },
  { value: 'kfar-adar', label: 'כפר אז"ר' },
  { value: 'shkhunat-tzfonim', label: 'שיכון צנחנים' },
  { value: 'ezor-havilim', label: 'הבילויים' },
  { value: 'neve-yehoshua', label: 'נווה יהושע' },
  { value: 'kiryat-borochov', label: 'קריית בורוכוב' },
  { value: 'ramet-hen', label: 'רמת חן' },
  { value: 'hagefen', label: 'הגפן' },
  { value: 'ramat-shikma', label: 'רמת שיקמה' },
  { value: 'tal-hashomer', label: 'תל השומר' },
  { value: 'tal-binyamin', label: 'תל בנימין' },
  { value: 'rishonim', label: 'הראשונים' },
  { value: 'merkaz-nave', label: 'מרום נווה' },
  { value: 'nahalat-ganim', label: 'נחלת גנים' },
  { value: 'halel', label: 'הלל' },
  { value: 'kiryat-krinzki', label: 'קרית קריניצי' },
  { value: 'hadarim', label: 'חרוזים' }
],


  'herzliya': [
    { value: 'yad-hatasha', label: 'יד התשעה' },
    { value: 'neve-amal-north', label: 'נווה עמל (צפון)' },
    { value: 'neve-amal-south', label: 'נווה עמל (דרום)' },
    { value: 'givat-haprahim-ganey-herzliya-tzmarot-darom', label: 'גבעת הפרחים, גני הרצליה, צמרות, שכ\' דרום' },
    { value: 'gordon-south', label: 'גורדון (דרום)' },
    { value: 'neve-amirim', label: 'נווה אמירים' },
    { value: 'neve-israel', label: 'נווה ישראל' },
    { value: 'shimshon-hagibor', label: 'שמשון הגבור' },
    { value: 'gordon-north', label: 'גורדון (צפון)' },
    { value: 'harav-goren', label: 'הרב גורן' },
    { value: 'maonot-sarah', label: 'מעונות שרה' },
    { value: 'sirkyn', label: 'סירקין' },
    { value: 'hahagana', label: 'ההגנה' },
    { value: 'merkaz', label: 'מרכז' },
    { value: 'neve-oved-south', label: 'נווה עובד (דרום)' },
    { value: 'neve-oved-north', label: 'נווה עובד (צפון)' },
    { value: 'gan-rashal-nahalat-ada', label: 'גן רש"ל, נחלת עדה' },
    { value: 'maonot-poalim', label: 'מעונות פועלים' },
    { value: 'kiryat-rabin-sport', label: 'קרית רבין (קרית ספורט)' },
    { value: 'bney-binyamin', label: 'בני בנימין' },
    { value: 'alkalai', label: 'אלקלעי' },
    { value: 'weizmann-east', label: 'וייצמן (מזרח)' },
    { value: 'weizmann-west', label: 'וייצמן (מערב)' },
    { value: 'new-industrial-marina', label: 'אזור תעשייה חדש, מרינה' },
    { value: 'industrial', label: 'אזור תעשייה' },
    { value: 'givat-hasofer', label: 'גבעת הסופר' },
    { value: 'herzliya-pituach-east', label: 'הרצליה פיתוח (מזרח)' },
    { value: 'herzliya-pituach-west', label: 'הרצליה פיתוח (מערב)' },
    { value: 'apollonia-nof-yam-reshef', label: 'אפולוניה, הרצליה פיתוח (צפון), נוף ים, רשף' }
  ],
  'ofakim': [
    { value: 'mishor-hagefen', label: 'מישור הגפן' },
    { value: 'dedo-yoni-mesika', label: 'דדו, יוני, יעקב מסיקה, שכ\' משטרה' },
    { value: 'arazim', label: 'הארזים' },
    { value: 'bne-beitcha-harif', label: 'בנה ביתך, הרי"ף' },
    { value: 'industrial-area', label: 'אזור התעשייה והמלאכה' },
    { value: 'ben-gurion', label: 'בן גוריון' },
    { value: 'shapira', label: 'שפירא' }
  ],
  'tel-aviv': [
    { value: 'old-north-np', label: 'הצפון הישן החלק הצפוני' },
    { value: 'old-north-sp', label: 'הצפון הישן החלק הדרומי' },
    { value: 'tel-baruch', label: 'תל ברוך' },
    { value: 'tel-baruch-n', label: 'תל ברוך צפון' },
    { value: 'city-center', label: 'לב העיר' },
    { value: 'afeka-a', label: 'נאות אפקה א' },
    { value: 'afeka-b', label: 'נאות אפקה ב' },
    { value: 'afeka', label: 'אפקה' },
    { value: 'florentin', label: 'פלורנטין' },
    { value: 'neve shaanan', label: 'נווה שאנן' },
    { value: 'neve-tzedek', label: 'נווה צדק' },
    { value: 'neve-dan', label: 'נווה דן' },
    { value: 'neve-sharet', label: 'נווה שרת' },
    { value: 'revivim', label: 'רביבים'  },
    { value: 'ramat-hachayal', label: 'רמת החייל' },
    { value: 'keremhatemanim', label: 'כרם התימנים' },
    { value: 'bavli', label: 'בבלי' },
    { value: 'zamarot-ayalon', label: 'צמרות איילון' },
    { value: 'tochnit-l', label: 'תכנית ל' },
    { value: 'azorie-chen', label: 'אזורי חן' },
    { value: 'kochav-hatzafon', label: 'כוכב הצפון' },
    { value: 'new-north-np', label: 'הצפון החדש החלק הצפוני' },
    { value: 'new-north-sp', label: 'הצפון החדש החלק הדרומי' },
    { value: 'new-north-km', label: 'הצפון החדש סביבת כיכר המדינה' },
    { value: 'ramat-aviv', label: 'רמת אביב' },
    { value: 'ramat-aviv-g', label: 'רמת אביב ג' },
    { value: 'ramat-aviv-n', label: 'רמת אביב החדשה' },
    { value: 'neve-avivim', label: 'נווה אביבים' },
    { value: 'neve-chen', label: 'נווה חן' },
    { value: 'yad-eliyahu', label: 'יד אליהו' },
    { value: 'ramat-hatayasim', label: 'רמת הטייסים' },
    { value: 'hatikva', label: 'התקווה' },
    { value: 'kfar-shalem', label: 'כפר שלם' },
    { value: 'montefiore', label: 'מונטיפיורי' },
    { value: 'yafo', label: 'צפון יפו' },
    { value: 'bizaron', label: 'ביצרון' },
    { value: 'nachaltizhack', label: 'נחלת יצחק' },
    { value: 'shapira', label: 'שפירא' },
    { value: 'kiryat-shalom', label: 'קריית שלום' },
    { value: 'hadar-yosef', label: 'הדר יוסף' },
    { value: 'tzahala', label: 'צהלה' },
    { value: 'hamishtala', label: 'המשתלה' },
    { value: 'ganei-tzahala', label: 'גני צהלה' },
    { value: 'ganei-sharona', label: 'גני שרונה' },
    { value: 'gelilot', label: 'גלילות' },
    { value: 'nofe-yam', label: 'נופי ים' }
  ],
  'beer-sheva': [
    { value: 'kiryat-wolfson', label: 'קרית וולפסון, שכ\' ד\' (צפון - מזרח)' },
    { value: 'shkh-d-nw', label: 'שכ\' ד\' (צפון-מערב)' },
    { value: 'shkh-d-n', label: 'שכ\' ד\' (צפון)' },
    { value: 'shkh-d-center', label: 'שכ\' ד\' (מרכז)' },
    { value: 'shkh-d-east', label: 'שכ\' ד\' (מזרח)' },
    { value: 'shkh-d-se', label: 'שכ\' ד\' (דרום - מזרח)' },
    { value: 'shkh-d-sw', label: 'שכ\' ד\' (דרום-מערב)' },
    { value: 'shkh-d-s', label: 'שכ\' ד\' (דרום)' },
    { value: 'shkh-v-se', label: 'שכ\' ו\' (דרום - מזרח)' },
    { value: 'shkh-v-center', label: 'שכ\' ו\' (מרכז)' },
    { value: 'shkh-v-ne', label: 'שכ\' ו\' (צפון-מזרח)' },
    { value: 'shkh-v-nw', label: 'שכ\' ו\' (צפון-מערב)' },
    { value: 'shkh-v-n', label: 'שכ\' ו\' (צפון)' },
    { value: 'shkh-v-sw', label: 'שכ\' ו\' (דרום-מערב)' },
    { value: 'shkh-ya-nw', label: 'שכ\' י"א - רמות ספיר (צפון-מערב)' },
    { value: 'shkh-ya-ne', label: 'שכ\' י"א - רמות ספיר (צפון-מזרח)' },
    { value: 'shkh-ya-se', label: 'שכ\' י"א - רמות ספיר (דרום-מזרח)' },
    { value: 'shkh-ya-sw', label: 'שכ\' י"א - רמות ספיר (דרום-מערב)' },
    { value: 'shkh-ya-s', label: 'שכ\' י"א - רמות ספיר (דרום)' },
    { value: 'neve-menachem-n', label: 'נווה מנחם (צפון)' },
    { value: 'neve-menachem-center', label: 'נווה מנחם (מרכז)' },
    { value: 'neve-menachem-s', label: 'נווה מנחם (דרום)' },
    { value: 'neve-zeev-sw', label: 'נווה זאב (דרום - מערב)' },
    { value: 'shkh-hatzerim', label: 'ש חצרים, שכ\' דרום (מערב)' },
    { value: 'neve-zeev-ne', label: 'נווה זאב (צפון - מזרח)' },
    { value: 'neve-zeev-nw', label: 'נווה זאב (צפון - מערב)' },
    { value: 'neve-zeev-center', label: 'נווה זאב (מרכז)' },
    { value: 'naot-lon', label: 'נאות לון' },
    { value: 'shkh-t-w', label: 'שכ\' ט\' (מערב)' },
    { value: 'shkh-t-e', label: 'שכ\' ט\' (מזרח)' },
    { value: 'shkh-h-se', label: 'שכ\' ה\' (דרום - מזרח)' },
    { value: 'shkh-h-sw', label: 'שכ\' ה\' (דרום - מערב)' },
    { value: 'shkh-h-nw', label: 'שכ\' ה\' (צפון - מערב)' },
    { value: 'shkh-h-ne', label: 'שכ\' ה\' (צפון - מזרח)' },
    { value: 'shkh-b-w', label: 'שכ\' ב\' (מערב)' },
    { value: 'shkh-b-center', label: 'שכ\' ב\' (מרכז)' },
    { value: 'shkh-b-e', label: 'שכ\' ב\' (מזרח)' },
    { value: 'shkh-a-ne', label: 'שכ\' א\' (צפון-מזרח)' },
    { value: 'shkh-a-se', label: 'שכ\' א\' (דרום-מזרח)' },
    { value: 'shkh-a-w', label: 'שכ\' א\' (מערב)' },
    { value: 'old-city-w', label: 'העיר העתיקה (מערב)' },
    { value: 'shkh-s-e', label: 'שכ\' דרום (מזרח)' },
    { value: 'neve-noy', label: 'נווה נוי' },
    { value: 'nahal-beka', label: 'נחל בקע' },
    { value: 'industrial-zones', label: 'אזורי תעשייה: עמק שרה, מרכז ביג, קרית יהודית' },
    { value: 'old-city-e', label: 'העיר העתיקה (מזרח)' },
    { value: 'civil-center', label: 'מרכז אזרחי' },
    { value: 'shkh-g-s', label: 'שכ\' ג\' (דרום)' },
    { value: 'shkh-g-center', label: 'שכ\' ג\' (מרכז)' },
    { value: 'shkh-g-n', label: 'שכ\' ג\' (צפון)' },
    { value: 'ben-gurion-univ', label: 'אוניברסיטת בן גוריון, הקריה ע"ש א. ברגמן, מרכז רפואי סורוקה' },
    { value: 'ramot-s', label: 'רמות (דרום)' },
    { value: 'ramot-center', label: 'רמות (מרכז), רמות ד\'' },
    { value: 'ramot-e', label: 'רמות (מזרח)' },
    { value: 'ramot-n', label: 'רמות (צפון)' },
    { value: 'ramot-b', label: 'רמות ב' }
],
  'jerusalem': [
    { value: 'rehavia', label: 'רחביה' },
    { value: 'french-hill', label: 'הגבעה הצרפתית' },
    { value: 'pisgat-zeev', label: 'פסגת זאב' },
    { value: 'german-colony', label: 'מושבה גרמנית' },
    { value: 'musrara', label: 'מוסררה' },
    { value: 'city-center', label: 'מרכז העיר' },
    { value: 'nachlaot', label: 'נחלאות' },
    { value: 'talbiya', label: 'טלביה' },
    { value: 'kiryat-haleom', label: 'קרית הלאום' },
    { value: 'kiryat-yovel', label: 'קרית היובל' },
    { value: 'katamonim', label: 'קטמונים' },
    { value: 'arnona', label: 'ארנונה' },
    { value: 'geolim-bakaa', label: 'גאולים בקעה' },
    { value: 'beit-vegan', label: 'בית וגן' }
  ],
  'haifa': [
    { value: 'carmel', label: 'כרמל' },
    { value: 'hadar', label: 'הדר' },
    { value: 'bat-galim', label: 'בת גלים' }
  ],
  
    'rishon': [
  { value: 'avrahamovitz', label: 'אברמוביץ' },
  { value: 'bnot-khayil', label: 'בנות חיל' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'katsnelson', label: 'כצנלסון' },
  { value: 'mabit-maarav', label: 'מב"ת מערב' },
  { value: 'mabit-tsafon', label: 'מב"ת צפון' },
  { value: 'mishor-hof', label: 'מישור הנוף' },
  { value: 'noot-asalim', label: 'נאות אשלים' },
  { value: 'noot-shikma', label: 'נאות שיקמה' },
  { value: 'noot-dkalim', label: 'נווה דקלים' },
  { value: 'noot-hadarim', label: 'נווה הדרים' },
  { value: 'noot-haklal', label: 'נווה הלל' },
  { value: 'noot-hof', label: 'נווה חוף' },
  { value: 'noot-yam', label: 'נווה ים' },
  { value: 'nakhalat-yehuda', label: 'נחלת יהודה' },
  { value: 'neorim', label: 'נעורים' },
  { value: 'tsameret', label: 'צמרות' },
  { value: 'kadmata-rishon', label: 'קדמת ראשון' },
  { value: 'kiryat-ganim', label: 'קריית גנים' },
  { value: 'kiryat-keramim', label: 'קריית כרמים' },
  { value: 'kiryat-khatanei-peres-nobel', label: 'קריית חתני פרס נובל' },
  { value: 'kiryat-rishon', label: 'קריית ראשון' },
  { value: 'kiryat-simkha', label: 'קריית שמחה' },
  { value: 'rishonim', label: 'ראשונים' },
  { value: 'revivim', label: 'רביבים' },
  { value: 'rambam', label: 'רמב"ם' },
  { value: 'remez', label: 'רמז' },
  { value: 'ramat-eliyahu', label: 'רמת אליהו' },
  { value: 'merkaz-rishon', label: 'מרום ראשון' },
  { value: 'kiryat-haum', label: 'קריית הלאום' },
  { value: 'sha-ar-ha-yam', label: 'שער הים' },
  { value: 'shikun-ha-mizrah', label: 'שיכוני המזרח' },
  { value: 'kalaniot', label: 'כלניות' }

  ],
  'netanya': [
  { value: 'neve-itamar', label: 'נווה איתמר' },
  { value: 'pardes-hagdud', label: 'פרדס הגדוד' },
  { value: 'kiryat-sanz', label: 'קרית צאנז' },
  { value: 'neot-hertzel', label: 'נאות הרצל' },
  { value: 'hof-hayam-vehamelunot', label: 'חוף הים והמלונות' },
  { value: 'neot-ganim-shikun-vatikim', label: 'נאות גנים - שיכון ותיקים' },
  { value: 'givaat-hairusim', label: 'גבעת האירוסים' },
  { value: 'ramat-efraim', label: 'רמת אפרים' },
  { value: 'ir-hayamim', label: 'עיר ימים' },
  { value: 'kiryat-nordau', label: 'קריית נורדאו' },
  { value: 'ein-hatkelet', label: 'עין התכלת' },
  { value: 'merkaz-hair', label: 'מרכז העיר' },
  { value: 'kiryat-hasharon', label: 'קריית השרון' },
  { value: 'ramat-yigal-yadin', label: 'רמת יגאל ידין' },
  { value: 'dora', label: 'דורה' },
  { value: 'ezor-taasiya-pinchas-sefi', label: 'אזור תעשיה פנחס ספיר' },
  { value: 'ramat-poleg', label: 'רמת פולג' },
  { value: 'neot-golda', label: 'נאות גולדה' },
  { value: 'neot-sheked', label: 'נאות שקד' },
  { value: 'nof-hatayelet', label: 'נוף הטיילת' },
  { value: 'machane-yaakov', label: 'מחנה יעקב' },
  { value: 'neot-menachem-begin', label: 'נאות מנחם בגין' },
  { value: 'nof-galim', label: 'נוף גלים' },
  { value: 'galei-hayam', label: 'גלי הים' },
  { value: 'agamim', label: 'אגמים' },
  { value: 'agam-3-betiknun', label: 'אגם 3 - בתכנון' },
  { value: 'givat', label: 'גבע' },
  { value: 'avoshid', label: 'אבו שיד' },
  { value: 'ben-zion', label: 'בן ציון' },
  { value: 'maale-merkaz-ironi-r', label: 'מעל"ר - מרכז עירוני ר' },
  { value: 'ramat-hen', label: 'רמת חן' },
  { value: 'shkhunot-zvolon', label: 'שכונות זבולון' },
  { value: 'kiryat-yitzhak-rabin', label: 'קריית יצחק רבין' },
  { value: 'kiryat-shazar', label: 'קריית שזר' },
  { value: 'kiryat-yamim-park-tet', label: 'קריית יהלום - פארק ט' },
  { value: 'miflas', label: 'מפנס' },
  { value: 'rispon', label: 'ריסקו' },
  { value: 'neve-shalom', label: 'נווה שלום' },
  { value: 'ezor-taasiya-kiryat-el', label: 'אזור תעשיה קריית אל' }
  ],
  'eilat': [
    { value: 'ben-gurion', label: 'בן גוריון, שיכון שבענה' },
    { value: 'hotels', label: 'אזור המלונות, החוף הצפוני אילת' },
    { value: 'center', label: 'מרכז' },
    { value: 'industrial', label: 'אזור התעשייה' },
    { value: 'yealim', label: 'יעלים, נווה מדבר, שכ\' אטונגים' },
    { value: 'dekel', label: 'הדקל' },
    { value: 'eshel', label: 'האשל' },
    { value: 'west-2', label: 'מערב 2, ערבה, שכ\' פטיו' },
    { value: 'urim', label: 'אורים' },
    { value: 'west-1', label: 'מערב 1, צאלים' },
    { value: 'mitzpe-yam', label: 'מצפה ים' },
    { value: 'ofir', label: 'אופיר' },
    { value: 'build-your-home', label: 'בנה ביתך, צופית, צופית עלית, שכ\' בתי ברמן' },
    { value: 'ganim', label: 'גנים א\', גנים ב\', מצפה נוף' },
    { value: 'shahmon-nw', label: 'שחמון (צפון - מערב)' },
    { value: 'shahmon-e', label: 'שחמון (מזרח)' },
    { value: 'shahmon-sw', label: 'שחמון (דרום - מערב)' },
    { value: 'shahmon-s', label: 'שחמון (דרום)' }
  ],
  'ashdod': [
    { value: 'industrial-3', label: 'אזור תעשייה 3' },
    { value: 'industrial-1-2', label: 'אזור התעשייה 1, אזור תעשייה 2, טופ סנטר' },
    { value: 'port', label: 'נמל אשדוד' },
    { value: 'quarter-a', label: 'רובע א\'' },
    { value: 'quarter-a-sw', label: 'רובע א\' (דרום - מערב)' },
    { value: 'givat-yona', label: 'גבעת יונה, רובע א\' (צפון - מערב)' },
    { value: 'bakma', label: 'אזור בקמה (תפקודי מיוחד)' },
    { value: 'quarter-a-ne', label: 'רובע א\' (צפון - מזרח)' },
    { value: 'quarter-a-se', label: 'רובע א\' (דרום – מזרח)' },
    { value: 'quarter-b-sw', label: 'רובע ב\' (דרום-מערב)' },
    { value: 'quarter-b-se', label: 'רובע ב\' (דרום-מזרח)' },
    { value: 'quarter-b-n', label: 'רובע ב\' (צפון), שכ\' ונטורה' },
    { value: 'quarter-c-n-ashtrom', label: 'אשטרום, רובע ג\' (צפון)' },
    { value: 'quarter-c-n-neve', label: 'נוה יהונתן, רובע ג\' (צפון)' },
    { value: 'quarter-c-center', label: 'רובע ג\' (מרכז)' },
    { value: 'quarter-c-s', label: 'מתחם אלתא, קרית פוניבש, רובע ג\' (דרום)' },
    { value: 'park-hashita', label: 'פארק השיטה המלבינה' },
    { value: 'quarter-g-se', label: 'רובע ז\' (דרום - מזרח)' },
    { value: 'quarter-g-nw', label: 'רובע ז\' (צפון - מערב)' },
    { value: 'quarter-f-e', label: 'רובע ו\' (מזרח)' },
    { value: 'quarter-f-s', label: 'רובע ו\' (דרום)' },
    { value: 'quarter-f-w', label: 'רובע ו\' (מערב)' },
    { value: 'quarter-e-e', label: 'רובע ה\' (מזרח)' },
    { value: 'quarter-e-se', label: 'רובע ה\' (דרום-מזרח)' },
    { value: 'quarter-e-sw', label: 'רובע ה\' (דרום-מערב)' },
    { value: 'quarter-e-nw', label: 'נאות ספיר, רובע ה\' (צפון-מערב)' },
    { value: 'quarter-d-ne', label: 'רובע ד\' (צפון-מזרח)' },
    { value: 'quarter-d-se', label: 'רובע ד\' (דרום-מזרח)' },
    { value: 'quarter-d-sw', label: 'רובע ד\' (דרום-מערב)' },
    { value: 'quarter-d-nw', label: 'רובע ד\' (צפון - מערב)' },
    { value: 'marina', label: 'אזור המרינה, חוף הקשתות' },
    { value: 'city-center-n', label: 'הקריה-מע"ר (צפון)' },
    { value: 'city-center-sw', label: 'הקריה-מגורים (דרום-מערב)' },
    { value: 'city-center-se', label: 'הקריה-מגורים (דרום-מזרח)' },
    { value: 'city-center-nw', label: 'הקריה-מגורים (צפון-מערב)' },
    { value: 'city-center-ne', label: 'הקריה-מגורים (צפון-מזרח)' },
    { value: 'quarter-h-s', label: 'רובע ח\' (דרום)' },
    { value: 'quarter-h-w', label: 'רובע ח\' (מערב)' },
    { value: 'quarter-h-e', label: 'רובע ח\' (מזרח)' },
    { value: 'quarter-i-1', label: 'רובע ט\'' },
    { value: 'quarter-i-2', label: 'רובע ט\'' },
    { value: 'quarter-i-3', label: 'רובע ט\'' },
    { value: 'quarter-n-n', label: 'רובע י"ד (צפון)' },
    { value: 'quarter-j-n', label: 'רובע י\' (צפון)' },
    { value: 'quarter-j-s', label: 'רובע י\' (דרום)' },
    { value: 'quarter-m-sw', label: 'רובע י"ג (דרום ומערב)' },
    { value: 'quarter-m-c', label: 'רובע י"ג (מרכז)' },
    { value: 'quarter-m-ne', label: 'רובע י"ג (צפון-מזרח)' },
    { value: 'quarter-n-s', label: 'רובע י"ד (דרום)' },
    { value: 'quarter-p', label: 'רובע ט"ז' },
    { value: 'quarter-l-n', label: 'רובע י"ב (צפון)' },
    { value: 'quarter-l-s', label: 'רובע י"ב (דרום)' },
    { value: 'quarter-k-ne', label: 'רובע י"א (צפון - מזרח)' },
    { value: 'quarter-k-se', label: 'רובע י"א (דרום - מזרח)' },
    { value: 'quarter-k-c', label: 'רובע י"א (מרכז)' },
    { value: 'quarter-k-w', label: 'רובע י"א (מערב)' },
    { value: 'quarter-k-w-beach', label: 'רובע י"א (מערב), רצועת החוף הדרומי' },
    { value: 'quarter-o-n', label: 'רובע ט"ו (צפון)' },
    { value: 'quarter-o-s', label: 'רובע ט"ו (דרום)' },
    { value: 'quarter-q', label: 'רובע י"ז' }
  ],
  'ashkelon': [
    { value: 'barnea-bg', label: 'ברנע ב\', ברנע ג\', כפר גולף, רמת כרמים' },
    { value: 'ganei-barnea', label: 'גני ברנע, מצפה ברנע' },
    { value: 'neot-barnea', label: 'נאות ברנע' },
    { value: 'barnea-a', label: 'ברנע א\'' },
    { value: 'marina-area', label: 'כפרי הנופש, מרינה, רצועת החוף והמלונות' },
    { value: 'afridar-west', label: 'אפרידר (מערב)' },
    { value: 'afridar-east', label: 'אפרידר (מזרח)' },
    { value: 'afridar-south', label: 'אפרידר (דרום), שכ\' חסכון אפרידר' },
    { value: 'eshkolei-paz', label: 'אשכולי פז' },
    { value: 'ashkelon-city', label: 'אשקלון סיטי' },
    { value: 'merkaz-nifti', label: 'מרכז נפתי, קרית חינוך' },
    { value: 'neot-ashkelon', label: 'נאות אשקלון' },
    { value: 'neve-ilan', label: 'נווה אילן' },
    { value: 'neve-hadarim', label: 'נווה ההדרים' },
    { value: 'neve-dekalim-s', label: 'נווה דקלים (דרום)' },
    { value: 'neve-dekalim-n', label: 'נווה דקלים (צפון)' },
    { value: 'kochav-hatzafon', label: 'כוכב הצפון' },
    { value: 'migdal', label: 'מגדל' },
    { value: 'ramat-eshkol', label: 'רמת אשכול, רמת חן' },
    { value: 'industrial-n', label: 'אזור התעשייה הצפוני' },
    { value: 'givat-flowers', label: 'גבעת הפרחים, שכ\' דרומי' },
    { value: 'givat-zion', label: 'גבעת ציון, כרמי ציון' },
    { value: 'gan-vradim', label: 'גן הורדים' },
    { value: 'shimshon-e', label: 'שמשון (מזרח)' },
    { value: 'shikmim', label: 'שיקמים, שמשון (מרכז א\')' },
    { value: 'jabotinsky', label: 'ז\'בוטינסקי, שמשון (מערב)' },
    { value: 'shimshon-c', label: 'שמשון (מרכז ב\')' },
    { value: 'ben-gurion', label: 'רמת בן גוריון, שמשון (צפון)' },
    { value: 'barzilai', label: 'מרכז רפואי ברזילי, נווה ים' },
    { value: 'neve-alonim', label: 'נווה אלונים' },
    { value: 'golda', label: 'גולדה' },
    { value: 'industrial-s', label: 'אזור התעשייה הדרומי' }
  ]
};

export const streets: Record<string, Record<string, Array<{ value: string; label: string }>>> = {
  'or-yehuda': {
    'kiryat-giora-north': [
      { value: 'savyon', label: 'סביון' },
      { value: 'adam-yekutiel', label: 'אדם יקותיאל' },
      { value: 'hakalanit', label: 'הכלנית' },
      { value: 'haatzmaut', label: 'העצמאות' },
      { value: 'yosef-haim', label: 'יוסף חיים' }
    ],
    'kiryat-giora-south': [
      { value: 'adam-yekutiel', label: 'אדם יקותיאל' },
      { value: 'hahatzav', label: 'החצב' },
      { value: 'haatzmaut', label: 'העצמאות' },
      { value: 'hashikma', label: 'השקמה' },
      { value: 'havered', label: 'הורד' }
    ],
    'histadrut-north': [
      { value: 'histadrut', label: 'ההסתדרות' },
      { value: 'haatzmaut', label: 'העצמאות' },
      { value: 'hashita', label: 'השיטה' },
      { value: 'yerushalayim', label: 'ירושלים' },
      { value: 'sderot-habanim', label: 'שד\' הבנים' }
    ],
    'histadrut-south': [
      { value: 'degania', label: 'דגניה' },
      { value: 'katznelson', label: 'כצנלסון' },
      { value: 'yahadut-canada', label: 'יהדות קנדה' },
      { value: 'dikla', label: 'דקלה' },
      { value: 'histadrut', label: 'ההסתדרות' }
    ],
    'industrial-almog-yahalom': [
      { value: 'haharoshet', label: 'החרושת' },
      { value: 'hayozmim', label: 'היוזמים' },
      { value: 'haavoda', label: 'העבודה' },
      { value: 'yahadut-canada', label: 'יהדות קנדה' },
      { value: 'sharet-moshe', label: 'שרת משה' }
    ],
    'city-center': [
      { value: 'shprinzak', label: 'שפרינצק' },
      { value: 'sharet-moshe', label: 'שרת משה' },
      { value: 'asirei-zion', label: 'אסירי ציון' },
      { value: 'saadon-eliyahu', label: 'סעדון אליהו' },
      { value: 'yahadut-canada', label: 'יהדות קנדה' }
    ],
    'amidar': [
      { value: 'hahalutzim', label: 'החלוצים' },
      { value: 'hala', label: 'הל"ה' },
      { value: 'sinai', label: 'סיני' },
      { value: 'olei-hagardom', label: 'עולי הגרדום' },
      { value: 'sderot-ben-porat', label: 'שד\' בן פורת מרדכי' }
    ],
    'pardes-neve-hadarim': [
      { value: 'bar-lev-haim', label: 'בר לב חיים' },
      { value: 'sderot-ben-gurion', label: 'שד\' בן גוריון' },
      { value: 'sderot-begin', label: 'שד\' בגין מנחם' },
      { value: 'dayan-moshe', label: 'דיין משה' },
      { value: 'sderot-alon', label: 'שד\' אלון יגאל' }
    ],
    'neve-savyon': [
      { value: 'bar-lev-haim', label: 'בר לב חיים' },
      { value: 'sderot-ben-gurion', label: 'שד\' בן גוריון' },
      { value: 'sderot-alon', label: 'שד\' אלון יגאל' },
      { value: 'kvish-lod', label: 'כביש לוד' },
      { value: 'haela', label: 'האלה' }
    ],
    'industrial-sapir': [
      { value: 'kazaz-yehezkel', label: 'קזז יחזקאל' },
      { value: 'hayotzrim', label: 'היוצרים' },
      { value: 'hataasia', label: 'התעשיה' },
      { value: 'hamifal', label: 'המפעל' },
      { value: 'hasadna', label: 'הסדנא' }
    ],
    'governmental-housing': [
      { value: 'sderot-ben-porat', label: 'שד\' בן פורת מרדכי' },
      { value: 'kazaz-yehezkel', label: 'קזז יחזקאל' },
      { value: 'herzl', label: 'הרצל' },
      { value: 'hagalil', label: 'הגליל' },
      { value: 'harishonim', label: 'הראשונים' }
    ],
    'ramat-pinkas': [
      { value: 'harama', label: 'הרמ"א' },
      { value: 'landau', label: 'לנדאו' },
      { value: 'agiv-kamus', label: 'עגיב כמוס' },
      { value: 'havered', label: 'הורד' },
      { value: 'hanarkis', label: 'הנרקיס (רמת פנקס)' }
    ]
  },

  'jerusalem': {
  'rehavia': [
    { value: 'ibn-gabirol', label: 'אבן גבירול' },
    { value: 'ibn-ezra', label: 'אבן עזרא' },
    { value: 'ibn-shaprut', label: 'אבן שפרוט' },
    { value: 'abravanel', label: 'אברבנאל' },
    { value: 'ussishkin', label: 'אוסישקין' },
    { value: 'alharizi', label: 'אלחריזי' },
    { value: 'alfasi', label: 'אלפסי' },
    { value: 'efodi', label: 'אפודי' },
    { value: 'arlosoroff', label: 'ארלוזורוב' },
    { value: 'balfour', label: 'בלפור' },
    { value: 'ben-labrat', label: 'בן-לברט' },
    { value: 'ben-maimon', label: 'בן-מימון' },
    { value: 'ben-saruk', label: 'בן-סרוק' },
    { value: 'benjamin-of-tudela', label: 'בנימין מטודלה' },
    { value: 'diskin', label: 'דיסקין' },
    { value: 'haari', label: 'האר"י' },
    { value: 'king-george', label: 'המלך ג׳ורג׳' },
    { value: 'hanasi', label: 'הנשיא' },
    { value: 'haselah', label: 'הסלח' },
    { value: 'hakalir', label: 'הקליר' },
    { value: 'kkl', label: 'הקרן הקיימת' },
    { value: 'haavad', label: 'הראב"ד' },
    { value: 'rabbi-herzog', label: 'הרב הרצוג' },
    { value: 'haran', label: 'הרן' },
    { value: 'hativonim', label: 'התיבונים' },
    { value: 'jabotinsky', label: 'ז׳בוטינסקי' },
    { value: 'haim-hazaz', label: 'חיים הזז' },
    { value: 'hanoch-yalon', label: 'חנוך ילון' },
    { value: 'harlap', label: 'חרל"פ' },
    { value: 'hatam-sofer', label: 'חת"ם סופר' },
    { value: 'itzhak-sharyon', label: 'יצחק שריון' },
    { value: 'tobianski', label: 'מאיר ולנה טוביאנסקי' },
    { value: 'magnes', label: 'מגנס' },
    { value: 'molcho', label: 'מולכו' },
    { value: 'narkis', label: 'נרקיס' },
    { value: 'saadia-gaon', label: 'סעדיה גאון' },
    { value: 'ovadia-mibartenura', label: 'עובדיה מברטנורה' },
    { value: 'gaza', label: 'עזה' },
    { value: 'radak', label: 'רד"ק' },
    { value: 'rotenberg', label: 'רוטנברג' },
    { value: 'rupin', label: 'רופין' },
    { value: 'ramban', label: 'רמב"ן' },
    { value: 'rashba', label: 'רשב"א' },
    { value: 'shmuel-hanagid', label: 'שמואל הנגיד' }
  ],
    'pisgat-zeev': [
    { value: 'pisgat-zeev-001', label: 'א-זהור' },
    { value: 'pisgat-zeev-002', label: 'אברהם דוד ליכטמן' },
    { value: 'pisgat-zeev-003', label: 'אורי בן-ארי' },
    { value: 'pisgat-zeev-004', label: 'אורי בר-און' },
    { value: 'pisgat-zeev-005', label: 'איסר נתנזון' },
    { value: 'pisgat-zeev-006', label: 'איתן לבני' },
    { value: 'pisgat-zeev-007', label: 'אלי תבין' },
    { value: 'pisgat-zeev-008', label: 'אליהו מרידור' },
    { value: 'pisgat-zeev-009', label: 'אמנון ליפקין-שחק' },
    { value: 'pisgat-zeev-010', label: 'אמרי (אמריך) קלמן' },
    { value: 'pisgat-zeev-011', label: 'אלטמן אריה' },
    { value: 'pisgat-zeev-012', label: 'בן-ציון ליאון' },
    { value: 'pisgat-zeev-013', label: 'בנימין שלום' },
    { value: 'pisgat-zeev-014', label: 'בצלאל בצראווי' },
    { value: 'pisgat-zeev-015', label: 'גדוד חרמש' },
    { value: 'pisgat-zeev-016', label: 'גדוד מכמש' },
    { value: 'pisgat-zeev-017', label: 'גיורא יוספטל' },
    { value: 'pisgat-zeev-018', label: 'גל' },
    { value: 'pisgat-zeev-019', label: 'גרמי ציון' },
    { value: 'pisgat-zeev-020', label: 'דב סדן' },
    { value: 'pisgat-zeev-021', label: 'דוד גויטיין' },
    { value: 'pisgat-zeev-022', label: 'דוד ניב ניב' },
    { value: 'pisgat-zeev-023', label: 'דוד פדרמן' },
    { value: 'pisgat-zeev-024', label: 'דן פגיס' },
    { value: 'pisgat-zeev-025', label: 'האלוף יקותיאל אדם' },
    { value: 'pisgat-zeev-026', label: 'האלוף עוזי נרקיס' },
    { value: 'pisgat-zeev-027', label: 'הארבעה' },
    { value: 'pisgat-zeev-028', label: 'הגדוד החמישי' },
    { value: 'pisgat-zeev-029', label: 'המזלות' },
    { value: 'pisgat-zeev-030', label: 'הניידות' },
    { value: 'pisgat-zeev-031', label: 'הסייר' },
    { value: 'pisgat-zeev-032', label: 'הסיירת הירושלמית' },
    { value: 'pisgat-zeev-033', label: 'הרב בנימין צביאלי' },
    { value: 'pisgat-zeev-034', label: 'הרב חיים קהן' },
    { value: 'pisgat-zeev-035', label: 'הרב שלום משאש' },
    { value: 'pisgat-zeev-036', label: 'השיריונאי' },
    { value: 'pisgat-zeev-037', label: 'השישה עשר' },
    { value: 'pisgat-zeev-038', label: 'התותחן' },
    { value: 'pisgat-zeev-039', label: 'ויליאם פרל' },
    { value: 'pisgat-zeev-040', label: 'זאב שרף' },
    { value: 'pisgat-zeev-041', label: 'זילברשטיין' },
    { value: 'pisgat-zeev-042', label: 'זלמן צורף' },
    { value: 'pisgat-zeev-043', label: 'חטיבת גבעתי' },
    { value: 'pisgat-zeev-044', label: 'חיים גבריהו' },
    { value: 'pisgat-zeev-045', label: 'חיים דוד הלוי' },
    { value: 'pisgat-zeev-046', label: 'חיים פזנר' },
    { value: 'pisgat-zeev-047', label: 'חיים תורן' },
    { value: 'pisgat-zeev-048', label: 'חיל האוויר' },
    { value: 'pisgat-zeev-049', label: 'חיל המודיעין' },
    { value: 'pisgat-zeev-050', label: 'חיל הקשר' },
    { value: 'pisgat-zeev-051', label: 'חיל חימוש' },
    { value: 'pisgat-zeev-052', label: 'חנה בבלי' },
    { value: 'pisgat-zeev-053', label: 'יהודה אליצור' },
    { value: 'pisgat-zeev-054', label: 'יואל פרידלר' },
    { value: 'pisgat-zeev-055', label: 'יובל נאמן' },
    { value: 'pisgat-zeev-056', label: 'יוסף נדבה' },
    { value: 'pisgat-zeev-057', label: 'יורי שטרן' },
    { value: 'pisgat-zeev-058', label: 'יעקב יהושע' },
    { value: 'pisgat-zeev-059', label: 'יצחק טוניק' },
    { value: 'pisgat-zeev-060', label: 'ירמיהו ברדנוב' },
    { value: 'pisgat-zeev-061', label: 'כיסא רחמים' },
    { value: 'pisgat-zeev-062', label: 'מאיר גרשון' },
    { value: 'pisgat-zeev-063', label: 'מאיר וייס' },
    { value: 'pisgat-zeev-064', label: 'מאיר יושע יושע' },
    { value: 'pisgat-zeev-065', label: 'מאשה ברוסקינה' },
    { value: 'pisgat-zeev-066', label: 'מזל אריה' },
    { value: 'pisgat-zeev-067', label: 'מזל גדי' },
    { value: 'pisgat-zeev-068', label: 'מזל דלי' },
    { value: 'pisgat-zeev-069', label: 'מזל טלה' },
    { value: 'pisgat-zeev-070', label: 'מזל מאזניים' },
    { value: 'pisgat-zeev-071', label: 'מזל קשת' },
    { value: 'pisgat-zeev-072', label: 'מזל שור' },
    { value: 'pisgat-zeev-073', label: 'מזל תאומים' },
    { value: 'pisgat-zeev-074', label: 'מחנה יצחק' },
    { value: 'pisgat-zeev-075', label: 'מישאל מזרחי' },
    { value: 'pisgat-zeev-076', label: 'מנורי' },
    { value: 'pisgat-zeev-077', label: 'מניה שוחט' },
    { value: 'pisgat-zeev-078', label: 'מרדכי זר' },
    { value: 'pisgat-zeev-079', label: 'משה (מוסא) פלד' },
    { value: 'pisgat-zeev-080', label: 'משה גבירצמן' },
    { value: 'pisgat-zeev-081', label: 'משה דיין' },
    { value: 'pisgat-zeev-082', label: 'משה ונטורה' },
    { value: 'pisgat-zeev-083', label: 'משה קראוס' },
    { value: 'pisgat-zeev-084', label: 'משה רחמילביץ' },
    { value: 'pisgat-zeev-085', label: 'משה שמיר' },
    { value: 'pisgat-zeev-086', label: 'משטרת היישובים' },
    { value: 'pisgat-zeev-087', label: 'נווה יעקב' },
    { value: 'pisgat-zeev-088', label: 'נופי מדבר' },
    { value: 'pisgat-zeev-089', label: 'נחום אהרנפלד' },
    { value: 'pisgat-zeev-090', label: 'סגולת ישראל' },
    { value: 'pisgat-zeev-091', label: 'סיירת גולני' },
    { value: 'pisgat-zeev-092', label: 'סיירת דוכיפת' },
    { value: 'pisgat-zeev-093', label: 'עמיחי פאגלין' },
    { value: 'pisgat-zeev-094', label: 'פאול גריניגר' },
    { value: 'pisgat-zeev-095', label: 'פלוגת הטנקים' },
    { value: 'pisgat-zeev-096', label: 'פרופ\' יום-טוב עסיס' },
    { value: 'pisgat-zeev-097', label: 'צבי לבנון' },
    { value: 'pisgat-zeev-098', label: 'קריית עמואל מורנו' },
    { value: 'pisgat-zeev-099', label: 'רא"ל משה לוי' },
    { value: 'pisgat-zeev-100', label: 'ראובן ארזי' },
    { value: 'pisgat-zeev-101', label: 'רב אלוף לסקוב' },
    { value: 'pisgat-zeev-102', label: 'רינה ניקובה' },
    { value: 'pisgat-zeev-103', label: 'רפול הררי' },
    { value: 'pisgat-zeev-104', label: 'שאול ליברמן' },
    { value: 'pisgat-zeev-105', label: 'שלום וצדק' },
    { value: 'pisgat-zeev-106', label: 'שלום שוורצבארד' },
    { value: 'pisgat-zeev-107', label: 'שלמה' },
    { value: 'pisgat-zeev-108', label: 'שלמה ומשה תג\'ר' },
    { value: 'pisgat-zeev-109', label: 'ברנדויין שמואל' },
    { value: 'pisgat-zeev-110', label: 'שמואל יפה' },
    { value: 'pisgat-zeev-111', label: 'שמואל עדן' },
    { value: 'pisgat-zeev-112', label: 'שמואל תמיר' },
    { value: 'pisgat-zeev-113', label: 'שמחה הולצברג' },
    { value: 'pisgat-zeev-114', label: 'ללא רחוב_פז' }
  ],
    'french-hill': [
    { value: 'french-hill-001', label: 'אבא ברדיצ\'ב' },
    { value: 'french-hill-002', label: 'אהרון קציר' },
    { value: 'french-hill-003', label: 'אצ"ל' },
    { value: 'french-hill-004', label: 'בר-כוכבא' },
    { value: 'french-hill-005', label: 'בר-לב' },
    { value: 'french-hill-006', label: 'ג\'ורג\' אדם סמית' },
    { value: 'french-hill-007', label: 'גולי קניה' },
    { value: 'french-hill-008', label: 'דקר' },
    { value: 'french-hill-009', label: 'האוניברסיטה' },
    { value: 'french-hill-010', label: 'האלוף עוזי נרקיס' },
    { value: 'french-hill-011', label: 'ההגנה' },
    { value: 'french-hill-012', label: 'ההתנדבויות' },
    { value: 'french-hill-013', label: 'החי"ל' },
    { value: 'french-hill-014', label: 'המאבק' },
    { value: 'french-hill-015', label: 'הנחל' },
    { value: 'french-hill-016', label: 'העשרה' },
    { value: 'french-hill-017', label: 'הפרטיזנים' },
    { value: 'french-hill-018', label: 'הר הצופים אידלסון' },
    { value: 'french-hill-019', label: 'הררי' },
    { value: 'french-hill-020', label: 'חיים יסקי' },
    { value: 'french-hill-021', label: 'יגאל ידין' },
    { value: 'french-hill-022', label: 'לוחמי הגטאות' },
    { value: 'french-hill-023', label: 'לח"י' },
    { value: 'french-hill-024', label: 'מעונות ברונפמן' },
    { value: 'french-hill-025', label: 'משה דיין' },
    { value: 'french-hill-026', label: 'נהגי הפרדות' },
    { value: 'french-hill-027', label: 'ענתות' },
    { value: 'french-hill-028', label: 'פל-ים' },
    { value: 'french-hill-029', label: 'שועפאט' },
    { value: 'french-hill-030', label: 'שלום הגליל' }
  ],
    'german-colony': [
    { value: 'german-colony-001', label: 'אליאשברג' },
    { value: 'german-colony-002', label: 'אמיל זולא' },
    { value: 'german-colony-003', label: 'בית לחם' },
    { value: 'german-colony-004', label: 'גדליהו אלון' },
    { value: 'german-colony-005', label: 'גנרל פייר קניג' },
    { value: 'german-colony-006', label: 'דור ודורשיו' },
    { value: 'german-colony-007', label: 'דידס וינדהם' },
    { value: 'german-colony-008', label: 'המגיד' },
    { value: 'german-colony-009', label: 'המליץ' },
    { value: 'german-colony-010', label: 'הצפירה' },
    { value: 'german-colony-011', label: 'הרב שמואל מוהליבר' },
    { value: 'german-colony-012', label: 'הרכבת' },
    { value: 'german-colony-013', label: 'וודגווד' },
    { value: 'german-colony-014', label: 'זאב באכר' },
    { value: 'german-colony-015', label: 'חנניה' },
    { value: 'german-colony-016', label: 'יעקב שסקין' },
    { value: 'german-colony-017', label: 'יצחק כרמיה' },
    { value: 'german-colony-018', label: 'לויד ג\'ורג\'' },
    { value: 'german-colony-019', label: 'מאוריציו גוטליב' },
    { value: 'german-colony-020', label: 'מאיר ומיכאל סגן כהן' },
    { value: 'german-colony-021', label: 'מל"ל' },
    { value: 'german-colony-022', label: 'מסריק' },
    { value: 'german-colony-023', label: 'מרטין לותר קינג' },
    { value: 'german-colony-024', label: 'משה גסטר' },
    { value: 'german-colony-025', label: 'סמאטס' },
    { value: 'german-colony-026', label: 'עזריאל הילדסהיימר' },
    { value: 'german-colony-027', label: 'עזריה' },
    { value: 'german-colony-028', label: 'עמנואל נוח' },
    { value: 'german-colony-029', label: 'עמק רפאים' },
    { value: 'german-colony-030', label: 'פטרסון' },
    { value: 'german-colony-031', label: 'צבי גרץ' },
    { value: 'german-colony-032', label: 'קליין' },
    { value: 'german-colony-033', label: 'רוזאניס' },
    { value: 'german-colony-034', label: 'רות' },
    { value: 'german-colony-035', label: 'רחל אימנו' }
  ],
     'musrara': [
    { value: 'musrara-001', label: 'אלישע' },
    { value: 'musrara-002', label: 'דניאל' },
    { value: 'musrara-003', label: 'החומה השלישית' },
    { value: 'musrara-004', label: 'הלני המלכה' },
    { value: 'musrara-005', label: 'הנביאים' },
    { value: 'musrara-006', label: 'הע"ח' },
    { value: 'musrara-007', label: 'הפנתרים השחורים' },
    { value: 'musrara-008', label: 'הצנחנים' },
    { value: 'musrara-009', label: 'הרב יחיא שניאור' },
    { value: 'musrara-010', label: 'חולדה הנביאה' },
    { value: 'musrara-011', label: 'חיל הנדסה' },
    { value: 'musrara-012', label: 'יחיא אדהאן' },
    { value: 'musrara-013', label: 'כץ מיכל' },
    { value: 'musrara-014', label: 'משמרות' },
    { value: 'musrara-015', label: 'נעמי קיס' },
    { value: 'musrara-016', label: 'נתן הנביא' },
    { value: 'musrara-017', label: 'עידו הנביא' },
    { value: 'musrara-018', label: 'שבטי ישראל' },
    { value: 'musrara-019', label: 'רחוב לא ידוע' }
  ],
    'city-center': [
    { value: 'city-center-001', label: 'אבידע' },
    { value: 'city-center-002', label: 'אבן ישראל' },
    { value: 'city-center-003', label: 'אברהם ביצ\'אצ\'ו' },
    { value: 'city-center-004', label: 'אגרון' },
    { value: 'city-center-005', label: 'אגריפס' },
    { value: 'city-center-006', label: 'אהרון מזיא' },
    { value: 'city-center-007', label: 'אוסישקין' },
    { value: 'city-center-008', label: 'אליעזר ריבלין' },
    { value: 'city-center-009', label: 'אלישר' },
    { value: 'city-center-010', label: 'אריסטובולוס' },
    { value: 'city-center-011', label: 'בארי' },
    { value: 'city-center-012', label: 'ביאנקיני' },
    { value: 'city-center-013', label: 'בייניס סלנט' },
    { value: 'city-center-014', label: 'בית הכנסת' },
    { value: 'city-center-015', label: 'בן-ברוך' },
    { value: 'city-center-016', label: 'בן-הלל' },
    { value: 'city-center-017', label: 'בן-יהודה' },
    { value: 'city-center-018', label: 'בן-סירא' },
    { value: 'city-center-019', label: 'בצלאל' },
    { value: 'city-center-020', label: 'גרוזנברג' },
    { value: 'city-center-021', label: 'דוד המלך' },
    { value: 'city-center-022', label: 'דונואס' },
    { value: 'city-center-023', label: 'דורות ראשונים' },
    { value: 'city-center-024', label: 'דרום' },
    { value: 'city-center-025', label: 'הגבורה' },
    { value: 'city-center-026', label: 'ההסתדרות' },
    { value: 'city-center-027', label: 'החבצלת' },
    { value: 'city-center-028', label: 'הלל' },
    { value: 'city-center-029', label: 'הלני המלכה' },
    { value: 'city-center-030', label: 'המלך ג\'ורג\'' },
    { value: 'city-center-031', label: 'המעלות' },
    { value: 'city-center-032', label: 'המתמיד' },
    { value: 'city-center-033', label: 'הנביאים' },
    { value: 'city-center-034', label: 'הסורג' },
    { value: 'city-center-035', label: 'הרב אגן' },
    { value: 'city-center-036', label: 'הרב חיים אלבוחר' },
    { value: 'city-center-037', label: 'הרב קוק' },
    { value: 'city-center-038', label: 'זמורה' },
    { value: 'city-center-039', label: 'חשין' },
    { value: 'city-center-040', label: 'טיכו' },
    { value: 'city-center-041', label: 'טרומפלדור' },
    { value: 'city-center-042', label: 'יהודה שפירא' },
    { value: 'city-center-043', label: 'יהושע ילין' },
    { value: 'city-center-044', label: 'יואל משה סלומון' },
    { value: 'city-center-045', label: 'יוחנן הורקנוס' },
    { value: 'city-center-046', label: 'יוחנן מגוש חלב' },
    { value: 'city-center-047', label: 'יוסף ויטלזון' },
    { value: 'city-center-048', label: 'יוסף ריבלין' },
    { value: 'city-center-049', label: 'ינאי' },
    { value: 'city-center-050', label: 'יעבץ' },
    { value: 'city-center-051', label: 'יפו' },
    { value: 'city-center-052', label: 'כורש' },
    { value: 'city-center-053', label: 'מאיר שחם' },
    { value: 'city-center-054', label: 'מונבז' },
    { value: 'city-center-055', label: 'מנורה' },
    { value: 'city-center-056', label: 'מנשה בן-ישראל' },
    { value: 'city-center-057', label: 'מסילת ישרים' },
    { value: 'city-center-058', label: 'משה לונץ' },
    { value: 'city-center-059', label: 'משיח בורוכוף' },
    { value: 'city-center-060', label: 'נחלת שבעה' },
    { value: 'city-center-061', label: 'נרקיס' },
    { value: 'city-center-062', label: 'סמואל' },
    { value: 'city-center-063', label: 'ספרא' },
    { value: 'city-center-064', label: 'עוזי חסון' },
    { value: 'city-center-065', label: 'עזרת ישראל' },
    { value: 'city-center-066', label: 'עליאש' },
    { value: 'city-center-067', label: 'פרומקין' },
    { value: 'city-center-068', label: 'ציפי מלכוב' },
    { value: 'city-center-069', label: 'קריב יצחק' },
    { value: 'city-center-070', label: 'קרן היסוד' },
    { value: 'city-center-071', label: 'ראול ולנברג' },
    { value: 'city-center-072', label: 'רבי עקיבא' },
    { value: 'city-center-073', label: 'רבן זאב' },
    { value: 'city-center-074', label: 'רבקה סטוינובסקי' },
    { value: 'city-center-075', label: 'שבתאי פטרושקה' },
    { value: 'city-center-076', label: 'שושן' },
    { value: 'city-center-077', label: 'שטראוס' },
    { value: 'city-center-078', label: 'שלומציון' },
    { value: 'city-center-079', label: 'שלמה המלך' },
    { value: 'city-center-080', label: 'שמאי' },
    { value: 'city-center-081', label: 'שמואל הנגיד' },
    { value: 'city-center-082', label: 'שמעון בן-שטח' },
    { value: 'city-center-083', label: 'שץ' },
    { value: 'city-center-084', label: 'רחוב לא ידוע' }
  ],
     'nachlaot': [
    { value: 'nahlaot-001', label: 'אבן ספיר' },
    { value: 'nahlaot-002', label: 'אבן שפרוט' },
    { value: 'nahlaot-003', label: 'אוסישקין' },
    { value: 'nahlaot-004', label: 'אושה' },
    { value: 'nahlaot-005', label: 'בצלאל' },
    { value: 'nahlaot-006', label: 'דיסקין' },
    { value: 'nahlaot-007', label: 'הגאונים' },
    { value: 'nahlaot-008', label: 'הגליל' },
    { value: 'nahlaot-009', label: 'הגר"א' },
    { value: 'nahlaot-010', label: 'הירשנברג' },
    { value: 'nahlaot-011', label: 'המדרגות' },
    { value: 'nahlaot-012', label: 'הקליר' },
    { value: 'nahlaot-013', label: 'הקרן הקיימת' },
    { value: 'nahlaot-014', label: 'הרב דוד פוברסקי' },
    { value: 'nahlaot-015', label: 'הרב והרבנית קאפח' },
    { value: 'nahlaot-016', label: 'הרב חיים עראקי' },
    { value: 'nahlaot-017', label: 'השל"ה' },
    { value: 'nahlaot-018', label: 'חצור' },
    { value: 'nahlaot-019', label: 'טבריה' },
    { value: 'nahlaot-020', label: 'יזהר' },
    { value: 'nahlaot-021', label: 'יצחק בן-צבי' },
    { value: 'nahlaot-022', label: 'יראון' },
    { value: 'nahlaot-023', label: 'ישעיה בר-זכאי' },
    { value: 'nahlaot-024', label: 'ישראלס' },
    { value: 'nahlaot-025', label: 'כהנוב' },
    { value: 'nahlaot-026', label: 'כורזים' },
    { value: 'nahlaot-027', label: 'כפר ברעם' },
    { value: 'nahlaot-028', label: 'מרדכי אנטוקולסקי' },
    { value: 'nahlaot-029', label: 'משה ששון' },
    { value: 'nahlaot-030', label: 'נחלת צדוק' },
    { value: 'nahlaot-031', label: 'נרבתה' },
    { value: 'nahlaot-032', label: 'נרקיס' },
    { value: 'nahlaot-033', label: 'עלמא' },
    { value: 'nahlaot-034', label: 'ענתבי' },
    { value: 'nahlaot-035', label: 'פרוש' },
    { value: 'nahlaot-036', label: 'ציפורי' },
    { value: 'nahlaot-037', label: 'צפת' },
    { value: 'nahlaot-038', label: 'רפאלי' },
    { value: 'nahlaot-039', label: 'שבזי' },
    { value: 'nahlaot-040', label: 'שערי חסד' },
    { value: 'nahlaot-041', label: 'שפרעם' },
    { value: 'nahlaot-042', label: 'רחוב לא ידוע' }
  ],
  'talbiya': [
    { value: 'talbiya-001', label: 'אגרון' },
    { value: 'talbiya-002', label: 'אוליפנט' },
    { value: 'talbiya-003', label: 'אחד העם' },
    { value: 'talbiya-004', label: 'אליוט' },
    { value: 'talbiya-005', label: 'אלקלעי' },
    { value: 'talbiya-006', label: 'בית לחם' },
    { value: 'talbiya-007', label: 'בלפור' },
    { value: 'talbiya-008', label: 'ברנר' },
    { value: 'talbiya-009', label: 'גדליהו אלון' },
    { value: 'talbiya-010', label: 'ד"ר מלכה שפיגל' },
    { value: 'talbiya-011', label: 'דובנוב' },
    { value: 'talbiya-012', label: 'דוד בן-שמעון' },
    { value: 'talbiya-013', label: 'דוד המלך' },
    { value: 'talbiya-014', label: 'דוד רמז' },
    { value: 'talbiya-015', label: 'דיזרעאלי' },
    { value: 'talbiya-016', label: 'הלב העברי' },
    { value: 'talbiya-017', label: 'המערבים' },
    { value: 'talbiya-018', label: 'הנשיא' },
    { value: 'talbiya-019', label: 'וושינגטון' },
    { value: 'talbiya-020', label: 'ז\'בוטינסקי' },
    { value: 'talbiya-021', label: 'זמנהוף' },
    { value: 'talbiya-022', label: 'חובבי ציון' },
    { value: 'talbiya-023', label: 'יצחק אלחנן' },
    { value: 'talbiya-024', label: 'לינקולן' },
    { value: 'talbiya-025', label: 'מאפו' },
    { value: 'talbiya-026', label: 'מנדלי מוכר ספרים' },
    { value: 'talbiya-027', label: 'מנה' },
    { value: 'talbiya-028', label: 'מרטין לותר קינג' },
    { value: 'talbiya-029', label: 'מרכוס' },
    { value: 'talbiya-030', label: 'משה הס' },
    { value: 'talbiya-031', label: 'סוקולוב' },
    { value: 'talbiya-032', label: 'סמולנסקין' },
    { value: 'talbiya-033', label: 'עזה' },
    { value: 'talbiya-034', label: 'עמק רפאים' },
    { value: 'talbiya-035', label: 'פינסקר' },
    { value: 'talbiya-036', label: 'צבי גרץ' },
    { value: 'talbiya-037', label: 'קריב יצחק' },
    { value: 'talbiya-038', label: 'קרן היסוד' },
    { value: 'talbiya-039', label: 'רד"ק' },
    { value: 'talbiya-040', label: 'שלום עליכם' },
    { value: 'talbiya-041', label: 'רחוב לא ידוע' }
  ],
    'kiryat-haleom': [
    { value: 'kiryat_haleom-001', label: 'אבא אבן' },
    { value: 'kiryat_haleom-002', label: 'אלוף שאלתיאל' },
    { value: 'kiryat_haleom-003', label: 'בגין' },
    { value: 'kiryat_haleom-004', label: 'בנק ישראל' },
    { value: 'kiryat_haleom-005', label: 'גרנות' },
    { value: 'kiryat_haleom-006', label: 'ד"ר יואל זוסמן' },
    { value: 'kiryat_haleom-007', label: 'ד"ר יוסף בורג' },
    { value: 'kiryat_haleom-008', label: 'דוד וולפסון' },
    { value: 'kiryat_haleom-009', label: 'האומה' },
    { value: 'kiryat_haleom-010', label: 'היכל המשפט' },
    { value: 'kiryat_haleom-011', label: 'הנשיא השישי' },
    { value: 'kiryat_haleom-012', label: 'העלייה' },
    { value: 'kiryat_haleom-013', label: 'הרב אברהם שפירא' },
    { value: 'kiryat_haleom-014', label: 'הרצל' },
    { value: 'kiryat_haleom-015', label: 'השופט מאיר שמגר' },
    { value: 'kiryat_haleom-016', label: 'ויצמן' },
    { value: 'kiryat_haleom-017', label: 'זאב וילנאי' },
    { value: 'kiryat_haleom-018', label: 'זבולון המר' },
    { value: 'kiryat_haleom-019', label: 'חיים הזז' },
    { value: 'kiryat_haleom-020', label: 'יהודה בורלא' },
    { value: 'kiryat_haleom-021', label: 'יוסף הרליץ' },
    { value: 'kiryat_haleom-022', label: 'יצחק בן-צבי' },
    { value: 'kiryat_haleom-023', label: 'ליליאן' },
    { value: 'kiryat_haleom-024', label: 'מבקר המדינה' },
    { value: 'kiryat_haleom-025', label: 'נחמן אביגד' },
    { value: 'kiryat_haleom-026', label: 'נתנאל לורך' },
    { value: 'kiryat_haleom-027', label: 'קפלן' },
    { value: 'kiryat_haleom-028', label: 'רבין' },
    { value: 'kiryat_haleom-029', label: 'רוטשילד' },
    { value: 'kiryat_haleom-030', label: 'רופין' },
    { value: 'kiryat_haleom-031', label: 'שותא רוסתאבלי' },
    { value: 'kiryat_haleom-032', label: 'שז"ר' },
    { value: 'kiryat_haleom-033', label: 'שמואל וייז' },
    { value: 'kiryat_haleom-034', label: 'רחוב לא ידוע' }
  ],
    'beit-vegan': [
    { value: 'beit-vegan-001', label: 'אברהם אבא אורי' },
    { value: 'beit-vegan-002', label: 'אברהם אגמון' },
    { value: 'beit-vegan-003', label: 'אליהו לופס' },
    { value: 'beit-vegan-004', label: 'אליהו פרנקל' },
    { value: 'beit-vegan-005', label: 'אליעזר ברגמן' },
    { value: 'beit-vegan-006', label: 'אלפייה' },
    { value: 'beit-vegan-007', label: 'באר מים חיים' },
    { value: 'beit-vegan-008', label: 'בגין' },
    { value: 'beit-vegan-009', label: 'בית וגן' },
    { value: 'beit-vegan-010', label: 'ברוך דובדבני' },
    { value: 'beit-vegan-011', label: 'דברי ירוחם' },
    { value: 'beit-vegan-012', label: 'הוועד הלאומי' },
    { value: 'beit-vegan-013', label: 'החיד"א' },
    { value: 'beit-vegan-014', label: 'המלבים' },
    { value: 'beit-vegan-015', label: 'הפסגה' },
    { value: 'beit-vegan-016', label: 'הרב אבוהב' },
    { value: 'beit-vegan-017', label: 'הרב אליעזרי' },
    { value: 'beit-vegan-018', label: 'הרב סלמן מוצפי' },
    { value: 'beit-vegan-019', label: 'הרב עוזיאל' },
    { value: 'beit-vegan-020', label: 'הרב פרנק' },
    { value: 'beit-vegan-021', label: 'הרב שאג' },
    { value: 'beit-vegan-022', label: 'הרצל' },
    { value: 'beit-vegan-023', label: 'הרשד"ם' },
    { value: 'beit-vegan-024', label: 'השלווה' },
    { value: 'beit-vegan-025', label: 'זאב חקלאי' },
    { value: 'beit-vegan-026', label: 'חיים וייסברג' },
    { value: 'beit-vegan-027', label: 'חכמי יוסף' },
    { value: 'beit-vegan-028', label: 'יעקב רוזנהים' },
    { value: 'beit-vegan-029', label: 'יצחק בן-נחום' },
    { value: 'beit-vegan-030', label: 'יצחק ברויאר' },
    { value: 'beit-vegan-031', label: 'ליאו ויסמן' },
    { value: 'beit-vegan-032', label: 'מיכלין' },
    { value: 'beit-vegan-033', label: 'מינצברג' },
    { value: 'beit-vegan-034', label: 'מרום ציון' },
    { value: 'beit-vegan-035', label: 'משה זילברג' },
    { value: 'beit-vegan-036', label: 'משולם ראט' },
    { value: 'beit-vegan-037', label: 'נזר דוד' },
    { value: 'beit-vegan-038', label: 'צבי לצדיק' },
    { value: 'beit-vegan-039', label: 'קאסוטו' },
    { value: 'beit-vegan-040', label: 'קריית היובל' },
    { value: 'beit-vegan-041', label: 'שחראי' },
    { value: 'beit-vegan-042', label: 'שלמה פרנקל' },
    { value: 'beit-vegan-043', label: 'שמואל בייט בייט' },
    { value: 'beit-vegan-044', label: 'שמשון רפאל הירש' },
    { value: 'beit-vegan-045', label: 'שערי תורה' },
    { value: 'beit-vegan-046', label: 'תורה ועבודה' },
    { value: 'beit-vegan-047', label: 'תורת חיים' },
    { value: 'beit-vegan-048', label: 'רחוב לא ידוע' }
  ],
  'kiryat-yovel': [
    { value: 'kiryay_yovel-001', label: 'אבל פן' },
    { value: 'kiryay_yovel-002', label: 'אברהם שטרן' },
    { value: 'kiryay_yovel-003', label: 'אהרון רבינוביץ' },
    { value: 'kiryay_yovel-004', label: 'אולשוונגר' },
    { value: 'kiryay_yovel-005', label: 'אורוגוואי' },
    { value: 'kiryay_yovel-006', label: 'אטינגר' },
    { value: 'kiryay_yovel-007', label: 'אנילביץ' },
    { value: 'kiryay_yovel-008', label: 'אריה קלנר' },
    { value: 'kiryay_yovel-009', label: 'בודנהיימר' },
    { value: 'kiryay_yovel-010', label: 'בוליביה' },
    { value: 'kiryay_yovel-011', label: 'בורוכוב' },
    { value: 'kiryay_yovel-012', label: 'בלומנפלד' },
    { value: 'kiryay_yovel-013', label: 'ברוך מרקו' },
    { value: 'kiryay_yovel-014', label: 'ברזיל' },
    { value: 'kiryay_yovel-015', label: 'גואטמאלה' },
    { value: 'kiryay_yovel-016', label: 'גולומב' },
    { value: 'kiryay_yovel-017', label: 'גורדון' },
    { value: 'kiryay_yovel-018', label: 'גרוסמן' },
    { value: 'kiryay_yovel-019', label: 'גרינוולד' },
    { value: 'kiryay_yovel-020', label: 'הזיכרון' },
    { value: 'kiryay_yovel-021', label: 'הנטקה' },
    { value: 'kiryay_yovel-022', label: 'הנרייטה סאלד' },
    { value: 'kiryay_yovel-023', label: 'הפסגה' },
    { value: 'kiryay_yovel-024', label: 'הצוקים' },
    { value: 'kiryay_yovel-025', label: 'הציונות' },
    { value: 'kiryay_yovel-026', label: 'הרב מרדכי פירון' },
    { value: 'kiryay_yovel-027', label: 'הרצל' },
    { value: 'kiryay_yovel-028', label: 'השועל' },
    { value: 'kiryay_yovel-029', label: 'וולטה העילית' },
    { value: 'kiryay_yovel-030', label: 'ורבורג' },
    { value: 'kiryay_yovel-031', label: 'חיים חביב' },
    { value: 'kiryay_yovel-032', label: 'חנה סנש' },
    { value: 'kiryay_yovel-033', label: 'טהון' },
    { value: 'kiryay_yovel-034', label: 'טור סיני' },
    { value: 'kiryay_yovel-035', label: 'יונה קרמינצקי' },
    { value: 'kiryay_yovel-036', label: 'יעקב גאוני' },
    { value: 'kiryay_yovel-037', label: 'יעקב נחום אפשטיין' },
    { value: 'kiryay_yovel-038', label: 'יצחק יעקב לויכטר' },
    { value: 'kiryay_yovel-039', label: 'יצחק ניידיץ' },
    { value: 'kiryay_yovel-040', label: 'ישראל זנגוויל' },
    { value: 'kiryay_yovel-041', label: 'כרמית' },
    { value: 'kiryay_yovel-042', label: 'מאיר אבנר' },
    { value: 'kiryay_yovel-043', label: 'מוצקין אריה' },
    { value: 'kiryay_yovel-044', label: 'מרדכי סופר' },
    { value: 'kiryay_yovel-045', label: 'משואה' },
    { value: 'kiryay_yovel-046', label: 'ניסן אברהם' },
    { value: 'kiryay_yovel-047', label: 'סירני' },
    { value: 'kiryay_yovel-048', label: 'עין כרם' },
    { value: 'kiryay_yovel-049', label: 'עקיבא כוסבינה' },
    { value: 'kiryay_yovel-050', label: 'פלורנטין' },
    { value: 'kiryay_yovel-051', label: 'פסח חברוני' },
    { value: 'kiryay_yovel-052', label: 'צ\'ילה' },
    { value: 'kiryay_yovel-053', label: 'צ\'לנוב' },
    { value: 'kiryay_yovel-054', label: 'צבי שפירא' },
    { value: 'kiryay_yovel-055', label: 'קדיש לוז' },
    { value: 'kiryay_yovel-056', label: 'קורצ\'אק' },
    { value: 'kiryay_yovel-057', label: 'קליינמן' },
    { value: 'kiryay_yovel-058', label: 'קריית היובל' },
    { value: 'kiryay_yovel-059', label: 'רובינשטיין' },
    { value: 'kiryay_yovel-060', label: 'רינגלבלום' },
    { value: 'kiryay_yovel-061', label: 'שמורק' },
    { value: 'kiryay_yovel-062', label: 'שמריהו לוין' },
    { value: 'kiryay_yovel-063', label: 'שרון' },
    { value: 'kiryay_yovel-064', label: 'תורה ועבודה' },
    { value: 'kiryay_yovel-065', label: 'רחוב לא ידוע' }
  ],
  'katamonim': [
    { value: 'katamonim-001', label: 'אבא חלקיה' },
    { value: 'katamonim-002', label: 'אברהם אלמליח' },
    { value: 'katamonim-003', label: 'אל-ולאג\'ה' },
    { value: 'katamonim-004', label: 'אליעזר הגדול' },
    { value: 'katamonim-005', label: 'אלכסנדרון' },
    { value: 'katamonim-006', label: 'אלעזר בן-יאיר' },
    { value: 'katamonim-007', label: 'אנטיגונוס' },
    { value: 'katamonim-008', label: 'בגין' },
    { value: 'katamonim-009', label: 'בן-בבא' },
    { value: 'katamonim-010', label: 'בן-דוסא' },
    { value: 'katamonim-011', label: 'בן-טבאי' },
    { value: 'katamonim-012', label: 'בני בתירא' },
    { value: 'katamonim-013', label: 'בר-יוחאי' },
    { value: 'katamonim-014', label: 'ברגר' },
    { value: 'katamonim-015', label: 'בריניקי' },
    { value: 'katamonim-016', label: 'גולומב' },
    { value: 'katamonim-017', label: 'גנרל פייר קניג' },
    { value: 'katamonim-018', label: 'דב הוז' },
    { value: 'katamonim-019', label: 'דב יוסף' },
    { value: 'katamonim-020', label: 'האמוראים' },
    { value: 'katamonim-021', label: 'הורקניה' },
    { value: 'katamonim-022', label: 'הנוטרים' },
    { value: 'katamonim-023', label: 'הרב הרצוג' },
    { value: 'katamonim-024', label: 'השומר' },
    { value: 'katamonim-025', label: 'זאב' },
    { value: 'katamonim-026', label: 'חננאל' },
    { value: 'katamonim-027', label: 'חסדא' },
    { value: 'katamonim-028', label: 'טוביה בן-חפץ' },
    { value: 'katamonim-029', label: 'טובייה' },
    { value: 'katamonim-030', label: 'יהודה הנשיא' },
    { value: 'katamonim-031', label: 'יהושע בן-גמלא' },
    { value: 'katamonim-032', label: 'יוחנן בן-זכאי' },
    { value: 'katamonim-033', label: 'יוסי בן-יועזר' },
    { value: 'katamonim-034', label: 'יעקב פת' },
    { value: 'katamonim-035', label: 'יצחק שדה' },
    { value: 'katamonim-036', label: 'מיכוור' },
    { value: 'katamonim-037', label: 'מעגלי יבנה' },
    { value: 'katamonim-038', label: 'מרגולין' },
    { value: 'katamonim-039', label: 'משה ברעם' },
    { value: 'katamonim-040', label: 'נהוראי' },
    { value: 'katamonim-041', label: 'ניקנור' },
    { value: 'katamonim-042', label: 'נתאי הארבלי' },
    { value: 'katamonim-043', label: 'סן מרטין' },
    { value: 'katamonim-044', label: 'קנאי הגליל' },
    { value: 'katamonim-045', label: 'רב אשי' },
    { value: 'katamonim-046', label: 'רבי חנינא' },
    { value: 'katamonim-047', label: 'רבי טרפון' },
    { value: 'katamonim-048', label: 'רבי מאיר' },
    { value: 'katamonim-049', label: 'רבי צדוק' },
    { value: 'katamonim-050', label: 'רבי תנחומא' },
    { value: 'katamonim-051', label: 'רשב"ג' },
    { value: 'katamonim-052', label: 'רחוב לא ידוע' }
  ],
  'arnona': [
    { value: 'arnona-001', label: 'אשר וינר' },
    { value: 'arnona-002', label: 'בית הערבה' },
    { value: 'arnona-003', label: 'השופט חיים כהן' },
    { value: 'arnona-004', label: 'ושיץ' },
    { value: 'arnona-005', label: 'זיגפריד מוזס' },
    { value: 'arnona-006', label: 'חברון' },
    { value: 'arnona-007', label: 'כפר עציון' },
    { value: 'arnona-008', label: 'לוריא' },
    { value: 'arnona-009', label: 'לייב יפה' },
    { value: 'arnona-010', label: 'משואות יצחק' },
    { value: 'arnona-011', label: 'עין צורים' },
    { value: 'arnona-012', label: 'פרופ\' צבי נוימן' },
    { value: 'arnona-013', label: 'קורא הדורות' },
    { value: 'arnona-014', label: 'רבדים' },
    { value: 'arnona-015', label: 'רבנו פוליטי' },
    { value: 'arnona-016', label: 'רחוב לא ידוע' }
  ],
  'geolim-bakaa': [
    { value: 'geolim_bakaa-001', label: 'אבטליון' },
    { value: 'geolim_bakaa-002', label: 'אהוד' },
    { value: 'geolim_bakaa-003', label: 'אסתר המלכה' },
    { value: 'geolim_bakaa-004', label: 'אפרים' },
    { value: 'geolim_bakaa-005', label: 'אשר' },
    { value: 'geolim_bakaa-006', label: 'בועז' },
    { value: 'geolim_bakaa-007', label: 'בית לחם' },
    { value: 'geolim_bakaa-008', label: 'בן-יפונה' },
    { value: 'geolim_bakaa-009', label: 'בן-עזאי' },
    { value: 'geolim_bakaa-010', label: 'בנימין' },
    { value: 'geolim_bakaa-011', label: 'ברק' },
    { value: 'geolim_bakaa-012', label: 'גד' },
    { value: 'geolim_bakaa-013', label: 'גדליה' },
    { value: 'geolim_bakaa-014', label: 'גדעון' },
    { value: 'geolim_bakaa-015', label: 'גנרל פייר קניג' },
    { value: 'geolim_bakaa-016', label: 'דוד רמז' },
    { value: 'geolim_bakaa-017', label: 'דינה' },
    { value: 'geolim_bakaa-018', label: 'דן' },
    { value: 'geolim_bakaa-019', label: 'הרכבת' },
    { value: 'geolim_bakaa-020', label: 'זבולון' },
    { value: 'geolim_bakaa-021', label: 'זרובבל' },
    { value: 'geolim_bakaa-022', label: 'חברון' },
    { value: 'geolim_bakaa-023', label: 'חלץ' },
    { value: 'geolim_bakaa-024', label: 'חנוך אלבק' },
    { value: 'geolim_bakaa-025', label: 'יאיר' },
    { value: 'geolim_bakaa-026', label: 'יהודה' },
    { value: 'geolim_bakaa-027', label: 'יוכבד' },
    { value: 'geolim_bakaa-028', label: 'יחזקאל מרטון' },
    { value: 'geolim_bakaa-029', label: 'יעל' },
    { value: 'geolim_bakaa-030', label: 'יפתח' },
    { value: 'geolim_bakaa-031', label: 'יששכר' },
    { value: 'geolim_bakaa-032', label: 'לוי' },
    { value: 'geolim_bakaa-033', label: 'מנשה' },
    { value: 'geolim_bakaa-034', label: 'מרדכי היהודי' },
    { value: 'geolim_bakaa-035', label: 'מרים החשמונאית' },
    { value: 'geolim_bakaa-036', label: 'מרתה במברגר' },
    { value: 'geolim_bakaa-037', label: 'מתתיהו' },
    { value: 'geolim_bakaa-038', label: 'נחום ליפשיץ' },
    { value: 'geolim_bakaa-039', label: 'נעמי' },
    { value: 'geolim_bakaa-040', label: 'נפתלי' },
    { value: 'geolim_bakaa-041', label: 'עתניאל' },
    { value: 'geolim_bakaa-042', label: 'פרץ' },
    { value: 'geolim_bakaa-043', label: 'צדקיהו' },
    { value: 'geolim_bakaa-044', label: 'ציפורה' },
    { value: 'geolim_bakaa-045', label: 'קיבוץ גלויות' },
    { value: 'geolim_bakaa-046', label: 'ראובן' },
    { value: 'geolim_bakaa-047', label: 'רבקה' },
    { value: 'geolim_bakaa-048', label: 'שמעון' },
    { value: 'geolim_bakaa-049', label: 'שמעיה' },
    { value: 'geolim_bakaa-050', label: 'שמשון' },
    { value: 'geolim_bakaa-051', label: 'רחוב לא ידוע' }
  ]
},
  'herzliya': {
    'yad-hatasha': [
      { value: 'hr-nbv', label: 'הר נבו' },
      { value: 'hr-syny', label: 'הר סיני' },
      { value: 'zysv', label: 'זיסו' },
      { value: 'mepyly-mrvkv', label: 'מעפילי מרוקו' },
      { value: 'rbybym', label: 'רביבים' }
    ],
    'neve-amal-north': [
      { value: 'bvrvkvb', label: 'בורוכוב' },
      { value: 'drk-yrvshlym', label: 'דרך ירושלים' },
      { value: 'ktznlsvn', label: 'כצנלסון' },
      { value: 'mvrdy-hgtavt', label: 'מורדי הגטאות' },
      { value: 'kbvtz-glvyvt', label: 'קבוץ גלויות' }
    ],
    'neve-amal-south': [
      { value: 'prtz', label: 'פרץ' },
      { value: 'pnks', label: 'פנקס' },
      { value: 'gyl', label: 'גיל' },
      { value: 'ytzchk-shdh', label: 'יצחק שדה' },
      { value: 'ktznlsvn', label: 'כצנלסון' }
    ],
    'givat-haprahim-ganey-herzliya-tzmarot-darom': [
      { value: 'yhvdh-hnshya', label: 'יהודה הנשיא' },
      { value: 'mshh', label: 'משה' },
      { value: 'rby-ekyba', label: 'רבי עקיבא' },
      { value: 'rzyal-dvd', label: 'רזיאל דוד' },
      { value: 'hvltzbrg-shmchh', label: 'הולצברג שמחה' }
    ],
    'gordon-south': [
      { value: 'bytr', label: 'בית"ר' },
      { value: 'ptch-tkvvh', label: 'פתח תקווה' },
      { value: 'bn-gvryvn', label: 'בן גוריון' },
      { value: 'hhstdrvt', label: 'ההסתדרות' },
      { value: 'brnr', label: 'ברנר' }
    ],
    'neve-amirim': [
      { value: 'shbty-yshral', label: 'שבטי ישראל' },
      { value: 'bary', label: 'בארי' },
      { value: 'bn-gvryvn', label: 'בן גוריון' },
      { value: 'br-kvkba', label: 'בר כוכבא' },
      { value: 'sedyh-gavn', label: 'סעדיה גאון' }
    ],
    'neve-israel': [
      { value: 'snsh-chnh', label: 'סנש חנה' },
      { value: 'hrb-kvk', label: 'הרב קוק' },
      { value: 'alrvay-dvd', label: 'אלרואי דוד' },
      { value: 'br-kvkba', label: 'בר כוכבא' },
      { value: 'bn-gvryvn', label: 'בן גוריון' }
    ],
    'shimshon-hagibor': [
      { value: 'shmshvn-hgbvr', label: 'שמשון הגבור' },
      { value: 'hs', label: 'הס' },
      { value: 'hetzmavt', label: 'העצמאות' },
      { value: 'hrb-kvk', label: 'הרב קוק' },
      { value: 'hshrvn', label: 'השרון' }
    ],
    'gordon-north': [
      { value: 'khylt-tzyvn', label: 'קהילת ציון' },
      { value: 'bn-yhvdh', label: 'בן יהודה' },
      { value: 'bn-gvryvn', label: 'בן גוריון' },
      { value: 'avsyshkyn', label: 'אוסישקין' },
      { value: 'arlvzvrvb', label: 'ארלוזורוב' }
    ],
    'harav-goren': [
      { value: 'mzah', label: 'מזא"ה' },
      { value: 'hrb-gvrn', label: 'הרב גורן' },
      { value: 'khylt-tzyvn', label: 'קהילת ציון' },
      { value: 'achd-hem', label: 'אחד העם' },
      { value: 'hetzmavt', label: 'העצמאות' }
    ],
    'maonot-sarah': [
      { value: 'br-ayln', label: 'בר אילן' },
      { value: 'hetzmavt', label: 'העצמאות' },
      { value: 'lvyn-shmevn', label: 'לוין שמעון' },
      { value: 'vytzmn', label: 'ויצמן' },
      { value: 'svkvlvb', label: 'סוקולוב' }
    ],
    'sirkyn': [
      { value: 'syrkyn', label: 'סירקין' },
      { value: 'khylt-tzyvn', label: 'קהילת ציון' },
      { value: 'hetzmavt', label: 'העצמאות' },
      { value: 'achd-hem', label: 'אחד העם' },
      { value: 'svkvlvb', label: 'סוקולוב' }
    ],
    'hahagana': [
      { value: 'klyshr', label: 'קלישר' },
      { value: 'hhgnh', label: 'ההגנה' },
      { value: 'hdr', label: 'הדר' },
      { value: 'achd-hem', label: 'אחד העם' },
      { value: 'svkvlvb', label: 'סוקולוב' }
    ],
    'merkaz': [
      { value: 'mlky-yshral', label: 'מלכי ישראל' },
      { value: 'svkvlvb', label: 'סוקולוב' },
      { value: 'tshrnychvbsky', label: 'טשרניחובסקי' },
      { value: 'bny-bnymyn', label: 'בני בנימין' },
      { value: 'hndyb', label: 'הנדיב' }
    ],
    'neve-oved-south': [
      { value: 'alvf-alvn-ygal', label: 'אלוף אלון יגאל' },
      { value: 'brvk', label: 'ברוך' },
      { value: 'hdr', label: 'הדר' },
      { value: 'yph-aryh-lyyb', label: 'יפה אריה לייב' },
      { value: 'egnvn', label: 'עגנון' }
    ],
    'neve-oved-north': [
      { value: 'kbvsh-hebvdh', label: 'כבוש העבודה' },
      { value: 'gvlvmb-alyhv', label: 'גולומב אליהו' },
      { value: 'hdr', label: 'הדר' },
      { value: 'helyh-hshnyh', label: 'העליה השניה' },
      { value: 'yph-aryh-lyyb', label: 'יפה אריה לייב' }
    ],
    'gan-rashal-nahalat-ada': [
      { value: 'שד-בגין-מנחם', label: 'שד\' בגין מנחם' },
      { value: 'mgn-dvd', label: 'מגן דוד' },
      { value: 'haylnvt', label: 'האילנות' },
      { value: 'hbrygdh-hyhvdyt', label: 'הבריגדה היהודית' },
      { value: 'knpy-nshrym', label: 'כנפי נשרים' }
    ],
    'maonot-poalim': [
      { value: 'mlky-yhvdh', label: 'מלכי יהודה' },
      { value: 'anylbytz', label: 'אנילביץ' },
      { value: 'gvlvmb-alyhv', label: 'גולומב אליהו' },
      { value: 'hbrygdh-hyhvdyt', label: 'הבריגדה היהודית' },
      { value: 'hdr', label: 'הדר' }
    ],
    'kiryat-rabin-sport': [
      { value: 'altrmn-ntn', label: 'אלתרמן נתן' },
      { value: 'זבוטינסקי', label: 'ז\'בוטינסקי' },
      { value: 'nbv-yvsf', label: 'נבו יוסף' },
      { value: 'shbet-hkvkbym', label: 'שבעת הכוכבים' },
      { value: 'שד-מיכאלי-בן ציון', label: 'שד\' מיכאלי בן ציון' }
    ],
    'bney-binyamin': [
      { value: 'bny-bnymyn', label: 'בני בנימין' },
      { value: 'shnyavr-zlmn', label: 'שניאור זלמן' },
      { value: 'brsh-ashr', label: 'ברש אשר' },
      { value: 'altrmn-ntn', label: 'אלתרמן נתן' },
      { value: 'hndyb', label: 'הנדיב' }
    ],
    'alkalai': [
      { value: 'alkley', label: 'אלקלעי' },
      { value: 'grynbrg-avry-tzby', label: 'גרינברג אורי צבי' },
      { value: 'hndyb', label: 'הנדיב' },
      { value: 'ezra-hsvpr', label: 'עזרא הסופר' },
      { value: 'pynskr', label: 'פינסקר' }
    ],
    'weizmann-east': [
      { value: 'abn-gbyrvl', label: 'אבן גבירול' },
      { value: 'hravbny', label: 'הראובני' },
      { value: 'vytzmn', label: 'ויצמן' },
      { value: 'pynskr', label: 'פינסקר' },
      { value: 'shmval-hngyd', label: 'שמואל הנגיד' }
    ],
    'weizmann-west': [
      { value: 'abn-shprvt', label: 'אבן שפרוט' },
      { value: 'ahrvnsvn-dshh', label: 'אהרונסון דשה' },
      { value: 'bn-srvk-mnchm', label: 'בן סרוק מנחם' },
      { value: 'hrb-kvk', label: 'הרב קוק' },
      { value: 'abn-ezra', label: 'אבן עזרא' }
    ],
    'new-industrial-marina': [
      { value: 'hchvshlym', label: 'החושלים' },
      { value: 'hmnvpym', label: 'המנופים' },
      { value: 'hshvnyt', label: 'השונית' },
      { value: 'שד-אבא-אבן', label: 'שד\' אבא אבן' },
      { value: 'shnkr-aryh', label: 'שנקר אריה' }
    ],
    'industrial': [
      { value: 'glgl-hpldh', label: 'גלגל הפלדה' },
      { value: 'yd-chrvtzym', label: 'יד חרוצים' },
      { value: 'mdynt-hyhvdym', label: 'מדינת היהודים' },
      { value: 'mshkyt', label: 'משכית' },
      { value: 'שד-אבא-אבן', label: 'שד\' אבא אבן' }
    ],
    'givat-hasofer': [
      { value: 'drk-dyyn-mshh', label: 'דרך דיין משה' },
      { value: 'hmsylh', label: 'המסילה' },
      { value: 'hmnhrh', label: 'המנהרה' },
      { value: 'al-el', label: 'אל על' },
      { value: 'nvrdav', label: 'נורדאו' }
    ],
    'herzliya-pituach-east': [
      { value: 'achy-dkr', label: 'אח"י דקר' },
      { value: 'hmgynym', label: 'המגינים' },
      { value: 'hnshya-ytzchk-bn-tzby', label: 'הנשיא יצחק בן צבי' },
      { value: 'yhvshpt-hmlk', label: 'יהושפט המלך' },
      { value: 'shlvh', label: 'שלוה' }
    ],
    'herzliya-pituach-west': [
      { value: 'hnshya-ytzchk-bn-tzby', label: 'הנשיא יצחק בן צבי' },
      { value: 'vyngyyt', label: 'וינגייט' },
      { value: 'nyly', label: 'ניל"י' },
      { value: 'mdynt-hyhvdym', label: 'מדינת היהודים' },
      { value: 'rmt-ym', label: 'רמת ים' }
    ],
    'apollonia-nof-yam-reshef': [
      { value: 'sher-hym', label: 'שער הים' },
      { value: 'krn-hysvd', label: 'קרן היסוד' },
      { value: 'bzl', label: 'בזל' },
      { value: 'hnshya-ytzchk-bn-tzby', label: 'הנשיא יצחק בן צבי' },
      { value: 'vyngyyt', label: 'וינגייט' }
    ]
  },
      'rishon': {
        'avrahamovitz': [
  { value: 'avrahamovitz', label: 'אברמוביץ' },
  { value: 'avshalom', label: 'אבשלום' },
  { value: 'aharon-u-baruch', label: 'אהרון וברוך' },
  { value: 'usishkin', label: 'אוסישקין' },
  { value: 'azr', label: 'אז"ר' },
  { value: 'amzaleg', label: 'אמזלג' },
  { value: 'emile-zola', label: 'אמיל זולא' },
  { value: 'asa', label: 'אסא' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'beitar', label: 'בית"ר' },
  { value: 'bar-yochai', label: 'בר-יוחאי' },
  { value: 'gisin', label: 'גיסין' },
  { value: 'gruzenberg', label: 'גרוזנברג' },
  { value: 'greenboim', label: 'גרינבוים' },
  { value: 'haoranim', label: 'האורנים' },
  { value: 'haachim-ziger', label: 'האחים זיגר' },
  { value: 'haboron-hirsch', label: 'הברון הירש' },
  { value: 'hagvura-hayehudit', label: 'הגבורה היהודית' },
  { value: 'hachayal-haalmoni', label: 'החייל האלמוני' },
  { value: 'halel-naftali', label: 'הלל נפתלי' },
  { value: 'halperin', label: 'הלפרין' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'zeev-jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'trumpeldor', label: 'טרומפלדור' },
  { value: 'trachtenerg', label: 'טרכטנברג' },
  { value: 'yalg', label: 'יל"ג' },
  { value: 'montefiore', label: 'מונטיפיורי' },
  { value: 'motskin', label: 'מוצקין' },
  { value: 'nili', label: 'ניל"י' },
  { value: 'naaman', label: 'נעמן' },
  { value: 'haltz', label: 'סאלד' },
  { value: 'olei-hagardom', label: 'עולי הגרדום' },
  { value: 'ein-hakore', label: 'עין הקורא' },
  { value: 'pins', label: 'פינס' },
  { value: 'frishman', label: 'פרישמן' },
  { value: 'tzvi-herman-shapira', label: 'צבי הרמן שפירא' },
  { value: 'karl-netter', label: 'קרל נטר' },
  { value: 'keren-hayesod', label: 'קרן היסוד' },
  { value: 'keren-kayemet-leisrael', label: 'קרן קיימת לישראל' },
  { value: 'rotenberg', label: 'רוטנברג' },
  { value: 'rothschild', label: 'רוטשילד' },
  { value: 'shenkin', label: 'שינקין' },
  { value: 'shalit', label: 'שליט' },
  { value: 'shmaryahu-levin', label: 'שמריהו לוין' },
  { value: 'shimshon', label: 'שמשון' },
  { value: 'spinoza', label: 'שפינוזה' },
  { value: 'tel-hai', label: 'תל חי' },
  { value: 'tavreshmem-bet', label: 'תרמ"ב' }
],
      'bnot-khayil': [
  { value: 'anna-frank', label: 'אנה פרנק' },
  { value: 'baba-idelson', label: 'בבה אידלסון' },
  { value: 'ben-gurion', label: 'בן גוריון' },
  { value: 'haganenet-harishona', label: 'הגננת הראשונה' },
  { value: 'zehara-lebitov', label: 'זהרה לביטוב' },
  { value: 'zikaron-sarah', label: 'זיכרון שרה' },
  { value: 'chaika-grossman', label: 'חייקה גרוסמן' },
  { value: 'chana-robina', label: 'חנה רובינא' },
  { value: 'lea-rabin', label: 'לאה רבין' },
  { value: 'menachem-begin', label: 'מנחם בגין' },
  { value: 'aliza-begin', label: 'עליזה בגין' },
  { value: 'paula-ben-gurion', label: 'פולה בן גוריון' },
  { value: 'rivka-guber', label: 'רבקה גובר' },
  { value: 'rachel-kagan', label: 'רחל כגן' }
],
     'hashomer': [
  { value: 'avraham-gershberg', label: 'אברהם גרשברג' },
  { value: 'adam-beckerman', label: 'אדם בקרמן' },
  { value: 'bilu', label: 'ביל"ו' },
  { value: 'beit-lechem', label: 'בית לחם' },
  { value: 'haavot', label: 'האבות' },
  { value: 'harav-damari', label: 'הרב דמארי' },
  { value: 'herbert-samuel', label: 'הרברט סמואל' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'chaviv-lubman', label: 'חביב לובמן' },
  { value: 'chevron', label: 'חברון' },
  { value: 'chalutzei-yesod-hamaala', label: 'חלוצי יסוד המעלה' },
  { value: 'tabib', label: 'טביב' },
  { value: 'toporovsky', label: 'טופורובסקי' },
  { value: 'yerushalayim', label: 'ירושלים' },
  { value: 'levontin', label: 'לבונטין' },
  { value: 'meirovitz', label: 'מאירוביץ' },
  { value: 'maonot-bracha', label: 'מעונות ברכה' },
  { value: 'shivat-tzion', label: 'שיבת ציון' },
  { value: 'shalom-chavakuk', label: 'שלום חבקוק' },
  { value: 'shimshon-balkind', label: 'שמשון בלקינד' }
],
     'katsnelson': [
  { value: 'even-shoshan', label: 'אבן שושן' },
  { value: 'aharonovich', label: 'אהרונוביץ' },
  { value: 'einstein', label: 'איינשטיין' },
  { value: 'imbar', label: 'אימבר' },
  { value: 'arloseorov', label: 'ארלוזורוב' },
  { value: 'arthur-rubinstein', label: 'ארתור רובינשטיין' },
  { value: 'borochov', label: 'בורוכוב' },
  { value: 'billinson', label: 'בילינסון' },
  { value: 'ben-gurion', label: 'בן גוריון' },
  { value: 'baron-deborah', label: 'ברון דבורה' },
  { value: 'barzilai', label: 'ברזילי' },
  { value: 'brener', label: 'ברנר' },
  { value: 'golomb', label: 'גולומב' },
  { value: 'gordon', label: 'גורדון' },
  { value: 'gan-yavne', label: 'גן יבנה' },
  { value: 'gretz', label: 'גרץ' },
  { value: 'dov-hoz', label: 'דב הוז' },
  { value: 'dubnov', label: 'דובנוב' },
  { value: 'achim-yaakobi', label: 'האחים יעקובי' },
  { value: 'habrigada', label: 'הבריגדה' },
  { value: 'hadegel-haivri', label: 'הדגל העברי' },
  { value: 'halochamim', label: 'הלוחמים' },
  { value: 'hamaayan', label: 'המעיין' },
  { value: 'hamitnadvim', label: 'המתנדבים' },
  { value: 'has', label: 'הס' },
  { value: 'haportzim', label: 'הפורצים' },
  { value: 'hapardes-harishon', label: 'הפרדס הראשון' },
  { value: 'hashachar', label: 'השחר' },
  { value: 'hatikva', label: 'התקוה' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'cheletz', label: 'חלץ' },
  { value: 'tshernichovsky', label: 'טשרניחובסקי' },
  { value: 'yadin', label: 'ידין' },
  { value: 'yaakov-peri', label: 'יעקב פרי' },
  { value: 'itzhak-tabankin', label: 'יצחק טבנקין' },
  { value: 'katznelson', label: 'כצנלסון' },
  { value: 'lilienthal', label: 'לילינבלום' },
  { value: 'leskov', label: 'לסקוב' },
  { value: 'mapu', label: 'מאפו' },
  { value: 'mivtsa-kadesh', label: 'מבצע קדש' },
  { value: 'micha-yosef', label: 'מיכה יוסף' },
  { value: 'mendele', label: 'מנדלי' },
  { value: 'nahum-goldman', label: 'נחום גולדמן' },
  { value: 'sascha-argov', label: 'סשה ארגוב' },
  { value: 'prof-nahum', label: 'פרופ\' נחום' },
  { value: 'peretz', label: 'פרץ' },
  { value: 'tsemach', label: 'צמח' },
  { value: 'kaplan', label: 'קפלן' },
  { value: 'kiryat-sefer', label: 'קריית ספר' },
  { value: 'rothschild', label: 'רוטשילד' },
  { value: 'sh-ben-tzion', label: 'ש\' בן ציון' },
  { value: 'shalom-aleichem', label: 'שלום עליכם' },
  { value: 'shlomo-mikhals', label: 'שלמה מיכאלס' },
  { value: 'shimoni', label: 'שמעוני' }
],
    'mabit-maarav': [
  { value: 'eitan', label: 'איתן' },
  { value: 'elchanan', label: 'אלחנן' },
  { value: 'altalena', label: 'אלטלנה' },
  { value: 'eliezer-mazal', label: 'אליעזר מזל' },
  { value: 'etzl', label: 'אצ"ל' },
  { value: 'gluska', label: 'גלוסקא' },
  { value: 'david-saharov', label: 'דוד סחרוב' },
  { value: 'david-pinkas', label: 'דוד פנקס' },
  { value: 'hahagana', label: 'ההגנה' },
  { value: 'hakhsharat-hayeshuv', label: 'הכשרת היישוב' },
  { value: 'harav-shalom-garufi', label: 'הרב שלום גרופי' },
  { value: 'hasar-moshe-shapira', label: 'השר משה שפירא' },
  { value: 'choma', label: 'חומה' },
  { value: 'yosef-lishansky', label: 'יוסף לישנסקי' },
  { value: 'yosef-sapir', label: 'יוסף ספיר' },
  { value: 'yeldei-teheran', label: 'ילדי טהרן' },
  { value: 'levi-moshe', label: 'לוי משה' },
  { value: 'lazarov', label: 'לזרוב' },
  { value: 'lechi', label: 'לח"י' },
  { value: 'mordechai-rozanski', label: 'מרדכי רוז\'נסקי' },
  { value: 'moshe-sharet', label: 'משה שרת' },
  { value: 'nadav-baskind', label: 'נדב בסקינד' },
  { value: 'nachum-mozes', label: 'נח מוזס' },
  { value: 'naftali-paltin', label: 'נפתלי פלטין' },
  { value: 'aliyat-hanoar', label: 'עלית הנוער' },
  { value: 'prof-chavot', label: 'פרופ\' חבוט' },
  { value: 'kaner', label: 'קנר' },
  { value: 'shimon-yisraeli', label: 'שמעון ישראלי' }
],
    'mabit-tsafon': [
  { value: 'avraham-aharon-markovich', label: 'אברהם אהרון מרקוביץ' },
  { value: 'binyamin-shmotkin', label: 'בנימין שמוטקין' },
  { value: 'beker', label: 'בקר' },
  { value: 'barshevski', label: 'ברשבסקי' },
  { value: 'hamaccabim', label: 'המכבים' },
  { value: 'tulipman', label: 'טוליפמן' },
  { value: 'yaakov-freeman', label: 'יעקב פרימן' },
  { value: 'pika', label: 'פיק"א' },
  { value: 'plotitzki', label: 'פלוטיצקי' },
  { value: 'prashkovski', label: 'פרשקובסקי' },
  { value: 'tzvi-isaacson', label: 'צבי איזקסון' },
  { value: 'shlomo-ben-david', label: 'שלמה בן דוד' }
],
    'mishor-hof': [
  { value: 'harav-gutman-zvi', label: 'הרב גוטמן צבי' },
  { value: 'yehoshua-gibshtein', label: 'יהושע גיבשטיין' },
  { value: 'yoni-zvi-feinstein', label: 'יוני צבי פינשטיין' },
  { value: 'yaakov-hazan', label: 'יעקב חזן' },
  { value: 'yaari-meir', label: 'יערי מאיר' },
  { value: 'mordechai-regev', label: 'מרדכי רגב' },
  { value: 'moshe-ben-nachman', label: 'משה בן נחמן' },
  { value: 'emanuela-ben-yaakov', label: 'עמנואלה בן יעקב' },
  { value: 'kampinsky', label: 'קמפינסקי' },
  { value: 'rabi-yehuda-hanasi', label: 'רבי יהודה הנשיא' }
],
      'noot-asalim': [
  { value: 'haorgan', label: 'האורגן' },
  { value: 'hagitit', label: 'הגיתית' },
  { value: 'hachalil', label: 'החליל' },
  { value: 'hakinor', label: 'הכינור' },
  { value: 'hamapuchit', label: 'המפוחית' },
  { value: 'haogev', label: 'העוגב' },
  { value: 'hapsanter', label: 'הפסנתר' },
  { value: 'haklarinet', label: 'הקלרנית' },
  { value: 'hatof', label: 'התוף' },
  { value: 'hatizmoret', label: 'התזמורת' }
],
        'noot-shikma': [
  { value: 'aba-kovner', label: 'אבא קובנר' },
  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'uri-tsvi', label: 'אורי צבי' },
  { value: 'alharizi', label: 'אלחריזי' },
  { value: 'elkabetz', label: 'אלקבץ' },
  { value: 'alterman', label: 'אלתרמן' },
  { value: 'buber-martin', label: 'בובר מרטין' },
  { value: 'borela', label: 'בורלא' },
  { value: 'ben-saruk', label: 'בן סרוק' },
  { value: 'banbanishti', label: 'בנבנישתי' },
  { value: 'bergman', label: 'ברגמן' },
  { value: 'gdolei-israel', label: 'גדולי ישראל' },
  { value: 'hazaz', label: 'הזז' },
  { value: 'haporet-rachel', label: 'המשוררת רחל' },
  { value: 'hanagid', label: 'הנגיד' },
  { value: 'harav-unterman', label: 'הרב אונטרמן' },
  { value: 'harav-goren', label: 'הרב גורן' },
  { value: 'harav-neriya', label: 'הרב נריה' },
  { value: 'habal-shel-lubavitch', label: 'הרבי מלובביץ' },
  { value: 'harashba', label: 'הרשב"א' },
  { value: 'hashira-haivrit', label: 'השירה העברית' },
  { value: 'levi-eshkol', label: 'לוי אשכול' },
  { value: 'lamdan', label: 'למדן' },
  { value: 'moreshet-israel', label: 'מורשת ישראל' },
  { value: 'kapach', label: 'קאפח' },
  { value: 'kipnis', label: 'קיפניס' },
  { value: 'kalisher', label: 'קלישר' },
  { value: 'ribal', label: 'ריב"ל' },
  { value: 'shlonsky', label: 'שלונסקי' }
],
     'noot-dkalim': [
  { value: 'avnei-etan', label: 'אבני איתן' },
  { value: 'avraham-nir', label: 'אברהם ניר' },
  { value: 'odem', label: 'אודם' },
  { value: 'ofira', label: 'אופירה' },
  { value: 'itam', label: 'איתם' },
  { value: 'el-rom', label: 'אל רום' },
  { value: 'alonei-habashan', label: 'אלוני הבשן' },
  { value: 'aniam', label: 'אניעם' },
  { value: 'afik', label: 'אפיק' },
  { value: 'bnei-chayil', label: 'בני חייל' },
  { value: 'bnei-yehuda', label: 'בני יהודה' },
  { value: 'givat-yoav', label: 'גבעת יואב' },
  { value: 'gamla', label: 'גמלא' },
  { value: 'dei-zehav', label: 'די-זהב' },
  { value: 'dekalim', label: 'דקלה' },
  { value: 'ha-esarah', label: 'העשרה' },
  { value: 'had-nes', label: 'חד נס' },
  { value: 'chativa-sheva', label: 'חטיבה שבע' },
  { value: 'hispin', label: 'חיספין' },
  { value: 'chama', label: 'חמה' },
  { value: 'chatzer-adar', label: 'חצר-אדר' },
  { value: 'yonatan', label: 'יונתן' },
  { value: 'yamit', label: 'ימית' },
  { value: 'kanaf', label: 'כנף' },
  { value: 'kfar-charuv', label: 'כפר חרוב' },
  { value: 'mevoot-hermon', label: 'מבואות חרמון' },
  { value: 'meitzar', label: 'מיצר' },
  { value: 'marom-golan', label: 'מרום גולן' },
  { value: 'neot-golan', label: 'נאות גולן' },
  { value: 'neviot', label: 'נביעות' },
  { value: 'nov', label: 'נוב' },
  { value: 'neve-atib', label: 'נווה אטי"ב' },
  { value: 'nachal-yam', label: 'נח"ל ים' },
  { value: 'nachal-nimrod', label: 'נח"ל נמרוד' },
  { value: 'natur', label: 'נטור' },
  { value: 'naama', label: 'נעמה' },
  { value: 'ein-zivan', label: 'עין זיוון' },
  { value: 'atzmona', label: 'עצמונה' },
  { value: 'pri-gan', label: 'פרי-גן' },
  { value: 'kedmat-sinai', label: 'קדמת סיני' },
  { value: 'kedmat-zvi', label: 'קדמת צבי' },
  { value: 'kela', label: 'קלע' },
  { value: 'katzrin', label: 'קצרין' },
  { value: 'keshet', label: 'קשת' },
  { value: 'ramot', label: 'רמות' },
  { value: 'ramat-magshimim', label: 'רמת מגשימים' },
  { value: 'refidim', label: 'רפידים' },
  { value: 'sdot', label: 'שדות' },
  { value: 'siyon', label: 'שיאון' },
  { value: 'sha-al', label: 'שעל' }
],
      'noot-hadarim': [
  { value: 'bernstein', label: 'ברנשטיין' },
  { value: 'haduchifat', label: 'הדוכיפת' },
  { value: 'hazarzir', label: 'הזרזיר' },
  { value: 'hachochit', label: 'החוחית' },
  { value: 'hanachlieli', label: 'הנחליאלי' },
  { value: 'haafroni', label: 'העפרוני' },
  { value: 'hakukiya', label: 'הקוקייה' },
  { value: 'herzl-grinshpan', label: 'הרצל גרינשפן' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'yigal-allon', label: 'יגאל אלון' },
  { value: 'yehuda-tibubitz', label: 'יהודה טיבוביץ' },
  { value: 'yerushalayim', label: 'ירושלים' },
  { value: 'mazia', label: 'מזי"א' },
  { value: 'feibush-ketzler', label: 'פייבוש כצלר' },
  { value: 'raam', label: 'ראם' }
],
      'noot-haklal': [
  { value: 'hagilboa', label: 'הגלבוע' },
  { value: 'har-tzion', label: 'הר ציון' },
  { value: 'hashomron', label: 'השומרון' },
  { value: 'hatavor', label: 'התבור' },
  { value: 'meron', label: 'מירון' }
],
        'noot-hof': [
  { value: 'avihayil', label: 'אביחיל' },
  { value: 'adar', label: 'אדר' },
  { value: 'esther-hamalkah', label: 'אסתר המלכה' },
  { value: 'argaman', label: 'ארגמן' },
  { value: 'haigeret', label: 'האיגרת' },
  { value: 'hadassah', label: 'הדסה' },
  { value: 'haketer', label: 'הכתר' },
  { value: 'halavonah', label: 'הלבונה' },
  { value: 'hamegillah', label: 'המגילה' },
  { value: 'hamelech', label: 'המלך' },
  { value: 'hapur', label: 'הפור' },
  { value: 'hasharvit', label: 'השרביט' },
  { value: 'hatchelet', label: 'התכלת' },
  { value: 'zalman-shazar', label: 'זלמן שז"ר' },
  { value: 'khen', label: 'ח"ן' },
  { value: 'chaim-landau', label: 'חיים לנדאו' },
  { value: 'heil-haavir', label: 'חיל האוויר' },
  { value: 'heil-hahandasa', label: 'חיל ההנדסה' },
  { value: 'heil-hahimush', label: 'חיל החימוש' },
  { value: 'heil-hayam', label: 'חיל הים' },
  { value: 'heil-hatzanhanim', label: 'חיל הצנחנים' },
  { value: 'heil-haregalim', label: 'חיל הרגלים' },
  { value: 'heil-hashiryon', label: 'חיל השריון' },
  { value: 'heil-hatotchanim', label: 'חיל התותחנים' },
  { value: 'chamda', label: 'חמ"ד (חיל המדע)' },
  { value: 'koresh', label: 'כורש' },
  { value: 'mordechai-hayehudi', label: 'מרדכי היהודי' },
  { value: 'ateret-zahav', label: 'עטרת זהב' },
  { value: 'shushan-habirah', label: 'שושן הבירה' },
  { value: 'shoshanat-yaakov', label: 'שושנת יעקב' }
],
        'noot-yam': [
  { value: 'even-khen', label: 'אבן חן' },
  { value: 'avnei-hachoshen', label: 'אבני החושן' },
  { value: 'bareket', label: 'ברקת' },
  { value: 'granite', label: 'גרניט' },
  { value: 'dag-hazahav', label: 'דג הזהב' },
  { value: 'hei-beiyar', label: "ה' באייר" },
  { value: 'haoniya', label: 'האונייה' },
  { value: 'hailatit', label: 'האילתית' },
  { value: 'haalgomim', label: 'האלמוגים' },
  { value: 'habarkan', label: 'הברקן' },
  { value: 'hadugit', label: 'הדוגית' },
  { value: 'hadolfin', label: 'הדולפין' },
  { value: 'hadiyonon', label: 'הדיונון' },
  { value: 'hadaysagim', label: 'הדייגים' },
  { value: 'hazaharon', label: 'הזהרון' },
  { value: 'hakasif', label: 'הכסיף' },
  { value: 'halivyatan', label: 'הלוויתן' },
  { value: 'hamelakhim', label: 'המלחים' },
  { value: 'hamifras', label: 'המפרש' },
  { value: 'hamashot', label: 'המשוט' },
  { value: 'hanakhshol', label: 'הנחשול' },
  { value: 'hanamal', label: 'הנמל' },
  { value: 'hasipon', label: 'הסיפון' },
  { value: 'hasira', label: 'הסירה' },
  { value: 'hasnapir', label: 'הסנפיר' },
  { value: 'haogen', label: 'העוגן' },
  { value: 'hapazit', label: 'הפזית' },
  { value: 'hatsadef', label: 'הצדף' },
  { value: 'hakabarnit', label: 'הקברניט' },
  { value: 'hakonchiya', label: 'הקונכייה' },
  { value: 'harafsoda', label: 'הרפסודה' },
  { value: 'hareshet', label: 'הרשת' },
  { value: 'hashayatim', label: 'השייטים' },
  { value: 'hatoren', label: 'התורן' },
  { value: 'topaz', label: 'טופז' },
  { value: 'yahalom', label: 'יהלום' },
  { value: 'leshem', label: 'לשם' },
  { value: 'mivtza-barak', label: 'מבצע ברק' },
  { value: 'mivtza-dani', label: 'מבצע דני' },
  { value: 'mivtza-haarel', label: 'מבצע הראל' },
  { value: 'mivtza-homat-magen', label: 'מבצע חומת מגן' },
  { value: 'mivtza-khorev', label: 'מבצע חורב' },
  { value: 'mivtza-yoav', label: 'מבצע יואב' },
  { value: 'mivtza-yonatan', label: 'מבצע יונתן' },
  { value: 'mivtza-litani', label: 'מבצע ליטאני' },
  { value: 'mivtza-moshe', label: 'מבצע משה' },
  { value: 'mivtza-nakhshon', label: 'מבצע נחשון' },
  { value: 'mivtza-uvda', label: 'מבצע עובדה' },
  { value: 'mivtza-anvey-zaam', label: 'מבצע ענבי זעם' },
  { value: 'mivtza-shlomo', label: 'מבצע שלמה' },
  { value: 'mivtza-tamuz', label: 'מבצע תמוז' },
  { value: 'migdalor', label: 'מגדלור' },
  { value: 'inbar', label: 'ענבר' },
  { value: 'pinat-hayam', label: 'פנינת הים' },
  { value: 'ravid', label: 'רביד' },
  { value: 'shoham', label: 'שוהם' },
  { value: 'shanav', label: 'שנהב' },
  { value: 'sheshet-hayamim', label: 'ששת הימים' },
  { value: 'tarshish', label: 'תרשיש' }
],
        'nakhalat-yehuda': [
  { value: 'avraham-weinberg', label: 'אברהם וינברג' },
  { value: 'aharon-ozen', label: 'אהרון אוזן' },
  { value: 'aharon-ve-menachem-zalzman', label: 'אהרון ומנחם זלצמן' },
  { value: 'ofek', label: 'אופק' },
  { value: 'eli-kohen', label: 'אלי כהן' },
  { value: 'elimelekh-tsamir', label: 'אלימלך צמיר' },
  { value: 'elisha', label: 'אלישע' },
  { value: 'alter-david-hacohen', label: 'אלתר דוד הכהן' },
  { value: 'asher-orenbach', label: 'אשר אורנבך' },
  { value: 'baari', label: 'בארי' },
  { value: 'jo-amar', label: 'ג\'ו עמר' },
  { value: 'giborei-yisrael', label: 'גבורי ישראל' },
  { value: 'gabin-moshe', label: 'גבין משה' },
  { value: 'deborah-omer', label: 'דבורה עומר' },
  { value: 'dalia-peri', label: 'דליה פרי' },
  { value: 'haagas', label: 'האגס' },
  { value: 'haoranim', label: 'האורנים' },
  { value: 'haeshkolit', label: 'האשכולית' },
  { value: 'habanim', label: 'הבנים' },
  { value: 'habroshim', label: 'הברושים' },
  { value: 'hahadar', label: 'ההדר' },
  { value: 'hayaar', label: 'היער' },
  { value: 'halimon', label: 'הלימון' },
  { value: 'hamukhtar', label: 'המוכתר' },
  { value: 'hamore-avraham', label: 'המורה אברהם' },
  { value: 'hamoshava', label: 'המושבה' },
  { value: 'hameyasdim', label: 'המייסדים' },
  { value: 'hanakhala', label: 'הנחלה' },
  { value: 'haeinav', label: 'העינב' },
  { value: 'haatsmaut', label: 'העצמאות' },
  { value: 'harav-yaakobovitz', label: 'הרב יעקובוביץ' },
  { value: 'harav-yitzhak-shlinka', label: 'הרב יצחק שלינקה' },
  { value: 'harav-moshe-tsalakh', label: 'הרב משה צאלח' },
  { value: 'hershkowitz', label: 'הרשקוביץ' },
  { value: 'hashnayim', label: 'השניים' },
  { value: 'hatamar', label: 'התמר' },
  { value: 'hatapuz', label: 'התפוז' },
  { value: 'zusman', label: 'זוסמן' },
  { value: 'yosef-ben-ovadia', label: 'יוסף בן עובדיה' },
  { value: 'yosef-verisia-livin', label: 'יוסף וריסיה ליבין' },
  { value: 'yitzhak-igo-wald', label: 'יצחק איגו ולד' },
  { value: 'yitzhak-ben-david', label: 'יצחק בן דוד' },
  { value: 'yisrael-dshavski', label: 'ישראל דשבסקי' },
  { value: 'luz', label: 'לוז' },
  { value: 'meir-ve-tsvi-hovav', label: 'מאיר וצבי חובב' },
  { value: 'mulek-eyal', label: 'מוליק (שמואל) אייל' },
  { value: 'miriam-ben-porat', label: 'מרים בן פורת' },
  { value: 'moshe-u-binyamin', label: 'משה ובנימין' },
  { value: 'noam-leoner', label: 'נועם לאונר' },
  { value: 'nakhmoni', label: 'נחמוני' },
  { value: 'nissim-melal', label: 'ניסים מלל' },
  { value: 'saadia-ve-yosef-bshari', label: 'סעדיה ויוסף בשארי' },
  { value: 'amiram-meidan', label: 'עמירם מידן' },
  { value: 'tsvi-ganot', label: 'צבי גנות' },
  { value: 'tsvi-miller', label: 'צבי מילר' },
  { value: 'kibbutz-galuyot', label: 'קבוץ גלויות' },
  { value: 'rabi-yosef-bokhriz', label: 'רבי יוסף בוכריץ' },
  { value: 'rabi-moshe-kalfon-hacohen', label: 'רבי משה כלפון הכהן' },
  { value: 'shaul-yaakobi', label: 'שאול יעקבי' },
  { value: 'shulamit-aloni', label: 'שולמית אלוני' },
  { value: 'shika-gertzberg', label: 'שיקא גרצברג' },
  { value: 'shalom-shabazi', label: 'שלום שבזי' },
  { value: 'shlomo-leib-lipshitz', label: 'שלמה לייב ליפשיץ' }
],
        'neorim': [
  { value: 'brit-yosef', label: 'ברית יוסף' },
  { value: 'hamakhanot-haolim', label: 'המחנות העולים' },
  { value: 'hanoar-haleumi', label: 'הנוער הלאומי' },
  { value: 'hatsufim', label: 'הצופים' },
  { value: 'maccabi-tzair', label: 'מכבי צעיר' },
  { value: 'pika', label: 'פיק"א' },
  { value: 'tnuot-hanoar', label: 'תנועות הנוער' }
],
    'tsameret': [
  { value: 'dolev', label: 'דולב' },
  { value: 'haokhmanit', label: 'האוכמנית' },
  { value: 'haafarsek', label: 'האפרסק' },
  { value: 'haduvdevan', label: 'הדובדבן' },
  { value: 'hachamanit', label: 'החמנית' },
  { value: 'hachatzav', label: 'החצב' },
  { value: 'halulav', label: 'הלולב' },
  { value: 'haarmon', label: 'הערמון' },
  { value: 'hapikus', label: 'הפיקוס' },
  { value: 'hatzabar', label: 'הצבר' },
  { value: 'hatzaftzafa', label: 'הצפצפה' },
  { value: 'hatut', label: 'התות' },
  { value: 'lilach', label: 'לילך' }
],
    'kadmata-rishon': [
  { value: 'eliezer-blevan', label: 'אליעזר בלבן' },
  { value: 'davidzon', label: 'דוידזון' },
  { value: 'harav-tzadok', label: 'הרב צדוק' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'yaakov-sofer', label: 'יעקב סופר' },
  { value: 'yaakovzon', label: 'יעקובזון' },
  { value: 'mordechai-popol', label: 'מרדכי פופל' },
  { value: 'mishmar-hayarden', label: 'משמר הירדן' },
  { value: 'al-kanfei-nesharim', label: 'על כנפי נשרים' },
  { value: 'pica', label: 'פיק"א' },
  { value: 'pnina-vemoshe', label: 'פנינה ומשה' },
  { value: 'tzvi-frank', label: 'צבי פרנק' },
  { value: 'reuven-ve-bat-sheva', label: 'ראובן ובת-שבע' }
],
    'kiryat-ganim': [
  { value: 'usha', label: 'אושה' },
  { value: 'eylon', label: 'אילון' },
  { value: 'beit-haarava', label: 'בית הערבה' },
  { value: 'beit-yehoshua', label: 'בית יהושע' },
  { value: 'geulim', label: 'גאולים' },
  { value: 'ginosar', label: 'גינוסר' },
  { value: 'gesher', label: 'גשר' },
  { value: 'dalia', label: 'דליה' },
  { value: 'dan', label: 'דן' },
  { value: 'hazorim', label: 'הזורעים' },
  { value: 'hachamisha', label: 'החמישה' },
  { value: 'choma-umigdal', label: 'חומה ומגדל' },
  { value: 'hamadiya', label: 'חמדיה' },
  { value: 'chanita', label: 'חניתה' },
  { value: 'tirat-tzvi', label: 'טירת צבי' },
  { value: 'kfar-chittim', label: 'כפר חיטים' },
  { value: 'mesilot', label: 'מסילות' },
  { value: 'maoz-chaim', label: 'מעוז חיים' },
  { value: 'mishmar-hashlosha', label: 'משמר השלושה' },
  { value: 'negba', label: 'נגבה' },
  { value: 'nir-david', label: 'ניר דוד' },
  { value: 'ein-gev', label: 'עין גב' },
  { value: 'ein-hamifratz', label: 'עין המפרץ' },
  { value: 'amir', label: 'עמיר' },
  { value: 'sde-eliyahu', label: 'שדה אליהו' },
  { value: 'sde-warburg', label: 'שדה ורבורג' },
  { value: 'sde-nachum', label: 'שדה נחום' },
  { value: 'shadmot-dvora', label: 'שדמות דבורה' },
  { value: 'sharona', label: 'שרונה' },
  { value: 'tel-yitzhak', label: 'תל יצחק' }
],
     'kiryat-keramim': [
  { value: 'habotzrim', label: 'הבוצרים' },
  { value: 'hagat', label: 'הגת' },
  { value: 'hadagan', label: 'הדגן' },
  { value: 'hazmora', label: 'הזמורה' },
  { value: 'hayitzhar', label: 'היצהר' },
  { value: 'hayekev', label: 'היקב' },
  { value: 'hakormim', label: 'הכורמים' },
  { value: 'hasuka', label: 'הסוכה' },
  { value: 'hasmadar', label: 'הסמדר' },
  { value: 'haasis', label: 'העסיס' },
  { value: 'hasarig', label: 'השריג' }
],
        'kiryat-khatanei-peres-nobel': [
  { value: 'edmund-fischer', label: 'אדמונד פישר' },
  { value: 'aharon-klug', label: 'אהרון קלוג' },
  { value: 'henri-bergson', label: 'אנרי ברגסון' },
  { value: 'arrow-kenneth-joseph', label: "ארו קנט' ג'וזף" },
  { value: 'baltimore-david', label: 'בולטימור דוד' },
  { value: 'boris-pasternak', label: 'בוריס פסטרנק' },
  { value: 'blue-saul', label: 'בלו סול' },
  { value: 'benacerraf-baruch', label: 'בנאסרף ברוך' },
  { value: 'berg-paul', label: 'ברג פול' },
  { value: 'george-de-hevesy', label: 'ג\'ורג\' דה-הוושי' },
  { value: 'gary-becker', label: 'גארי בקר' },
  { value: 'gustav-hertz', label: 'גוסטב הרץ' },
  { value: 'glashow-sheldon', label: 'גלשאו שלדון' },
  { value: 'harry-markowitz', label: 'הארי מרקוביץ' },
  { value: 'hoffmann-roald', label: 'הופמן רואלד' },
  { value: 'haise-paul', label: 'הייז פול' },
  { value: 'herbert-simon', label: 'הרברט סיימון' },
  { value: 'warmes-harold', label: 'ורמוס הרולד' },
  { value: 'sachs-nelly', label: 'זק"ס נלי' },
  { value: 'yalow-rosalyn', label: 'יאלו רוזלין' },
  { value: 'joseph-brodsky', label: 'יוסף ברודסקי' },
  { value: 'isaac-bashevis-singer', label: 'יצחק בשביס זינגר' },
  { value: 'bernard-katz', label: 'כ"ץ סר ברנרד' },
  { value: 'lev-landau-davidovich', label: 'לב לנדאו דוידוביץ' },
  { value: 'lurija-salvador', label: 'לוריא סלבדור' },
  { value: 'lorenz-klein', label: 'לורנץ קליין' },
  { value: 'leonid-kantorovich', label: 'ליאוניד קנטורוביץ' },
  { value: 'murray-gell-mann', label: 'מוריי גל-מן' },
  { value: 'milton-friedman', label: 'מילטון פרידמן' },
  { value: 'peace-circle', label: 'מעגל השלום' },
  { value: 'nadine-gordimer', label: 'נדין גורדימר' },
  { value: 'daniel-nathans', label: 'נתנס דניאל' },
  { value: 'samuelson-paul', label: 'סמואלסון פול' },
  { value: 'canetti-elias', label: 'קאנטי אליאס' },
  { value: 'rabi-isaac-isdor', label: 'רבי יצחק איזידור' },
  { value: 'robert-fogel', label: 'רוברט פוגל' },
  { value: 'richard-feynman', label: 'ריצארד פיינמן' },
  { value: 'shimon-peres', label: 'שמעון פרס' },
  { value: 'simon-kuznets', label: 'שמעון קוזנץ' }
],
   'kiryat-rishon': [
  { value: 'golda-meir', label: 'גולדה מאיר' },
  { value: 'ha-iris', label: 'האיריס' },
  { value: 'ha-gome', label: 'הגומא' },
  { value: 'ha-zahavit', label: 'הזהבית' },
  { value: 'ha-khalmonit', label: 'החלמונית' },
  { value: 'ha-khartzit', label: 'החרצית' },
  { value: 'ha-yakinton', label: 'היקינטון' },
  { value: 'ha-lotem', label: 'הלוטם' },
  { value: 'ha-moran', label: 'המורן' },
  { value: 'ha-marganit', label: 'המרגנית' },
  { value: 'ha-nofer', label: 'הנופר' },
  { value: 'ha-nurit', label: 'הנורית' },
  { value: 'ha-narkis', label: 'הנרקיס' },
  { value: 'ha-sakhlav', label: 'הסחלב' },
  { value: 'ha-sigalit', label: 'הסיגלית' },
  { value: 'ha-sitvanit', label: 'הסתוונית' },
  { value: 'ha-pereg', label: 'הפרג' },
  { value: 'ha-tzivoni', label: 'הצבעוני' },
  { value: 'ha-tziporen', label: 'הציפורן' },
  { value: 'ha-rotem', label: 'הרותם' },
  { value: 'ha-turmus', label: 'התורמוס' }
],
     'kiryat-simkha': [
  { value: 'aaleh-betamar', label: 'אעלה בתמר' },
  { value: 'baruch-sharoni', label: 'ברוך שרוני' },
  { value: 'hapalmach', label: 'הפלמ"ח' },
  { value: 'chaim-ben-efraim', label: 'חיים בן אפרים' },
  { value: 'yehoshua-gibstein', label: 'יהושע גיבשטיין' },
  { value: 'tzadok-ve-malka-kamus', label: 'צדוק ומלכה כמוס' },
  { value: 'kirzhner', label: 'קירז\'נר' },
  { value: 'shlomo-araki', label: 'שלמה עראקי' },
  { value: 'simcha-holtzberg', label: 'שמחה הולצברג' },
  { value: 'shkolnik', label: 'שקולניק' }
],
    'rishonim': [
  { value: 'egozey', label: 'אגוזי' },
  { value: 'aharon-kron', label: 'אהרון קרון' },
  { value: 'ashed', label: 'אשד' },
  { value: 'bilu', label: 'ביל"ו' },
  { value: 'ben-yehuda', label: 'בן יהודה' },
  { value: 'bakerman-adam', label: 'בקרמן אדם' },
  { value: 'bar-ilan', label: 'בר-אילן' },
  { value: 'gevim', label: 'גבים' },
  { value: 'gavriyahu', label: 'גבריהו' },
  { value: 'gluskin', label: 'גלוסקין' },
  { value: 'dr-elikom', label: 'ד"ר אליקום' },
  { value: 'david-ben-pinchas', label: 'דוד בן פנחס' },
  { value: 'david-yellin', label: 'דוד ילין' },
  { value: 'haachim-ostashinski', label: 'האחים אוסטשינסקי' },
  { value: 'haari', label: 'האר"י' },
  { value: 'habaal-shem-tov', label: 'הבעל שם טוב' },
  { value: 'hakarmel', label: 'הכרמל' },
  { value: 'hamusharer-shalom', label: 'המושרר שלום' },
  { value: 'hanatziv-mi-volozhin', label: 'הנצי"ב מוולוז\'ין' },
  { value: 'hapalmach', label: 'הפלמ"ח' },
  { value: 'harav-nissim', label: 'הרב ניסים' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'zelig-shimshon', label: 'זליג שמשון' },
  { value: 'chaim-ve-pnia-chisin', label: 'חיים ופניה חיסין' },
  { value: 'chalutzei-yesod-hamala', label: 'חלוצי יסוד המעלה' },
  { value: 'chankin', label: 'חנקין' },
  { value: 'tabib', label: 'טביב' },
  { value: 'tahon', label: 'טהון' },
  { value: 'tiomkin', label: 'טיומקין' },
  { value: 'yudilovich', label: 'יודילוביץ\'' },
  { value: 'itzhak-berger', label: 'יצחק ברגר' },
  { value: 'itzhak-musal', label: 'יצחק מוסאל' },
  { value: 'itzhak-tsarnov', label: 'יצחק צרנוב' },
  { value: 'levontin', label: 'לבונטין' },
  { value: 'levi-yitzhak-mi-barditchev', label: 'לוי יצחק מברדיצ\'ב' },
  { value: 'meirovitz', label: 'מאירוביץ' },
  { value: 'mechali-halevi', label: 'מחלי הלוי' },
  { value: 'michal-puchachevsky', label: 'מיכל פוחצ\'בסקי' },
  { value: 'neve-zion', label: 'נווה ציון' },
  { value: 'nordau', label: 'נורדאו' },
  { value: 'sokolov', label: 'סוקולוב' },
  { value: 'smilanski', label: 'סמילנסקי' },
  { value: 'fayess', label: 'פייס' },
  { value: 'peleg', label: 'פלג' },
  { value: 'pinchasovitz', label: 'פנחסוביץ' },
  { value: 'peretz-karlen', label: 'פרץ קרלן' },
  { value: 'ruphyn', label: 'רופין' },
  { value: 'rokach', label: 'רוקח' },
  { value: 'reiness', label: 'ריינס' },
  { value: 'shivat-zion', label: 'שיבת ציון' },
  { value: 'shimshon-belkind', label: 'שמשון בלקינד' }
],
      'revivim': [
  { value: 'avidan-shimon', label: 'אבידן שמעון' },
  { value: 'aviezer', label: 'אביעזר' },
  { value: 'olga-v-yehoshua', label: 'אולגה ויהושע' },
  { value: 'arya-gershoni', label: 'אריה גרשוני' },
  { value: 'bar-kochva', label: 'בר-כוכבא' },
  { value: 'goldberg-hanadvan', label: 'גולדברג הנדבן' },
  { value: 'gush-chalav', label: 'גוש חלב' },
  { value: 'dori', label: 'דורי' },
  { value: 'haechad-asar', label: 'האחד עשר' },
  { value: 'hachashmonaim', label: 'החשמונאים' },
  { value: 'hanachal', label: 'הנח"ל' },
  { value: 'harav-shmuel-trovitz', label: 'הרב שמואל טרוביץ' },
  { value: 'chaim-sharf', label: 'חיים שרף' },
  { value: 'yair', label: 'יאיר' },
  { value: 'yehuda-sagis', label: 'יהודה סגיס' },
  { value: 'yoel-cohen', label: 'יואל כהן' },
  { value: 'yosef-klauzner', label: 'יוסף קלוזנר' },
  { value: 'yerushalayim', label: 'ירושלים' },
  { value: 'yisrael-v-fani', label: 'ישראל ופאני' },
  { value: 'modiin', label: 'מודיעין' },
  { value: 'metzada', label: 'מצדה' },
  { value: 'kaliv', label: 'קאליב' },
  { value: 'shlomo', label: 'שלמה' },
  { value: 'shmuel-sharira', label: 'שמואל שרירא' }
],
      'rambam': [
  { value: 'abravanel', label: 'אברבנאל' },
  { value: 'echad-haam', label: 'אחד העם' },
  { value: 'achi-ezer', label: 'אחיעזר' },
  { value: 'eizenband', label: 'אייזנבנד' },
  { value: 'itamar-ben-avi', label: 'איתמר בן אב"י' },
  { value: 'alkalay', label: 'אלקלעי' },
  { value: 'elroi', label: 'אלרואי' },
  { value: 'arya-rafael', label: 'אריה רפאל' },
  { value: 'asher-barash', label: 'אשר ברש' },
  { value: 'asher-levin', label: 'אשר לוין' },
  { value: 'beit-yosef', label: 'בית יוסף' },
  { value: 'balfour', label: 'בלפור' },
  { value: 'ben-zeev', label: 'בן זאב' },
  { value: 'betsalel', label: 'בצלאל' },
  { value: 'brandeis', label: 'ברנדייס' },
  { value: 'givati', label: 'גבעתי' },
  { value: 'gush-etzion', label: 'גוש עציון' },
  { value: 'degania', label: 'דגניה' },
  { value: 'david-elazar', label: 'דוד אלעזר' },
  { value: 'david-haroevni', label: 'דוד הראובני' },
  { value: 'dror', label: 'דרור' },
  { value: 'haachim-suliman', label: 'האחים סולימן' },
  { value: 'hagaon-mi-vilna', label: 'הגאון מוילנה' },
  { value: 'hagdud-haivri', label: 'הגדוד העברי' },
  { value: 'hachafetz-chaim', label: 'החפץ חיים' },
  { value: 'heisman', label: 'הייסמן' },
  { value: 'hakovesh', label: 'הכובש' },
  { value: 'hakuzari', label: 'הכוזרי' },
  { value: 'hakarmel', label: 'הכרמל' },
  { value: 'hameyasdim', label: 'המיסדים' },
  { value: 'hanegev', label: 'הנגב' },
  { value: 'harav-brock', label: 'הרב ברוק' },
  { value: 'harav-herzog', label: 'הרב הרצוג' },
  { value: 'harav-zinger', label: 'הרב זינגר' },
  { value: 'harav-charlap', label: 'הרב חרל"פ' },
  { value: 'harav-maimon', label: 'הרב מימון' },
  { value: 'harav-sobhi', label: 'הרב סובהי' },
  { value: 'harav-uziel', label: 'הרב עוזיאל' },
  { value: 'harav-kook', label: 'הרב קוק' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'vigodsky', label: 'ויגודסקי' },
  { value: 'stephen-wise', label: 'וייז סטפן' },
  { value: 'witzbard', label: 'ויצברד' },
  { value: 'vitkin', label: 'ויתקין' },
  { value: 'waksler-moshe', label: 'וקסלר משה' },
  { value: 'zedel', label: 'זדל' },
  { value: 'chabad', label: 'חב"ד' },
  { value: 'chazon-ish', label: 'חזון איש' },
  { value: 'krayati-unit', label: 'חטיבת קרייתי' },
  { value: 'chis', label: 'חי"ש' },
  { value: 'yehuda', label: 'יהודה' },
  { value: 'yehuda-halevi', label: 'יהודה הלוי' },
  { value: 'yehuda-leib', label: 'יהודה לייב' },
  { value: 'yehuda-ragonis', label: 'יהודה רגוניס' },
  { value: 'yehuda-shagai', label: 'יהודה שגיא' },
  { value: 'yochanan-hasandler', label: 'יוחנן הסנדלר' },
  { value: 'yosef-halevi', label: 'יוסף הלוי' },
  { value: 'yosef-feinberg', label: 'יוסף פיינברג' },
  { value: 'yosef-karo', label: 'יוסף קארו' },
  { value: 'yerushalayim', label: 'ירושלים' },
  { value: 'mohliver', label: 'מוהליבר' },
  { value: 'mizrahi-moshe', label: 'מזרחי משה' },
  { value: 'maklef', label: 'מקלף' },
  { value: 'margolin', label: 'מרגולין' },
  { value: 'mordechai-rosenstein', label: 'מרדכי רוזנשטיין' },
  { value: 'naharaim', label: 'נהריים' },
  { value: 'nordau', label: 'נורדאו' },
  { value: 'nechama', label: 'נחמה' },
  { value: 'naomi-persol', label: 'נעמי פרסול' },
  { value: 'senior', label: 'סניור' },
  { value: 'atarot', label: 'עטרות' },
  { value: 'ein-hakore', label: 'עין הקורא' },
  { value: 'ein-tzurim', label: 'עין צורים' },
  { value: 'fishelzon', label: 'פישלזון' },
  { value: 'frank-zvi', label: 'פרנק צבי' },
  { value: 'tzg-banot', label: 'צ"ג בנות' },
  { value: 'kadosh-hashem', label: 'קדוש השם' },
  { value: 'klivitzky', label: 'קליביצקי' },
  { value: 'kretzchevsky', label: 'קרצבסקי' },
  { value: 'revadim', label: 'רבדים' },
  { value: 'rothschild', label: 'רוטשילד' },
  { value: 'rambam', label: 'רמב"ם' },
  { value: 'rashi', label: 'רש"י' },
  { value: 'shlomo-eliraz', label: 'שלמה אלירז' },
  { value: 'shlomo-molcho', label: 'שלמה מולכו' },
  { value: 'tanchum', label: 'תנחום' },
  { value: 'tarmab', label: 'תרמ"ב' }
],
        'remez': [
  { value: 'avraham-barad', label: 'אברהם ברד' },
  { value: 'arbel', label: 'ארבל' },
  { value: 'arya-sheftel', label: 'אריה שפטל' },
  { value: 'ben-eliezer', label: 'בן אליעזר' },
  { value: 'binyamin-fein', label: 'בנימין פיין' },
  { value: 'bernicki-natan', label: 'ברניצקי נתן' },
  { value: 'gur', label: 'גור' },
  { value: 'druvin-yoel', label: 'דרובין יואל' },
  { value: 'haachim-smilchenski', label: 'האחים סמילצ\'נסקי' },
  { value: 'haem', label: 'האם' },
  { value: 'haben-harishon', label: 'הבן הראשון' },
  { value: 'habashan', label: 'הבשן' },
  { value: 'hagalil', label: 'הגליל' },
  { value: 'hagilad', label: 'הגלעד' },
  { value: 'hagefen', label: 'הגפן' },
  { value: 'hahadarim', label: 'ההדרים' },
  { value: 'horovitz', label: 'הורוביץ' },
  { value: 'hazayit', label: 'הזית' },
  { value: 'hakharmon', label: 'החרמון' },
  { value: 'hayarden', label: 'הירדן' },
  { value: 'hayarmukh', label: 'הירמוך' },
  { value: 'hayarkon', label: 'הירקון' },
  { value: 'hirschfeld', label: 'הירשפלד' },
  { value: 'hakishon', label: 'הקישון' },
  { value: 'harav-yanovsky', label: 'הרב ינובסקי' },
  { value: 'harimon', label: 'הרימון' },
  { value: 'hasadeh', label: 'השדה' },
  { value: 'hashaked', label: 'השקד' },
  { value: 'hashikma', label: 'השקמה' },
  { value: 'hataena', label: 'התאנה' },
  { value: 'hatavor', label: 'התבור' },
  { value: 'hatomer', label: 'התומר' },
  { value: 'wolfson', label: 'וולפסון' },
  { value: 'vinik', label: 'ויניק' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'yavneh-eli', label: 'יבנאלי' },
  { value: 'yabarboym', label: 'יברבוים' },
  { value: 'itzhak-sadeh', label: 'יצחק שדה' },
  { value: 'kinneret', label: 'כינרת' },
  { value: 'mania-shochat', label: 'מניה שוחט' },
  { value: 'nahal-shorek', label: 'נחל שורק' },
  { value: 'olei-hagardom', label: 'עולי הגרדום' },
  { value: 'chelnov', label: 'צ\'לנוב' },
  { value: 'tzallichin', label: 'צלליכין' },
  { value: 'kaplanski', label: 'קפלנסקי' },
  { value: 'reuven', label: 'ראובן' },
  { value: 'rothschild', label: 'רוטשילד' },
  { value: 'remez', label: 'רמז' },
  { value: 'shprintzak', label: 'שפרינצק' }
],
      'ramat-eliyahu': [
  { value: 'abu-khatzeira', label: 'אבו חצירה' },
  { value: 'anilevich', label: 'אנילביץ' },
  { value: 'ariav-haim', label: 'אריאב חיים' },
  { value: 'arnon-moshe', label: 'ארנון משה' },
  { value: 'esh-shalom', label: 'אש שלום' },
  { value: 'ben-zvi-itzhak', label: 'בן צבי יצחק' },
  { value: 'golinkin', label: 'גולינקין' },
  { value: 'david-hamelech', label: 'דוד המלך' },
  { value: 'david-tidhar', label: 'דוד תדהר' },
  { value: 'hagalim', label: 'הגלים' },
  { value: 'hadugit', label: 'הדוגית' },
  { value: 'hachalutz', label: 'החלוץ' },
  { value: 'haknesset', label: 'הכנסת' },
  { value: 'hanakhshol', label: 'הנחשול' },
  { value: 'hatzfira', label: 'הצפירה' },
  { value: 'harav-haim-chadad', label: 'הרב חיים חדד' },
  { value: 'harav-minz', label: 'הרב מינץ' },
  { value: 'harav-nurok', label: 'הרב נורוק' },
  { value: 'hashoftim', label: 'השופטים' },
  { value: 'wolf-wilensky', label: 'וולף וילנסקי' },
  { value: 'zalman-shneur', label: 'זלמן שניאור' },
  { value: 'chana-senesh', label: 'חנה סנש' },
  { value: 'yanush-korczak', label: 'יאנוש קורצ\'אק' },
  { value: 'yaakov-cohen', label: 'יעקב כהן' },
  { value: 'malchey-israel', label: 'מלכי ישראל' },
  { value: 'menachem-poznanski', label: 'מנחם פוזננסקי' },
  { value: 'meshorer-hashoah', label: 'משורר השואה' },
  { value: 'natan-shlomo', label: 'נתן שלמה' },
  { value: 'silver', label: 'סילבר' },
  { value: 'sfinat-hashlosha', label: 'ספינת השלושה' },
  { value: 'ezra-uvetzron', label: 'עזרה ובצרון' },
  { value: 'tzaitlin', label: 'צייטלין' },
  { value: 'kehilat-new-jersey', label: 'קהילת ניו ג\'רסי' },
  { value: 'shai-agnon', label: 'ש"י עגנון' },
  { value: 'shaul-hamelech', label: 'שאול המלך' },
  { value: 'shlomo-hamelech', label: 'שלמה המלך' },
  { value: 'shmuel-hanavi', label: 'שמואל הנביא' },
  { value: 'sarah-aaronson', label: 'שרה אהרונסון' },
  { value: 'torah-vaavoda', label: 'תורה ועבודה' }
],
      'shikun-ha-mizrah': [
  { value: 'alfasi', label: 'אלפסי' },
  { value: 'asirei-tzion', label: 'אסירי ציון' },
  { value: 'efraim-kishon', label: 'אפרים קישון' },
  { value: 'arik-einstein', label: 'אריק איינשטיין' },
  { value: 'ben-zakkai', label: 'בן זכאי' },
  { value: 'barak', label: 'ברק' },
  { value: 'gidon', label: 'גדעון' },
  { value: 'devora-hanevia', label: 'דבורה הנביאה' },
  { value: 'daniel-hanavi', label: 'דניאל הנביא' },
  { value: 'drabla', label: 'דרבלה' },
  { value: 'haegoz', label: 'האגוז' },
  { value: 'haoren', label: 'האורן' },
  { value: 'haelah', label: 'האלה' },
  { value: 'haalon', label: 'האלון' },
  { value: 'haamoraim', label: 'האמוראים' },
  { value: 'haerez', label: 'הארז' },
  { value: 'haeshel', label: 'האשל' },
  { value: 'haetrogh', label: 'האתרוג' },
  { value: 'habrosh', label: 'הברוש' },
  { value: 'haduda-im', label: 'הדודאים' },
  { value: 'hadekel', label: 'הדקל' },
  { value: 'hahadas', label: 'ההדס' },
  { value: 'havard', label: 'הוורד' },
  { value: 'hazamir', label: 'הזמיר' },
  { value: 'hachavatzelet', label: 'החבצלת' },
  { value: 'hachatzav', label: 'החצב' },
  { value: 'hacharuv', label: 'החרוב' },
  { value: 'hakalanit', label: 'הכלנית' },
  { value: 'hakarkom', label: 'הכרכום' },
  { value: 'halulav', label: 'הלולב' },
  { value: 'hamaapilim', label: 'המעפילים' },
  { value: 'haneviim', label: 'הנביאים' },
  { value: 'hanotrim', label: 'הנוטרים' },
  { value: 'haperach', label: 'הפרח' },
  { value: 'hatzealim', label: 'הצאלים' },
  { value: 'hatzabar', label: 'הצבר' },
  { value: 'hakanaim', label: 'הקנאים' },
  { value: 'harav-taieb', label: 'הרב טייב' },
  { value: 'harakefet', label: 'הרקפת' },
  { value: 'hashezif', label: 'השזיף' },
  { value: 'hatanaim', label: 'התנאים' },
  { value: 'hatapuach', label: 'התפוח' },
  { value: 'zeev', label: 'זאב' },
  { value: 'zerubavel', label: 'זרובבל' },
  { value: 'chaggai-hanavi', label: 'חגי הנביא' },
  { value: 'yonah-hanavi', label: 'יונה הנביא' },
  { value: 'yosef-hanasi', label: 'יוסף הנשיא' },
  { value: 'yechezkel-hanavi', label: 'יחזקאל הנביא' },
  { value: 'yaakov', label: 'יעקב' },
  { value: 'yirmiyahu', label: 'ירמיהו' },
  { value: 'yeshayahu', label: 'ישעיהו' },
  { value: 'meir-avner', label: 'מאיר אבנר' },
  { value: 'mordey-hagetaot', label: 'מורדי הגטאות' },
  { value: 'malachi', label: 'מלאכי' },
  { value: 'maapilei-maroko', label: 'מעפילי מרוקו' },
  { value: 'maapilei-kafrisin', label: 'מעפילי קפריסין' },
  { value: 'marvad-haksamim', label: 'מרבד הקסמים' },
  { value: 'nechemya', label: 'נחמיה' },
  { value: 'struma', label: 'סטרומה' },
  { value: 'ovadia', label: 'עובדיה' },
  { value: 'ezra', label: 'עזרא' },
  { value: 'amos-hanavi', label: 'עמוס הנביא' },
  { value: 'patriya', label: 'פטרייה' },
  { value: 'raava', label: 'ראב"ע' },
  { value: 'rabi-tarfon', label: 'רבי טרפון' },
  { value: 'rabi-meir', label: 'רבי מאיר' },
  { value: 'rabi-akiva', label: 'רבי עקיבא' },
  { value: 'radak', label: 'רד"ק' },
  { value: 'shvtei-yisrael', label: 'שבטי ישראל' }
],
        'sha-ar-ha-yam': [
  { value: 'akhi-gaash', label: 'אח"י געש' },
  { value: 'akhi-dakar', label: 'אח"י דקר' },
  { value: 'akhi-chanit', label: 'אח"י חנית' },
  { value: 'akhi-lehav', label: 'אח"י להב' },
  { value: 'akhi-mivtakh', label: 'אח"י מבטח' },
  { value: 'akhi-meznek', label: 'אח"י מזנק' },
  { value: 'akhi-misgav', label: 'אח"י משגב' },
  { value: 'akhi-sufa', label: 'אח"י סופה' },
  { value: 'akhi-seara', label: 'אח"י סער' },
  { value: 'hatayelet', label: 'הטיילת' },
  { value: 'hashayetet', label: 'השייטת' },
  { value: 'mivtsa-noa', label: 'מבצע נועה' }
],
        'kiryat-haum': [
  { value: 'ha-aluf-david', label: 'האלוף דוד' },
  { value: 'israel-galili', label: 'ישראל גלילי' },
  { value: 'mishar', label: 'מיש"ר' }
],
      'merkaz-rishon': [
  { value: 'batalem', label: 'בתלם' },
  { value: 'hityashvut', label: 'ההתיישבות' },
  { value: 'katriel', label: 'כתריאל' },
  { value: 'nirim', label: 'נירים' }
]
                
  },
  'ramat-gan': {
  'yad-levanim': [
    { value: 'aluf-hanitzahon', label: 'אלוף הניצחון' },
    { value: 'aluf-nehemia-tamari', label: 'אלוף נחמיה תמרי' },
    { value: 'barkai', label: 'ברקאי' },
    { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
    { value: 'haagada', label: 'האגדה' },
    { value: 'haamoraim', label: 'האמוראים' },
    { value: 'habanim', label: 'הבנים' },
    { value: 'halakha', label: 'ההלכה' },
    { value: 'hanakhal', label: 'הנח"ל' },
    { value: 'hasneh', label: 'הסנה' },
    { value: 'haraa', label: 'הרא"ה' },
    { value: 'hashakhar', label: 'השחר' },
    { value: 'hashiloakh', label: 'השילוח' },
    { value: 'zalman-shneor', label: 'זלמן שניאור' },
    { value: 'khevat-tzion', label: 'חיבת ציון' },
    { value: 'hatzor', label: 'חצור' },
    { value: 'yedidya', label: 'ידידיה' },
    { value: 'yehuda-guri', label: 'יהודה גורי' },
    { value: 'yehuda-hanasi', label: 'יהודה הנשיא' },
    { value: 'yerushalayim', label: 'ירושלים' },
    { value: 'lavi', label: 'לביא' },
    { value: 'lokhamei-sinai', label: 'לוחמי סיני' },
    { value: 'moriah', label: 'מוריה' },
    { value: 'sanhedrin', label: 'סנהדרין' },
    { value: 'uziel', label: 'עוזיאל' },
    { value: 'amikam', label: 'עמיקם' },
    { value: 'etzion', label: 'עציון' },
    { value: 'tzel-hagivah', label: 'צל הגבעה' },
    { value: 'kraske', label: 'קרסקי' },
    { value: 'shualei-shimshon', label: 'שועלי שמשון' },
    { value: 'tirtza', label: 'תרצה' }
  ],
    'tal-givim': [
    { value: 'irena-sendler', label: 'אירנה סנדלר' },
    { value: 'gideon', label: 'גדעון' },
    { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
    { value: 'haportzim', label: 'הפורצים' },
    { value: 'yosef-tsvi', label: 'יוסף צבי' },
    { value: 'yiftach', label: 'יפתח' },
    { value: 'itzhak-rabin', label: 'יצחק רבין' },
    { value: 'mordechai', label: 'מרדכי' },
    { value: 'uziel', label: 'עוזיאל' },
    { value: 'kish', label: 'קיש' },
    { value: 'sha-ar-hagay', label: 'שער הגיא' }
  ],

  'ramat-amidar': [
    { value: 'a-rom', label: 'א-רום' },
    { value: 'even-avitour', label: 'אבן אביתור' },
    { value: 'even-haviv', label: 'אבן חביב' },
    { value: 'avnei-hachoshen', label: 'אבני החושן' },
    { value: 'etzl', label: 'אצ"ל' },
    { value: 'arya-ben-eliezer', label: 'אריה  בן אליעזר' },
    { value: 'dangor', label: 'דנגור' },
    { value: 'habashan', label: 'הבשן' },
    { value: 'hagolan', label: 'הגולן' },
    { value: 'hagana', label: 'הגנה' },
    { value: 'hachermon', label: 'החרמון' },
    { value: 'hamachteret', label: 'המחתרת' },
    { value: 'harav-levin', label: 'הרב לוין' },
    { value: 'harav-landers', label: 'הרב לנדרס' },
    { value: 'hatfutzot', label: 'התפוצות' },
    { value: 'chazon-ish', label: 'חזון איש' },
    { value: 'yaavetz', label: 'יעבץ' },
    { value: 'lehi', label: 'לח"י' },
    { value: 'mivtza-ayin', label: 'מבצע עין' },
    { value: 'matityahu-mendel', label: 'מתתיהו מנדל' },
    { value: 'nehardea', label: 'נהרדעא' },
    { value: 'sura', label: 'סורא' },
    { value: 'sayeret-duchifat', label: 'סיירת דוכיפת' },
    { value: 'olei-hagardom', label: 'עולי הגרדום' },
    { value: 'pumbedita', label: 'פומבדיתא' },
    { value: 'komemiyut', label: 'קוממיות' },
    { value: 'rudin', label: 'רודין' },
    { value: 'shrira-gaon', label: 'שרירא גאון' }
  ],
    'shkhunat-mizrahit': [
    { value: 'even-ezra', label: 'אבן עזרא' },
    { value: 'altalena', label: 'אלטלנה' },
    { value: 'etzl', label: 'אצ"ל' },
    { value: 'arya-ben-eliezer', label: 'אריה בן אליעזר' },
    { value: 'be-er-ora', label: 'באר אורה' },
    { value: 'ben-saruk', label: 'בן סרוק' },
    { value: 'gershom', label: 'גרשום' },
    { value: 'donash', label: 'דונש' },
    { value: 'hayarden', label: 'הירדן' },
    { value: 'haraav-a', label: 'הראב"ע' },
    { value: 'harabi-miruzhin', label: 'הרבי מריז\'ין' },
    { value: 'zecharya-chami', label: 'זכריה חמי' },
    { value: 'yosef-karo', label: 'יוסף קארו' },
    { value: 'yeshurun', label: 'ישורון' },
    { value: 'metula', label: 'מטולה' },
    { value: 'mishmar-hayarden', label: 'משמר הירדן' },
    { value: 'negba', label: 'נגבה' },
    { value: 'pinchas', label: 'פנחס' },
    { value: 'pinkas', label: 'פנקס' },
    { value: 'profess', label: 'פרופס' },
    { value: 'rosh-pina', label: 'ראש פינה' },
    { value: 'tiferet-yisrael', label: 'תפארת ישראל' }
  ],
    'mitkham-givah': [
    { value: 'amir', label: 'אמיר' },
    { value: 'ephraim', label: 'אפרים' },
    { value: 'baal-shem-tov', label: 'בעל שם-טוב' },
    { value: 'bar-yochai', label: 'בר-יוחאי' },
    { value: 'bat-shua', label: 'בת-שוע' },
    { value: 'devorah-hanevia', label: 'דבורה הנביאה' },
    { value: 'haari', label: 'האר"י' },
    { value: 'hachayal', label: 'החי"ל' },
    { value: 'hayad-hazaka', label: 'היד החזקה' },
    { value: 'hayarden', label: 'הירדן' },
    { value: 'hatzanhanim', label: 'הצנחנים' },
    { value: 'haraeh', label: 'הרא"ה' },
    { value: 'haraubeni', label: 'הראובני' },
    { value: 'hashikma', label: 'השקמה' },
    { value: 'hasar-moshe', label: 'השר משה' },
    { value: 'had-nes', label: 'חד נס' },
    { value: 'harod', label: 'חרוד' },
    { value: 'truman', label: 'טרומן' },
    { value: 'yud-alef-beadar', label: 'י"א באדר' },
    { value: 'yael-hagibora', label: 'יעל הגיבורה' },
    { value: 'negba', label: 'נגבה' },
    { value: 'neve-yaakov', label: 'נווה יעקב' },
    { value: 'nachala', label: 'נחלה' },
    { value: 'nirdimon', label: 'נרדימון' },
    { value: 'uziel', label: 'עוזיאל' },
    { value: 'aminadav', label: 'עמינדב' },
    { value: 'pinchas', label: 'פנחס' },
    { value: 'ptaya', label: 'פתייה' },
    { value: 'shlomtzion', label: 'שלומציון' },
    { value: 'tel-hai', label: 'תל חי' }
  ],

  'tal-yehuda': [
    { value: 'avishai', label: 'אבישי' },
    { value: 'ehud', label: 'אהוד' },
    { value: 'aluf-hanitzahon', label: 'אלוף הניצחון' },
    { value: 'elyashiv', label: 'אלישיב' },
    { value: 'elroi', label: 'אלרואי' },
    { value: 'amnon-ve-tamar', label: 'אמנון ותמר' },
    { value: 'beit-lehem', label: 'בית לחם' },
    { value: 'ben-gurion-david', label: 'בן גוריון דוד' },
    { value: 'bar-kochva', label: 'בר-כוכבא' },
    { value: 'hamelech-yosef', label: 'המלך יוסף' },
    { value: 'haraeh', label: 'הרא"ה' },
    { value: 'harechasim', label: 'הרכסים' },
    { value: 'hashoshan', label: 'השושן' },
    { value: 'hatichon', label: 'התיכון' },
    { value: 'havazelet', label: 'חבצלת' },
    { value: 'chevron', label: 'חברון' },
    { value: 'churgin', label: 'חורגין' },
    { value: 'yad-shalom', label: 'יד שלום' },
    { value: 'yerushalayim', label: 'ירושלים' },
    { value: 'yericho', label: 'יריחו' },
    { value: 'knafey-nesharim', label: 'כנפי נשרים' },
    { value: 'motza', label: 'מוצא' },
    { value: 'moria', label: 'מוריה' },
    { value: 'michael', label: 'מיכאל' },
    { value: 'salek', label: 'סאלק' },
    { value: 'uziel', label: 'עוזיאל' },
    { value: 'atarot', label: 'עטרות' },
    { value: 'kedma', label: 'קדמה' },
    { value: 'ruchama', label: 'רוחמה' },
    { value: 'tirza', label: 'תרצה' }
  ],

  'bar-ilan': [
    { value: 'bar-ilan-university', label: 'אוניברסיטת בר-אילן' }
  ],
    'kiryat-krinzki': [
  { value: 'oren', label: 'אורן' },
  { value: 'brosh', label: 'ברוש' },
  { value: 'bshamet', label: 'בשמת' },
  { value: 'gildesheim', label: 'גילדסגיים' },
  { value: 'gaponov', label: 'גפונוב' },
  { value: 'dr-eliayhu', label: 'ד"ר אליהו' },
  { value: 'dan-shomron', label: 'דן שומרון' },
  { value: 'haakhot-chaya', label: 'האחות חיה' },
  { value: 'haachim-litvinski', label: 'האחים ליטוינסקי' },
  { value: 'hailanot', label: 'האילנות' },
  { value: 'hadas', label: 'הדס' },
  { value: 'hameiri', label: 'המאירי' },
  { value: 'chaim-bar-lev', label: 'חיים בר-לב' },
  { value: 'yona-eitan', label: 'יונה איתן' },
  { value: 'yosef-sapir', label: 'יוסף ספיר' },
  { value: 'yaakov-cohen', label: 'יעקב כהן' },
  { value: 'yaara', label: 'יערה' },
  { value: 'leib-yafe', label: 'לייב יפה' },
  { value: 'mandes', label: 'מנדס' },
  { value: 'sigalit', label: 'סיגלית' },
  { value: 'emek-haela', label: 'עמק האלה' },
  { value: 'katzir', label: 'קציר' },
  { value: 'roi-klein', label: 'רועי קליין' },
  { value: 'rotem', label: 'רותם' },
  { value: 'shlomo-malkhi', label: 'שלמה מלחי' }
],
'ben-goryon': [
{ value: 'avtalyon', label: 'אבטליון' },
{ value: 'moshe-sharet', label: 'משה שרת' },
{ value: 'hachayal-haalmoni', label: 'החייל האלמוני' },
{ value: 'haraeh', label: 'הרא"ה' },
{ value: 'hagat', label: 'הגת' },
{ value: 'krinitzi', label: 'קריניצי' },
{ value: 'magadim', label: 'מגדים' },
{ value: 'yosef-hagalili', label: 'יוסף הגלילי' },
{ value: 'haprasa', label: 'הפרסה' },
  { value: 'mevo-natan', label: 'מבוא נתן' },
  { value: 'shederot-avrham', label: 'שדרות אברהם' }
  
  ],
'merkaz-hair-g': [
  { value: 'avraham', label: 'אברהם' },
  { value: 'elimelekh', label: 'אלימלך' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'dr-cohen', label: 'ד"ר כהן' },
  { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'hagiborim', label: 'הגיבורים' },
  { value: 'hayeled', label: 'הילד' },
  { value: 'hanesher', label: 'הנשר' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'hatmarim', label: 'התמרים' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'zar', label: 'ז"ר' },
  { value: 'zeev', label: 'זאב' },
  { value: 'zohar', label: 'זוהר' },
  { value: 'yahalom', label: 'יהל"ם (יהודה לייב מוצקין)' },
  { value: 'yohanna', label: 'יוהנה' },
  { value: 'yosefi', label: 'יוספי' },
  { value: 'lamdan', label: 'למדן' },
  { value: 'natan', label: 'נתן' },
  { value: 'krinitzi', label: 'קריניצי' },
  { value: 'siyon', label: 'שיאון' },
  { value: 'shtil', label: 'שתיל' }
],
    'merkaz-hair-b': [
  { value: 'orah', label: 'אורה' },
  { value: 'alexander', label: 'אלכסנדר' },
  { value: 'arya', label: 'אריה' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'david', label: 'דוד' },
  { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'haeshel', label: 'האש"ל' },
  { value: 'hagat', label: 'הגת' },
  { value: 'hazetim', label: 'הזיתים' },
  { value: 'hatayas', label: 'הטייס' },
  { value: 'hatman', label: 'הפטמן' },
  { value: 'haraeh', label: 'הרא"ה' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'mirkin', label: 'מירקין' },
  { value: 'nahalat-yosef', label: 'נחלת יוסף' },
  { value: 'natan', label: 'נתן' },
  { value: 'safrai', label: 'ספראי' },
  { value: 'klauser', label: 'קלאוזנר' },
  { value: 'krinitzi', label: 'קריניצי' },
  { value: 'shaanan', label: 'שאנן' },
  { value: 'shilah', label: 'שילה' }
],
    'merkaz-hair-a': [
  { value: 'arlozorov', label: 'ארלוזורוב' },
  { value: 'boaz', label: 'בועז' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'beit-el', label: 'בית אל' },
  { value: 'beit-horon', label: 'בית חורון' },
  { value: 'ben-yosef', label: 'בן יוסף' },
  { value: 'bar-giura', label: 'בר-גיורה' },
  { value: 'habeer', label: 'הבאר' },
  { value: 'hachashmonaim', label: 'החשמונאים' },
  { value: 'hamaccabi', label: 'המכבי' },
  { value: 'hamelech-yanai', label: 'המלך ינאי' },
  { value: 'hamaagal', label: 'המעגל' },
  { value: 'hamaalot', label: 'המעלות' },
  { value: 'hamatzir', label: 'המצי"ר' },
  { value: 'hamatmid', label: 'המתמיד' },
  { value: 'hanagid', label: 'הנגיד' },
  { value: 'hatzvi', label: 'הצבי' },
  { value: 'hatzofim', label: 'הצופים' },
  { value: 'harav-chava-elia', label: 'הרב חבה אליה' },
  { value: 'hashoteret', label: 'השוטרת' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'yochanan', label: 'יוחנן' },
  { value: 'laan', label: 'לאן' },
  { value: 'levi', label: 'לוי' },
  { value: 'mitzpe', label: 'מצפה' },
  { value: 'miryam', label: 'מרים' },
  { value: 'nordau', label: 'נורדאו' },
  { value: 'nechama', label: 'נחמה' },
  { value: 'perug-shimon', label: 'פרוג שמעון' }
],
    'vatikim': [
  { value: 'aba-achimeir', label: 'אב"א אחימאיר' },
  { value: 'aba-hillel', label: 'אבא הלל' },
  { value: 'avivim', label: 'אביבים' },
  { value: 'ankorim', label: 'אנקורים' },
  { value: 'hadrorim', label: 'הדרורים' },
  { value: 'hazamir', label: 'הזמיר' },
  { value: 'hakalanit', label: 'הכלניות' },
  { value: 'hamarganit', label: 'המרגנית' },
  { value: 'hanarkisim', label: 'הנרקיסים' },
  { value: 'haam-hatzarfati', label: 'העם הצרפתי' },
  { value: 'haarmonim', label: 'הערמונים' },
  { value: 'tovim', label: 'טובים' },
  { value: 'yaelim', label: 'יעלים' },
  { value: 'nurit', label: 'נורית' },
  { value: 'nachum-mozes', label: 'נח מוזס' },
  { value: 'nachlieli', label: 'נחליאלי' },
  { value: 'nitzanim', label: 'ניצנים' },
  { value: 'netz', label: 'נץ' },
  { value: 'samdar', label: 'סמדר' },
  { value: 'rokach', label: 'רוקח' },
  { value: 'ramba', label: 'רמבה' },
  { value: 'rananim', label: 'רננים' },
  { value: 'rakafet', label: 'רקפת' },
  { value: 'shoshanim', label: 'שושנים' },
  { value: 'shmueli', label: 'שמואלי' }
],
    'habursa': [
  { value: 'aba-hillel', label: 'אבא הלל' },
  { value: 'ohaliav', label: 'אהליאב' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'betsalel', label: 'בצלאל' },
  { value: 'haachim-bezharno', label: 'האחים בז\'רנו' },
  { value: 'hachilazon', label: 'החילזון' },
  { value: 'hayetzira', label: 'היצירה' },
  { value: 'harei-hagilad', label: 'הרי הגלעד' },
  { value: 'harkon', label: 'הרקון' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'yaakov-rozen', label: 'יעקב רוזן' },
  { value: 'menachem-begin', label: 'מנחם בגין' },
  { value: 'shoham', label: 'שוהם' },
  { value: 'tuval', label: 'תובל' },
  { value: 'taas', label: 'תע"ש' }
],
    'ramat-afal': [
  { value: 'agmon', label: 'אגמון' },
  { value: 'el-al', label: 'אל על' },
  { value: 'alomot', label: 'אלומות' },
  { value: 'almog', label: 'אלמוג' },
  { value: 'argaman', label: 'ארגמן' },
  { value: 'bareket', label: 'ברקת' },
  { value: 'grofrit', label: 'גרופית' },
  { value: 'dolev', label: 'דולב' },
  { value: 'haokhmaniot', label: 'האוכמניות' },
  { value: 'haoranim', label: 'האורנים' },
  { value: 'haatad', label: 'האטד' },
  { value: 'haela', label: 'האלה' },
  { value: 'haalon', label: 'האלון' },
  { value: 'haarazim', label: 'הארזים' },
  { value: 'haetrog', label: 'האתרוג' },
  { value: 'habroshim', label: 'הברושים' },
  { value: 'hadodaim', label: 'הדודאים' },
  { value: 'havared', label: 'הוורד' },
  { value: 'hachuga', label: 'החוגה' },
  { value: 'hachatzav', label: 'החצב' },
  { value: 'hacharuv', label: 'החרוב' },
  { value: 'hachartzit', label: 'החרצית' },
  { value: 'hayasmin', label: 'היסמין' },
  { value: 'halotus', label: 'הלוטוס' },
  { value: 'hanatziv', label: 'הנצי"ב' },
  { value: 'haarava', label: 'הערבה' },
  { value: 'hapragim', label: 'הפרגים' },
  { value: 'harduf', label: 'הרדוף' },
  { value: 'harkefet', label: 'הרקפת' },
  { value: 'hashita', label: 'השיטה' },
  { value: 'hashaked', label: 'השקד' },
  { value: 'yahalom', label: 'יהלום' },
  { value: 'lod', label: 'לוד' },
  { value: 'mehula', label: 'מחולה' },
  { value: 'mashoah', label: 'משואה' },
  { value: 'nevatim', label: 'נבטים' },
  { value: 'sapir', label: 'ספיר' },
  { value: 'tzofar', label: 'צופר' },
  { value: 'tzur', label: 'צור' },
  { value: 'kzita', label: 'קציעה' },
  { value: 'rimon', label: 'רימון' },
  { value: 'rafael-eitan', label: 'רפאל איתן' },
  { value: 'shacham', label: 'שחם' },
  { value: 'shiba', label: 'שיבא' },
  { value: 'shachtermann', label: 'שכטרמן' },
  { value: 'tidhar', label: 'תדהר' }
],
    'kfar-adar': [
  { value: 'ben-gurion', label: 'בן גוריון' },
  { value: 'hei-beiyar', label: "ה' באייר" },
  { value: 'habanim', label: 'הבנים' },
  { value: 'hahagana', label: 'ההגנה' },
  { value: 'hanachal', label: 'הנח"ל' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'mandes', label: 'מנדס' }
],
   'shkhunat-tzfonim': [
  { value: 'aluf-yitzhak-hofi', label: 'אלוף יצחק חופי' },
  { value: 'ben-tzvi', label: 'בן צבי' },
  { value: 'hatzvi', label: 'הצבי' },
  { value: 'nisei-yisrael', label: 'נשיאי ישראל' },
  { value: 'peretz-bernstein', label: 'פרץ ברנשטיין' },
  { value: 'shazar', label: 'שז"ר' }
],
   'ezor-havilim': [
  { value: 'aba-berditchev', label: 'אבא ברדיצ\'ב' },
  { value: 'even-sapir', label: 'אבן ספיר' },
  { value: 'aharonson-sarah', label: 'אהרונסון שרה' },
  { value: 'einstein', label: 'איינשטיין' },
  { value: 'brodetsky', label: 'ברודצקי' },
  { value: 'habiluim', label: 'הביל"וים' },
  { value: 'hayarden', label: 'הירדן' },
  { value: 'hakongres', label: 'הקונגרס' },
  { value: 'harae', label: 'הרא"ה' },
  { value: 'tabenkin', label: 'טבנקין' },
  { value: 'yosef-tzvi', label: 'יוסף צבי' },
  { value: 'itzhak-rabin', label: 'יצחק רבין' },
  { value: 'lev-hazahav', label: 'לב הזהב' },
  { value: 'meir-avner', label: 'מאיר אבנר' },
  { value: 'moshe-dayan', label: 'משה דיין' },
  { value: 'netter', label: 'נטר' },
  { value: 'uziel', label: 'עוזיאל' },
  { value: 'alomim', label: 'עלומים' },
  { value: 'pinchas', label: 'פנחס' }
],
    'neve-yehoshua': [
  { value: 'albert', label: 'אלברט' },
  { value: 'arya-ben-eliezer', label: 'אריה בן אליעזר' },
  { value: 'arnon', label: 'ארנון' },
  { value: 'haem', label: 'האם' },
  { value: 'haerez', label: 'הארז' },
  { value: 'hachula', label: 'החולה' },
  { value: 'hayasmin', label: 'היסמין' },
  { value: 'hayarden', label: 'הירדן' },
  { value: 'hakabaim', label: 'הכבאים' },
  { value: 'harav-hai-taieb-yitzhak', label: 'הרב חי טייב יצחק' },
  { value: 'harari', label: 'הררי' },
  { value: 'kinneret', label: 'כינרת' },
  { value: 'machanayim', label: 'מחניים' },
  { value: 'neve-yehoshua', label: 'נוה יהושע' },
  { value: 'stop', label: 'סטופ' },
  { value: 'aliya-rishona', label: 'עלייה ראשונה' },
  { value: 'aliya-shlishit', label: 'עלייה שלישית' },
  { value: 'aliya-shniya', label: 'עלייה שנייה' },
  { value: 'pinchas', label: 'פנחס' },
  { value: 'kam', label: 'ק"ם' },
  { value: 'kidron', label: 'קדרון' },
  { value: 'rosh-pina', label: 'ראש פינה' },
  { value: 'shear-yashuv', label: 'שאר ישוב' }
],
    'kiryat-borochov': [
  { value: 'granados', label: 'גרנדוס' },
  { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'hashichrur', label: 'השחרור' },
  { value: 'chaver', label: 'חבר' },
  { value: 'kanfei-nesharim', label: 'כנפי נשרים' },
  { value: 'menachem', label: 'מנחם' },
  { value: 'nachshon', label: 'נחשון' },
  { value: 'nidonei-kahir', label: 'נידוני קהיר' },
  { value: 'uziel', label: 'עוזיאל' },
  { value: 'fabrikant', label: 'פבריגט' },
  { value: 'kaplan', label: 'קפלן' },
  { value: 'ramez', label: 'רמז' },
  { value: 'tnuat-hameri', label: 'תנועת המרי' }
],
   'ramat-hen': [
  { value: 'aluf-david', label: 'אלוף דוד' },
  { value: 'elisha', label: 'אלישע' },
  { value: 'alexandroni', label: 'אלכסנדרוני' },
  { value: 'ben-zvi', label: 'בן צבי' },
  { value: 'bnei-haneviim', label: 'בני הנביאים' },
  { value: 'bernstein-peretz', label: 'ברנשטיין פרץ' },
  { value: 'givati', label: 'גבעתי' },
  { value: 'golani', label: 'גולני' },
  { value: 'daniel', label: 'דניאל' },
  { value: 'deker', label: 'דקר' },
  { value: 'hoshea', label: 'הושע' },
  { value: 'hamea-veechad', label: 'המאה ואחד' },
  { value: 'haseren-dov', label: 'הסרן דב' },
  { value: 'har-el', label: 'הראל' },
  { value: 'hashloshim-veshlosha', label: 'השלושים ושלושה' },
  { value: 'zecharia', label: 'זכריה' },
  { value: 'chavakuk', label: 'חבקוק' },
  { value: 'chaggai', label: 'חגי' },
  { value: 'yair', label: 'יאיר' },
  { value: 'yechezkel', label: 'יחזקאל' },
  { value: 'yirmiya', label: 'ירמיה' },
  { value: 'yeshayahu', label: 'ישעיהו' },
  { value: 'kaf-gimel', label: 'כ"ג' },
  { value: 'karmeli', label: 'כרמלי' },
  { value: 'machatz', label: 'מחץ' },
  { value: 'micah', label: 'מיכה' },
  { value: 'malachi', label: 'מלאכי' },
  { value: 'metzada', label: 'מצדה' },
  { value: 'nachum', label: 'נחום' },
  { value: 'san-martin', label: 'סן מרטין' },
  { value: 'ovadya', label: 'עובדיה' },
  { value: 'oded', label: 'עודד' },
  { value: 'ido', label: 'עידו' },
  { value: 'ein-yahav', label: 'עין יהב' },
  { value: 'amos', label: 'עמוס' },
  { value: 'tzefanya', label: 'צפניה' },
  { value: 'kiryati', label: 'קרייתי' },
  { value: 'rozen', label: 'רוזן' },
  { value: 'raziel', label: 'רזיאל' },
  { value: 'ramat-chen', label: 'רמת חן' },
  { value: 'tidhar', label: 'תדהר' }
],
    'hagefen': [
  { value: 'aba-hillel', label: 'אבא הלל' },
  { value: 'badner', label: 'בדנר' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'geulim', label: 'גאולים' },
  { value: 'hagefen', label: 'הגפן' },
  { value: 'hadekalim', label: 'הדקלים' },
  { value: 'hadrar', label: 'הדר' },
  { value: 'hamavdil', label: 'המבדיל' },
  { value: 'hamaapil', label: 'המעפיל' },
  { value: 'harimon', label: 'הרימון' },
  { value: 'hashoava', label: 'השואבה' },
  { value: 'hatikva', label: 'התקוה' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'cherut', label: 'חירות' },
  { value: 'mordey-hagetaot', label: 'מורדי הגטאות' },
  { value: 'stromah', label: 'סטרומה' },
  { value: 'pnei-hagivah', label: 'פני הגבעה' },
  { value: 'tzuriel', label: 'צוריאל' },
  { value: 'rokach', label: 'רוקח' },
  { value: 'shkedia', label: 'שקדייה' },
  { value: 'talpiot', label: 'תלפיות' }
],
    'ramat-shikma': [
  { value: 'ehad-haam', label: 'אחד העם' },
  { value: 'aluf-david', label: 'אלוף דוד' },
  { value: 'bney-haneviim', label: 'בני הנביאים' },
  { value: 'benayahu', label: 'בניהו' },
  { value: 'givati', label: 'גבעתי' },
  { value: 'hatayasim', label: 'הטייסים' },
  { value: 'yehoshafat', label: 'יהושפט' },
  { value: 'malchi-tzedek', label: 'מלכי צדק' },
  { value: 'matenia', label: 'מתניה' },
  { value: 'azriel', label: 'עזריאל' },
  { value: 'shalom-aleichem', label: 'שלום עליכם' },
  { value: 'shalem', label: 'שלם' },
  { value: 'shimoni', label: 'שמעוני' }
],
    'halel': [
  { value: 'uri-nissan', label: 'אורי ניסן' },
  { value: 'beit-hillel', label: 'בית הלל' },
  { value: 'beit-shammai', label: 'בית שמאי' },
  { value: 'ben-gurion-david', label: 'בן גוריון דוד' },
  { value: 'bney-moshe', label: 'בני משה' },
  { value: 'haorim', label: 'האורים' },
  { value: 'habanim', label: 'הבנים' },
  { value: 'hagalgall', label: 'הגלגל' },
  { value: 'hachetz', label: 'החץ' },
  { value: 'hayated', label: 'היתד' },
  { value: 'hamitar', label: 'המיתר' }
],

    'hadarim': [
{ value: 'yoav', label: 'יואב' },
{ value: 'aba-hillel', label: 'אבא הלל' },
{ value: 'itamar', label: 'איתמר' },
{ value: 'avigail', label: 'אביגיל' },
{ value: 'anne-frank', label: 'אנה פרנק' },
{ value: 'asaf', label: 'אסף' },
{ value: 'bialik', label: 'ביאליק' },
{ value: 'bruriah', label: 'ברוריה' },
{ value: 'haachim-bazrano', label: 'האחים בזרנו' },
{ value: 'hamelacha', label: 'המלאכה' },
{ value: 'haviva-reik', label: 'חביבה רייק' },
{ value: 'haruzim', label: 'חרוזים' },
{ value: 'yeda-am', label: 'ידע עם' },
{ value: 'rokach', label: 'רוקח' },
{ value: 'yehudit', label: 'יהודית' },
{ value: 'rut', label: 'רות' },
{ value: 'rechovot-hanahar', label: 'רחובות הנהר' },
],
    
   'tal-binyamin': [
  { value: 'aba-hillel', label: 'אבא הלל' },
  { value: 'alonim', label: 'אלונים' },
  { value: 'eliezer-weinschel', label: 'אליעזר ויינשל' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'binyamin', label: 'בנימין' },
  { value: 'harey-hagilad', label: 'הרי הגלעד' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'mcdonald', label: 'מקדונלד' }
],
    'rishonim': [
  { value: 'arlozorov', label: 'ארלוזורוב' },
  { value: 'boaz', label: 'בועז' },
  { value: 'dov', label: 'דב' },
  { value: 'hachitzon', label: 'החיצון' },
  { value: 'hamaayan', label: 'המעיין' },
  { value: 'hamatmid', label: 'המתמיד' },
  { value: 'harishonim', label: 'הראשונים' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'yehuda-englander', label: 'יהודה אנגלנדר' },
  { value: 'yakhin', label: 'יכין' },
  { value: 'lean', label: 'לאן' },
  { value: 'ir-ganim', label: 'עיר גנים' },
  { value: 'tzvi', label: 'צבי' },
  { value: 'simcha', label: 'שמחה' },
  { value: 'shapira', label: 'שפירא' },
  { value: 'tav-resh-ayin-daled', label: 'תרע"ד' },
  { value: 'tav-resh-pey-bet', label: 'תרפ"ב' },
  { value: 'tav-shin-yod', label: 'תש"י' }
],
    'nahalat-ganim': [
  { value: 'aba-hillel', label: 'אבא הלל' },
  { value: 'ornia', label: 'אורנייה' },
  { value: 'irena-nuskovich', label: 'אירנה נוסקוביץ' },
  { value: 'eshtaol', label: 'אשתאול' },
  { value: 'ben-shemen', label: 'בן שמן' },
  { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'aluf-albert-mandler', label: 'האלוף אלברט מנדלר' },
  { value: 'hakharoshet', label: 'החרושת' },
  { value: 'hayogev', label: 'היוגב' },
  { value: 'halapid', label: 'הלפיד' },
  { value: 'hamavdil', label: 'המבדיל' },
  { value: 'hamekor', label: 'המקור' },
  { value: 'haamal', label: 'העמל' },
  { value: 'hapodim', label: 'הפודים' },
  { value: 'hatzela', label: 'הצלע' },
  { value: 'zeev-jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'menachem-yitzhak', label: 'מנחם יצחק' },
  { value: 'nes', label: 'נס' },
  { value: 'savion', label: 'סביון' },
  { value: 'sokolov', label: 'סוקולוב' },
  { value: 'rashi', label: 'רש"י' }
],
      'merkaz-nave': [
  { value: 'elimelekh-rimalt', label: 'אלימלך רימלט' },
  { value: 'golomb', label: 'גולומב' },
  { value: 'hagaon-eliya', label: 'הגאון אליהו' },
  { value: 'chazon-ish', label: 'חזון איש' },
  { value: 'chaim-landau', label: 'חיים לנדאו' },
  { value: 'yochanan-bader', label: 'יוחנן באדר' },
  { value: 'yerushalayim', label: 'ירושלים' },
  { value: 'meir-ba-al-hanes', label: 'מאיר בעל הנס' },
  { value: 'molcho', label: 'מולכו' },
  { value: 'michael', label: 'מיכאל' },
  { value: 'negba', label: 'נגבה' },
  { value: 'tirtza', label: 'תרצה' }
]

  },

  'givataim': {
    'borochov': [
  { value: 'akharon-goldenshtein', label: 'אהרון גולדשטיין' },
  { value: 'akhdut-haavoda', label: 'אחדות העבודה' },
  { value: 'eliyahu', label: 'אליהו' },
  { value: 'borochov', label: 'בורוכוב' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'bloch', label: 'בלוך' },
  { value: 'ben-tzion-yisraeli', label: 'בן ציון ישראלי' },
  { value: 'gordon', label: 'גורדון' },
  { value: 'gazit', label: 'גזית' },
  { value: 'hameorer', label: 'המוערר' },
  { value: 'hamored', label: 'המורד' },
  { value: 'hapoel-hatsaair', label: 'הפועל הצעיר' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'hashnayim', label: 'השנים' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'chanita', label: 'חניטה' },
  { value: 'yafe-nof', label: 'יפה נוף' },
  { value: 'itzhak', label: 'יצחק' },
  { value: 'katznelson', label: 'כצנלסון' },
  { value: 'mordey-hagetaot', label: 'מורדי הגטאות' },
  { value: 'miryam', label: 'מרים' },
  { value: 'nachal', label: 'נחל' },
  { value: 'sirkin', label: 'סירקין' },
  { value: 'aliyat-hanoar', label: 'עליית הנוער' },
  { value: 'ptai', label: 'פטאי' },
  { value: 'klaai', label: 'קלעי' },
  { value: 'keren-kayemet-leisrael', label: 'קרן קיימת לישראל' },
  { value: 'shimon-frug', label: 'שמעון פרוג' }
 ],
    'kiryat-yosef': [
  { value: 'achdut-haavoda', label: 'אחדות העבודה' },
  { value: 'alomot', label: 'אלומות' },
  { value: 'hapoel-hatsaair', label: 'הפועל הצעיר' },
  { value: 'chanina', label: 'חנינה' },
  { value: 'itzhak', label: 'יצחק' },
  { value: 'katznelson', label: 'כצלנסון' },
  { value: 'manara', label: 'מנרה' },
  { value: 'aliyat-hanoar', label: 'עליית הנוער' },
  { value: 'kiryat-yosef', label: 'קריית יוסף' }
 ],
  'halamedhe': [
  { value: 'gush-etzion', label: 'גוש עציון' },
  { value: 'dalia', label: 'דליה' },
  { value: 'havradim', label: 'הוורדים' },
  { value: 'halach', label: 'הל"ה' },
  { value: 'hamilben', label: 'המלבן' },
  { value: 'hapalmach', label: 'הפלמ"ח' },
  { value: 'hataash', label: 'התע"ש' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'katzenelson', label: 'כצנלסון' },
  { value: 'lachish', label: 'לכיש' },
  { value: 'misgav-am', label: 'משגב עם' },
  { value: 'aliyat-hanoar', label: 'עליית הנוער' },
  { value: 'arad', label: 'ערד' },
  { value: 'keren-kayemet-leisrael', label: 'קרן קיימת לישראל' }
],
    'poale-harakevet': [
  { value: 'ben-gurion-david', label: 'דוד בן גוריון' },
  { value: 'gevulot', label: 'גבולות' },
  { value: 'hagoren', label: 'הגורן' },
  { value: 'hamaagal', label: 'המעגל' },
  { value: 'hamaalot', label: 'המעלות' },
  { value: 'hashlavim', label: 'השלבים' },
  { value: 'catsalelson', label: 'כצנלסון' },
  { value: 'sirkin', label: 'סירקין' },
  { value: 'poaley-harakevet', label: 'פועלי הרכבת' },
  { value: 'meir-rotenberg', label: 'מאיר רוטנברג' }   
],
'shenkin': [
  { value: 'asiri ziyon', label: 'אסירי ציון' },
  { value: 'afikim', label: 'אפיקים' },
  { value: 'etzel', label: 'אצ"ל' },
  { value: 'geva', label: 'גבע' },
  { value: 'gilboa', label: 'גלבוע' },
  { value: 'dovtinsky', label: 'זבוטינסקי' },
  { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'haknesset', label: 'הכנסת' },
  { value: 'hamavo', label: 'המבוא' },
  { value: 'hamaalot', label: 'המעלות' },
  { value: 'hameri', label: 'המרי' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'yaakov-feinberg', label: 'יעקב פיינברג' },
  { value: 'katzenelson', label: 'כצלנסון' },
  { value: 'sirkin', label: 'סירקין' },
  { value: 'ein-gedi', label: 'עין גדי' },
  { value: 'shenkin', label: 'שינקין' },
  { value: 'hafner', label: 'אפנר' }
],
 'givat-kosolovski': [ 
  { value: 'etzel', label: 'אצ"ל' },
  { value: 'bereshit', label: 'בראשית' },
  { value: 'baruch', label: 'ברוך' },
  { value: 'golomb', label: 'גולומב' },
  { value: 'gilboa', label: 'גלבוע' },
  { value: 'ben-gurion-david', label: 'דוד בן גוריון' },
  { value: 'hamaalot', label: 'המעלות' },
  { value: 'hameri', label: 'המרי' },
  { value: 'zabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'kinneret', label: 'כינרת' },
  { value: 'misada', label: 'מסדה' },
  { value: 'maoz', label: 'מעוז' },
  { value: 'amal', label: 'עמל' },
  { value: 'rama', label: 'רמה' }
],
    'arlosorov': [
  { value: 'ahron-shar', label: 'אהרון שר' },
  { value: 'eilat', label: 'אילת' },  
  { value: 'arlosorov', label: 'ארלוזורוב' },
  { value: 'bereshit', label: 'בראשית' },
  { value: 'berditchevski', label: 'ברדיצ\'בסקי' },
  { value: 'geva', label: 'גבע' },
  { value: 'golomb', label: 'גולומב' },
  { value: 'david-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'haknesset', label: 'הכנסת' },
  { value: 'hamaayan', label: 'המעיין' },
  { value: 'hamifne', label: 'המפנה' },
  { value: 'hameri', label: 'המרי' },
  { value: 'har-el', label: 'הראל' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'yaakov', label: 'יעקב' },
  { value: 'yitzhak-sadeh', label: 'יצחק שדה' },
  { value: 'kalanit', label: 'כלנית' },
  { value: 'nitzana', label: 'ניצנה' },
  { value: 'narkis', label: 'נרקיס' },
  { value: 'tzahal', label: 'צה"ל' },
  { value: 'rotem', label: 'רותם' },
  { value: 'reiness', label: 'ריינס' },
  { value: 'rakafet', label: 'רקפת' },
  { value: 'sde-boker', label: 'שדה בוקר' }
      
],
    'givat-rambam': [
  { value: 'avnei zikaron', label: 'אבני זיכרון' },
  { value: 'eilat', label: 'אילת' }, 
  { value: 'anzel-sirani', label: 'אנצו סירני' },
  { value: 'ariel', label: 'אריאל' },
  { value: 'ganzin', label: 'גנסין' },
  { value: 'golomb', label: 'גולומב' },
  { value: 'hadagim', label: 'הדגים' },
  { value: 'hahagana', label: 'ההגנה' },
  { value: 'hamigdal', label: 'המגדל' },
  { value: 'hangeva', label: 'הנגבה' },
  { value: 'hatzanhanim', label: 'הצנחנים' },
  { value: 'hashalom', label: 'השלום' },
  { value: 'vitzman', label: 'ויצמן' },
  { value: 'hen', label: 'ח"ן' },
  { value: 'tiber', label: 'טיבר' },
  { value: 'yitzhak-rabin', label: 'יצחק רבין' },
  { value: 'senesh', label: 'סנש' },
  { value: 'avarona', label: 'עברונה' },
  { value: 'rahel', label: 'רחל' },
  { value: 'reik', label: 'רייק' },
  { value: 'rambam', label: 'רמב"ם' },
  { value: 'ramaz', label: 'רמז' }
],
    'shtach-9': [
  { value: 'haknesset', label: 'הכנסת' },
  { value: 'davia-ben-gurion', label: 'דוד בן גוריון' },
  { value: 'koshnir', label: 'קושניר' },
  { value: 'shimon-ben-tzvi', label: 'שמעון בן צבי' }
],
   'shikon-elec': [
  { value: 'afek', label: 'אפק' },
  { value: 'argon', label: 'ארנון' },
  { value: 'gonen', label: 'גונן' },
  { value: 'david-yalin', label: 'דוד ילין' },
  { value: 'hayahid', label: 'הידיד' },
  { value: 'hamaavak', label: 'המאבק' },
  { value: 'hamaor', label: 'המאור' },
  { value: 'hanadiv', label: 'הנדיב' },
  { value: 'yaldey-tarhan', label: 'ילדי טהרן' },
  { value: 'yizhak-rabin', label: 'יצחק רבין' },
  { value: 'yisrael-shapira', label: 'ישראל שפירא' },
  { value: 'kaf-gimel', label: 'כ"ג' },
  { value: 'meharshak', label: 'מהרשק' },
  { value: 'menorah', label: 'מנורה' },
  { value: 'matzlot-yam', label: 'מצולות ים' },
  { value: 'amishav', label: 'עמישב' },
  { value: 'tziporim', label: 'צפרירים' },
  { value: 'kibotz-galoyot', label: 'קיבוץ גלויות' },
  { value: 'ravivim', label: 'רביבים' }
],
   'tel-ganim': [
  { value: 'idamit', label: 'אידמית' },
  { value: 'elyashiv-rodin', label: 'אלישע רודין' },
  { value: 'histadrut', label: 'ההסתדרות' },
  { value: 'hamaavak', label: 'המאבק' },
  { value: 'haratz', label: 'הרצוג' },
  { value: 'tabakin', label: 'טבנקין' },
  { value: 'yavneli', label: 'יבנאלי' },
  { value: 'kurzin', label: 'כורזין' },
  { value: 'menorah', label: 'מנורה' },
  { value: 'mishmar-hayarden', label: 'משמר הירדן' },
  { value: 'kvutzat-galiyot', label: 'קבוץ גלויות' },
  { value: 'kaplansky', label: 'קפלנסקי' },
  { value: 'shiluv', label: 'שילוב' },
  { value: 'keren-hayesod', label: 'קרן היסוד' },
  { value: 'tifzot-israel', label: 'תפוצות ישראל' }
],
    'city': [
  { value: 'ariel-sharon', label: 'אריאל שרון' },
  { value: 'arve-nachal', label: 'ערבי נחל' }
 ]
 
},
  'beer-sheva': {
  'kiryat-wolfson': [
    { value: 'yosftal-giora', label: 'יוספטל גיורא' },
    { value: 'sanhedrin', label: 'סנהדרין' },
    { value: 'sderot-reger-yitzhak', label: 'שד\' רגר יצחק' },
    { value: 'bar-yochai', label: 'בר יוחאי' },
    { value: 'avraham-avinu', label: 'אברהם אבינו' }
  ],
  'shkh-d-nw': [
    { value: 'even-ezra', label: 'אבן עזרא' },
    { value: 'hatzadik-miyerushalayim', label: 'הצדיק מירושלים' },
    { value: 'hatlmud', label: 'התלמוד' },
    { value: 'rabbenu-tam', label: 'רבנו תם' },
    { value: 'ramban', label: 'רמב"ן' }
  ],
  'shkh-d-n': [
    { value: 'sanhedrin', label: 'סנהדרין' },
    { value: 'yehuda-halevi', label: 'יהודה הלוי' },
    { value: 'rashi', label: 'רש"י' },
    { value: 'shprintzak', label: 'שפרינצק' },
    { value: 'hatlmud', label: 'התלמוד' }
  ],
  'shkh-d-center': [
    { value: 'avraham-avinu', label: 'אברהם אבינו' },
    { value: 'david-hamelekh', label: 'דוד המלך' },
    { value: 'yoel-hashofet', label: 'יואל השופט' },
    { value: 'yohanan-horkanos', label: 'יוחנן הורקנוס' },
    { value: 'gilad', label: 'גלעד' }
  ],
  'shkh-d-east': [
    { value: 'sderot-reger-yitzhak', label: 'שד\' רגר יצחק' },
    { value: 'shifer-yitzhak', label: 'שיפר יצחק' },
    { value: 'bernfeld-shimon', label: 'ברנפלד שמעון' },
    { value: 'klaozner', label: 'קלאוזנר' },
    { value: 'ringelblum', label: 'רינגלבלום' }
  ],
  'shkh-d-se': [
    { value: 'sderot-reger-yitzhak', label: 'שד\' רגר יצחק' },
    { value: 'ringelblum', label: 'רינגלבלום' },
    { value: 'arnia-osvaldo', label: 'ארניה אסוולדו' },
    { value: 'yosef-ben-matityahu', label: 'יוסף בן מתתיהו' },
    { value: 'harav-asaf-shimcha', label: 'הרב אסף שמחה' }
  ],
  'shkh-d-sw': [
    { value: 'sderot-reger-yitzhak', label: 'שד\' רגר יצחק' },
    { value: 'avraham-avinu', label: 'אברהם אבינו' },
    { value: 'alexander-yanai', label: 'אלכסנדר ינאי' },
    { value: 'yaakov-avinu', label: 'יעקב אבינו' },
    { value: 'shlomo-hamelekh', label: 'שלמה המלך' }
  ],
  'shkh-d-s': [
    { value: 'elazar-ben-yair', label: 'אלעזר בן יאיר' },
    { value: 'avraham-avinu', label: 'אברהם אבינו' },
    { value: 'yehuda-halevi', label: 'יהודה הלוי' },
    { value: 'david-hamelekh', label: 'דוד המלך' },
    { value: 'bar-giora', label: 'בר גיורא' }
  ],
  'shkh-v-se': [
    { value: 'derech-metzada', label: 'דרך מצדה' },
    { value: 'modiin', label: 'מודיעין' },
    { value: 'bar-giora', label: 'בר גיורא' },
    { value: 'yitzhak-avinu', label: 'יצחק אבינו' },
    { value: 'rabi-akiva', label: 'רבי עקיבא' }
  ],
  'shkh-v-center': [
    { value: 'shaul-hamelekh', label: 'שאול המלך' },
    { value: 'yehoshafat', label: 'יהושפט' },
    { value: 'mivtza-horev', label: 'מבצע חורב' },
    { value: 'mivtza-yoav', label: 'מבצע יואב' },
    { value: 'mivtza-nachshon', label: 'מבצע נחשון' }
  ],
    'shkh-v-ne': [
    { value: 'mivtsa-yonatan', label: 'משעול מבצע יונתן' },
    { value: 'mivtsa-yoav', label: 'מבצע יואב' },
    { value: 'shaul-hamelekh', label: 'שאול המלך' },
    { value: 'rehavat-mivtsa-erez', label: 'רחבת מבצע ארז' },
    { value: 'dori-yaakov', label: 'דורי יעקב' }
  ],
  'shkh-v-nw': [
    { value: 'zmora-moshe', label: 'זמורה משה' },
    { value: 'vitkon-alfred', label: 'ויתקון אלפרד' },
    { value: 'dori-yaakov', label: 'דורי יעקב' },
    { value: 'david-elazar', label: 'דוד אלעזר' },
    { value: 'maklef-mordechai', label: 'מקלף מרדכי' }
  ],
  'shkh-v-n': [
    { value: 'yarkoni-amos', label: 'ירקוני עמוס' },
    { value: 'dayan-moshe', label: 'דיין משה' },
    { value: 'shtein-richard', label: 'שטיין ריכרד' },
    { value: 'fritz-albert', label: 'פריץ אלברט' },
    { value: 'david-elazar', label: 'דוד אלעזר' }
  ],
  'shkh-v-sw': [
    { value: 'shaul-hamelekh', label: 'שאול המלך' },
    { value: 'rehavat-pal-yam', label: 'רחבת פל-ים' },
    { value: 'rehavat-harel', label: 'רחבת הראל' },
    { value: 'dayan-moshe', label: 'דיין משה' },
    { value: 'dori-yaakov', label: 'דורי יעקב' }
  ],
  'shkh-ya-nw': [
    { value: 'avishai', label: 'אבישי' },
    { value: 'shaul-hamelekh', label: 'שאול המלך' },
    { value: 'derech-metzada', label: 'דרך מצדה' },
    { value: 'mivtsa-uvda', label: 'מבצע עובדה' },
    { value: 'mivtsa-yoav', label: 'מבצע יואב' }
  ],
  'shkh-ya-ne': [
    { value: 'derech-metzada', label: 'דרך מצדה' },
    { value: 'harosh', label: 'הראש' },
    { value: 'radak', label: 'רד"ק' },
    { value: 'shaul-hamelekh', label: 'שאול המלך' },
    { value: 'alfasi', label: 'אלפסי' }
  ],
  'shkh-ya-se': [
    { value: 'rehavat-harav-uziel', label: 'רחבת הרב עוזיאל' },
    { value: 'hachida', label: 'החיד"א' },
    { value: 'derech-metzada', label: 'דרך מצדה' },
    { value: 'avrabanel', label: 'אברבנאל' },
    { value: 'shaul-hamelekh', label: 'שאול המלך' }
  ],
  'shkh-ya-sw': [
    { value: 'aran-zalman', label: 'ארן זלמן' },
    { value: 'shitreit', label: 'שיטרית' },
    { value: 'mishol-pinkas-david', label: 'משעול פנקס דוד' },
    { value: 'dov-yosef', label: 'דב יוסף' },
    { value: 'yeshayahu-israel', label: 'ישעיהו ישראל' }
  ],
  'shkh-ya-s': [
    { value: 'tzizling', label: 'ציזלינג' },
    { value: 'kadish-luz', label: 'קדיש לוז' },
    { value: 'svidor-menahem', label: 'סבידור מנחם' },
    { value: 'yeshayahu-israel', label: 'ישעיהו ישראל' },
    { value: 'yaari-meir', label: 'יערי מאיר' }
  ],
  'neve-menachem-n': [
    { value: 'sharet-moshe', label: 'שרת משה' },
    { value: 'namir-mordechai', label: 'נמיר מרדכי' },
    { value: 'hazani-michael', label: 'חזני מיכאל' },
    { value: 'harav-hertzog', label: 'הרב הרצוג' },
    { value: 'avigor-shaul', label: 'אביגור שאול' }
  ],
  'neve-menachem-center': [
    { value: 'moyal-eliyahu', label: 'מויאל אליהו' },
    { value: 'ropin-arthur', label: 'רופין ארתור' },
    { value: 'rokach-israel', label: 'רוקח ישראל' },
    { value: 'sderot-golda-meir', label: 'שד\' גולדה מאיר' },
    { value: 'dolchin-arya', label: 'דולצ\'ין אריה' }
  ],
  'neve-menachem-s': [
    { value: 'kalczkin-rafael', label: 'קלצ\'קין רפאל' },
    { value: 'rubina-hana', label: 'רובינא חנה' },
    { value: 'rudensky-shmuel', label: 'רודנסקי שמואל' },
    { value: 'maskin-aharon', label: 'מסקין אהרון' },
    { value: 'yalen-shtaklis-miryam', label: 'ילן-שטקליס מרים' }
  ]
},
  'ofakim': {
    'mishor-hagefen': [
      { value: 'hatamar', label: 'התמר' },
      { value: 'kibutz-galuyot', label: 'קבוץ גלויות' },
      { value: 'beit-vegan', label: 'דרך בית וגן' },
      { value: 'harav-huri', label: 'הרב חורי' },
      { value: 'pri-megadim', label: 'פרי מגדים' }
    ],
    'dedo-yoni-mesika': [
      { value: 'sharet', label: 'שרת' },
      { value: 'haoren', label: 'האורן' },
      { value: 'kadesh', label: 'קדש' },
      { value: 'hakramim', label: 'הכרמים' },
      { value: 'herzl-blvd', label: 'שד\' הרצל' }
    ],
    'arazim': [
      { value: 'beit-vegan', label: 'דרך בית וגן' },
      { value: 'hanasi', label: 'הנשיא' },
      { value: 'giborei-israel', label: 'גבורי ישראל' },
      { value: 'herzl-blvd', label: 'שד\' הרצל' },
      { value: 'eli-cohen', label: 'אלי כהן' }
    ],
    'bne-beitcha-harif': [
      { value: 'etzel', label: 'אצ"ל' },
      { value: 'herzl-blvd', label: 'שד\' הרצל' },
      { value: 'olei-hagardom', label: 'עולי הגרדום' },
      { value: 'hachida', label: 'החיד"א' },
      { value: 'bilu', label: 'ביל"ו' }
    ],
    'industrial-area': [
      { value: 'totzeret-haaretz', label: 'תוצרת הארץ' },
      { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
      { value: 'hamasger', label: 'המסגר' },
      { value: 'hamelacha', label: 'המלאכה' },
      { value: 'betzalel', label: 'בצלאל' }
    ],
    'ben-gurion': [
      { value: 'derech-hatayas', label: 'דרך הטייסים' },
      { value: 'buzaglo-david', label: 'בוזגלו דוד' },
      { value: 'rabbi-akiva', label: 'רבי עקיבא' },
      { value: 'chafetz-chaim', label: 'חפץ חיים' },
      { value: 'hachida', label: 'החיד"א' }
    ],
    'shapira': [
      { value: 'kiryat-sefer', label: 'קריית ספר' },
      { value: 'derech-haneviim', label: 'דרך הנביאים' },
      { value: 'yerushalayim', label: 'ירושלים' },
      { value: 'david-hamelech', label: 'דוד המלך' },
      { value: 'derech-hatayas', label: 'דרך הטייסים' }
    ]
  },
  'tel-aviv': {
     
    'new-north-np': [
  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'elazar-hachorani', label: 'אלעזר החורני' },
  { value: 'antigonos', label: 'אנטיגונוס' },
  { value: 'aristobolus', label: 'אריסטובול' },
  { value: 'bublik', label: 'בובליק' },
  { value: 'bodenheimer', label: 'בודנהיימר' },
  { value: 'birnbaum', label: 'בירנבוים' },
  { value: 'bney-dan', label: 'בני דן' },
  { value: 'bney-moshe', label: 'בני משה' },
  { value: 'brandeis', label: 'ברנדייס' },
  { value: 'de-haas', label: 'דה האז' },
  { value: 'hildesheimer', label: 'הילדסהיימר' },
  { value: 'harav-david-friedman', label: 'הרב דוד פרידמן' },
  { value: 'harav-amiel', label: 'הרב עמיאל' },
  { value: 'harav-tsirelson', label: 'הרב צירלסון' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'vaadat-katowitz', label: 'ועידת קטוביץ' },
  { value: 'honi-hamaagel', label: 'חוני המעגל' },
  { value: 'yehuda-hamaccabi', label: 'יהודה המכבי' },
  { value: 'yochanan-hagadi', label: 'יוחנן הגדי' },
  { value: 'yonatan-hofsi', label: 'יונתן הוופסי' },
  { value: 'itzhak-rilf', label: 'יצחק רילף' },
  { value: 'louis-marshall', label: 'לואי מרשל' },
  { value: 'mordechai-namir', label: 'מרדכי נמיר' },
  { value: 'miryam-hachasmonait', label: 'מרים החשמונאית' },
  { value: 'moshe-zatturi', label: 'משה זטורי' },
  { value: 'matityahu-kohen-gadol', label: 'מתתיהו כהן גדול' },
  { value: 'nisenboim', label: 'ניסנבוים' },
  { value: 'smuts', label: 'סמאטס' },
  { value: 'pinkas', label: 'פינלס' },
  { value: 'pincas', label: 'פנקס' },
  { value: 'rav-tsa-ir', label: 'רב צעיר' },
  { value: 'stricker', label: 'שטריקר' },
  { value: 'shlomtzion-hamalkah', label: 'שלומציון המלכה' },
  { value: 'shlezinger', label: 'שלזינגר' }
],
    'new-north-sp': [
  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'uri', label: 'אורי' },
  { value: 'antokolski', label: 'אנטוקולסקי' },
  { value: 'arlazorov', label: 'ארלוזורוב' },
  { value: 'baari', label: 'בארי' },
  { value: 'bloch-david', label: 'בלוך דוד' },
  { value: 'betsalel', label: 'בצלאל' },
  { value: 'bar-kokhva', label: 'ברקוביץ' },
  { value: 'glitzenstein', label: 'גליצנשטיין' },
  { value: 'dovnov', label: 'דובנוב' },
  { value: 'david-hamelech', label: 'דוד המלך' },
  { value: 'dulitzki', label: 'דוליצקי' },
  { value: 'dafna', label: 'דפנה' },
  { value: 'hagefen', label: 'הגפן' },
  { value: 'hazayit', label: 'הזית' },
  { value: 'sold-henrietta', label: 'הנרייטה סאלד' },
  { value: 'fishman-maimon', label: 'הרב י"ל פישמן מיימון' },
  { value: 'harimon', label: 'הרימון' },
  { value: 'hashoftim', label: 'השופטים' },
  { value: 'hataena', label: 'התאנה' },
  { value: 'hatamar', label: 'התמר' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'chachmei-kirouan', label: 'חכמי קירואן' },
  { value: 'itzhak-katzenelson', label: 'יצחק קצנלסון' },
  { value: 'lilian', label: 'ליליאן' },
  { value: 'mana', label: 'מאנה' },
  { value: 'modigliani', label: 'מודיליאני' },
  { value: 'mordechai-namir', label: 'מרדכי נמיר' },
  { value: 'nehardea', label: 'נהרדעא' },
  { value: 'soutine', label: 'סוטין' },
  { value: 'pumbedita', label: 'פומבדיתא' },
  { value: 'tzeitlin', label: 'צייטלין' },
  { value: 'reuben-brainin', label: 'ראובן בריינין' },
  { value: 'rehov-668', label: "רח' 668" },
  { value: 'rembrandt', label: 'רמברנדט' },
  { value: 'shaul-hamelech', label: 'שאול המלך' },
  { value: 'shtruk', label: 'שטרוק' },
  { value: 'shilah', label: 'שילה' }
],
 'new-north-km': [
  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'ahavat-tzion', label: 'אהבת ציון' },
  { value: 'epstein', label: 'אפשטיין' },
  { value: 'arya-akiva', label: 'אריה עקיבא' },
  { value: 'arlazorov', label: 'ארלוזורוב' },
  { value: 'biltmore', label: 'בילטמור' },
  { value: 'ben-saruk', label: 'בן סרוק' },
  { value: 'ben-shaprut', label: 'בן שפרוט' },
  { value: 'gur-yehuda', label: 'גור יהודה' },
  { value: 'gluskin', label: 'גלוסקין' },
  { value: 'david-yellin', label: 'דוד ילין' },
  { value: 'david-ramez', label: 'דוד רמז' },
  { value: 'danin', label: 'דנין' },
  { value: 'heh-ba-iyar', label: "ה' באייר" },
  { value: 'helsinki', label: 'הלסינקי' },
  { value: 'hatzionut', label: 'הציונות' },
  { value: 'hashofet-nofech', label: 'השופט נופך' },
  { value: 'visotsky', label: 'ויסוצקי' },
  { value: 'weizmann', label: 'ויצמן' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'zikhron-yaakov', label: 'זיכרון יעקב' },
  { value: 'zlotsisti', label: 'זלוציסטי' },
  { value: 'chevra-chadasha', label: 'חברה חדשה' },
  { value: 'hadera', label: 'חדרה' },
  { value: 'chayutman', label: 'חיותמן' },
  { value: 'hankin', label: 'חנקין' },
  { value: 'yaakov-mozir', label: 'יעקב מוזיר' },
  { value: 'kohenstam', label: 'כהנשטם' },
  { value: 'louis-lipsky', label: 'לואי ליפסקי' },
  { value: 'lissin', label: 'ליסין' },
  { value: 'mosinson', label: 'מוסינזון' },
  { value: 'matmon-cohen', label: 'מטמון כהן' },
  { value: 'mordechai-namir', label: 'מרדכי נמיר' },
  { value: 'moshe-sharet', label: 'משה שרת' },
  { value: 'smilansky', label: 'סמילנסקי' },
  { value: 'faivel', label: 'פייבל' },
  { value: 'pinkas', label: 'פנקס' },
  { value: 'clay', label: 'קליי' },
  { value: 'rehov-1184', label: "רח' 1184" },
  { value: 'rehov-1279', label: "רח' 1279" },
  { value: 'shor', label: 'שור' },
  { value: 'tashach', label: 'תש"ח' }
],
  'old-north-np': [

  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'adam-hacohen', label: 'אד"ם הכהן' },
  { value: 'eduard-bernstein', label: 'אדוארד ברנשטיין' },
  { value: 'aharon-david-gordon', label: 'אהרון דוד גורדון' },
  { value: 'ussishkin', label: 'אוסישקין' },
  { value: 'aybeshitz', label: 'אייבשיץ' },
  { value: 'isaac-hirsch-weiss', label: 'אייזיק הירש וייס' },
  { value: 'alharizi', label: 'אלחריזי' },
  { value: 'eliyahu-bachur', label: 'אליהו בחור' },
  { value: 'eliezer-peri', label: 'אליעזר פרי' },
  { value: 'alexander-yanai', label: 'אלכסנדר ינאי' },
  { value: 'alkalay', label: 'אלקלעי' },
  { value: 'amsterdam', label: 'אמסטרדם' },
  { value: 'arba-aratzot', label: 'ארבע ארצות' },
  { value: 'arlazorov', label: 'ארלוזורוב' },
  { value: 'ashtori-haparchi', label: 'אשתורי הפרחי' },
  { value: 'beer-tuvia', label: 'באר טוביה' },
  { value: 'basel', label: 'בזל' },
  { value: 'ben-gurion', label: 'בן גוריון' },
  { value: 'ben-yehuda', label: 'בן יהודה' },
  { value: 'gush-halav', label: 'גוש חלב' },
  { value: 'grizim', label: 'גריזים' },
  { value: 'gretz', label: 'גרץ' },
  { value: 'dizengoff', label: 'דיזנגוף' },
  { value: 'bashan', label: 'הבשן' },
  { value: 'gilad', label: 'הגלעד' },
  { value: 'hadasa', label: 'הדסה' },
  { value: 'hoshea', label: 'הושע' },
  { value: 'heil', label: 'היל' },
  { value: 'hayarkon', label: 'הירקון' },
  { value: 'halperin', label: 'הלפרין' },
  { value: 'hapardes', label: 'הפרדס' },
  { value: 'haklair', label: 'הקליר' },
  { value: 'har-nevo', label: 'הר נבו' },
  { value: 'hashele', label: 'השל"ה' },
  { value: 'hatanya', label: 'התניא' },
  { value: 'worms', label: 'וורמיזה' },
  { value: 'weizel', label: 'ויזל' },
  { value: 'vilna', label: 'וילנא' },
  { value: 'vitkin', label: 'ויתקין' },
  { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
  { value: 'zechariah', label: 'זכריה' },
  { value: 'zlatopolsky', label: 'זלטופולסקי' },
  { value: 'zangwill', label: 'זנגביל' },
  { value: 'chavakuk', label: 'חבקוק' },
  { value: 'chagai', label: 'חגי' },
  { value: 'chulda', label: 'חולדה' },
  { value: 'chatam-sofer', label: 'חת"ם סופר' },
  { value: 'tahon-yehoshua', label: 'טהון יהושע' },
  { value: 'yehoshua-bin-nun', label: 'יהושע בן נון' },
  { value: 'yahalal', label: 'יהל"ל (יהודה לייב לוין)' },
  { value: 'yoel-hanavi', label: 'יואל הנביא' },
  { value: 'yodfat', label: 'יודפת' },
  { value: 'yochanan-horkanus', label: 'יוחנן הורקנוס' },
  { value: 'just', label: 'יוסט' },
  { value: 'yotsar', label: 'יוצ"ר' },
  { value: 'yechezkel', label: 'יחזקאל' },
  { value: 'yaakov-emden', label: 'יעקב עמדן' },
  { value: 'yafe-nof', label: 'יפה נוף' },
  { value: 'itzhak-levi', label: 'יצחק לוי' },
  { value: 'jericho', label: 'יריחו' },
  { value: 'yirmiyahu', label: 'ירמיהו' },
  { value: 'yeshayahu', label: 'ישעיהו' },
  { value: 'kaf-gimel-yordei-hasira', label: 'כ"ג יורדי הסירה' },
  { value: 'liberman', label: 'ליברמן' },
  { value: 'lasal', label: 'לסל' },
  { value: 'itzik-manger', label: 'מאנגר איציק' },
  { value: 'maharal', label: 'מהר"ל' },
  { value: 'modiin', label: 'מודיעין' },
  { value: 'mozaikin', label: 'מוצקין' },
  { value: 'micah', label: 'מיכה' },
  { value: 'malachi', label: 'מלאכי' },
  { value: 'mandelshtam', label: 'מנדלשטם' },
  { value: 'masada', label: 'מצדה' },
  { value: 'moshe-ben-ezra', label: 'משה אבן עזרא' },
  { value: 'nordau', label: 'נורדאו' },
  { value: 'nahum', label: 'נחום' },
  { value: 'nachshon', label: 'נחשון' },
  { value: 'namal-tel-aviv', label: 'נמל תל אביב' },
  { value: 'sokolov', label: 'סוקולוב' },
  { value: 'ovadya-hanavi', label: 'עובדיה הנביא' },
  { value: 'ovadya-mi-bartenura', label: 'עובדיה מברטנורה' },
  { value: 'azarya-min-haadomim', label: 'עזריה מן האדומים' },
  { value: 'ein-gedi', label: 'עין גדי' },
  { value: 'amos', label: 'עמוס' },
  { value: 'immanuel-haromi', label: 'עמנואל הרומי' },
  { value: 'pekiin', label: 'פקיעין' },
  { value: 'prague', label: 'פראג' },
  { value: 'frankfurt', label: 'פרנקפורט' },
  { value: 'tzidon', label: 'צידון' },
  { value: 'cordoba', label: 'קורדובה' },
  { value: 'kalonymus', label: 'קלונימוס' },
  { value: 'rachel', label: 'רחל' },
  { value: 'rank', label: 'רנ"ק' },
  { value: 'shir', label: 'שי"ר' },
  { value: 'shlomo-hamelech', label: 'שלמה המלך' },
  { value: 'shmuel-hanagid', label: 'שמואל הנגיד' },
  { value: 'shimon-hatarsi', label: 'שמעון התרסי' },
  { value: 'sha-ar-tzion', label: 'שער ציון' }
],
    'old-north-sp': [
  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'avraham-lev', label: 'אברהם לב' },
  { value: 'aharonovich', label: 'אהרונוביץ' },
  { value: 'eliyahu-sapir', label: 'אליהו ספיר' },
  { value: 'ambar', label: 'אמבר' },
  { value: 'emile-zola', label: 'אמיל זולא' },
  { value: 'esther-hamalka', label: 'אסתר המלכה' },
  { value: 'arnon', label: 'ארנון' },
  { value: 'bogroshov', label: 'בוגרשוב' },
  { value: 'buki-ben-yogley', label: 'בוקי בן יוגלי' },
  { value: 'byron', label: 'ביירון' },
  { value: 'bilu', label: 'ביל"ו' },
  { value: 'bilinson', label: 'בילינסון' },
  { value: 'ben-gurion', label: 'בן גוריון' },
  { value: 'ben-yehuda', label: 'בן יהודה' },
  { value: 'ben-ami', label: 'בן עמי' },
  { value: 'ben-zion', label: 'בן ציון' },
  { value: 'bar-giura', label: 'בר-גיורה' },
  { value: 'bar-kochva', label: 'בר-כוכבא' },
  { value: 'bracha-fold', label: 'ברכה פולד' },
  { value: 'gideon', label: 'גדעון' },
  { value: 'gottlieb', label: 'גוטליב' },
  { value: 'gur-arye', label: 'גור אריה' },
  { value: 'gordon-y-l', label: 'גורדון י ל' },
  { value: 'gezer', label: 'גזר' },
  { value: 'glikson', label: 'גליקסון' },
  { value: 'gensin', label: 'גנסין' },
  { value: 'dov-hoz', label: 'דב הוז' },
  { value: 'dizengoff', label: 'דיזנגוף' },
  { value: 'droyanov', label: 'דרויאנוב' },
  { value: 'haalkushi', label: 'האלקושי' },
  { value: 'huberman', label: 'הוברמן' },
  { value: 'hayarkon', label: 'הירקון' },
  { value: 'hirshenbergh', label: 'הירשנברג' },
  { value: 'hakarem', label: 'הכרם' },
  { value: 'hamelitz', label: 'המליץ' },
  { value: 'king-george', label: 'המלך ג\'ורג\'' },
  { value: 'haneviim', label: 'הנביאים' },
  { value: 'herman-cohen', label: 'הרמן כהן' },
  { value: 'hashoftim', label: 'השופטים' },
  { value: 'jean-jaures', label: 'ז\'אן ז\'ורס' },
  { value: 'zamenhof', label: 'זמנהוף' },
  { value: 'chen', label: 'ח"ן' },
  { value: 'chovevei-zion', label: 'חובבי ציון' },
  { value: 'chissin', label: 'חיסין' },
  { value: 'tiberias', label: 'טבריה' },
  { value: 'toscanini', label: 'טוסקניני' },
  { value: 'tchernichovsky', label: 'טשרניחובסקי' },
  { value: 'yehoash', label: 'יהואש' },
  { value: 'yosef-eliya', label: 'יוסף אליהו' },
  { value: 'ylg', label: 'יל"ג' },
  { value: 'yael', label: 'יעל' },
  { value: 'yeshurun', label: 'ישורון' },
  { value: 'israelis', label: 'ישראליס' },
  { value: 'lurya', label: 'לוריא' },
  { value: 'latris', label: 'לטריס' },
  { value: 'lachish', label: 'לכיש' },
  { value: 'mana', label: 'מאנה' },
  { value: 'mapu', label: 'מאפו' },
  { value: 'megido', label: 'מגידו' },
  { value: 'malchei-israel', label: 'מלכי ישראל' },
  { value: 'mendele-mokher-sfarim', label: 'מנדלי מוכר ספרים' },
  { value: 'mendelssohn', label: 'מנדלסון' },
  { value: 'masaryk', label: 'מסריק' },
  { value: 'mitzpe', label: 'מצפה' },
  { value: 'marmorek', label: 'מרמורק' },
  { value: 'netzach-israel', label: 'נצח ישראל' },
  { value: 'natan-hachacham', label: 'נתן החכם' },
  { value: 'sirkin', label: 'סירקין' },
  { value: 'smolenskin', label: 'סמולנסקין' },
  { value: 'ein-charod', label: 'עין חרוד' },
  { value: 'am-yisrael-chai', label: 'עם ישראל חי' },
  { value: 'philo', label: 'פילון' },
  { value: 'pinsker', label: 'פינסקר' },
  { value: 'perg', label: 'פרוג' },
  { value: 'frishman', label: 'פרישמן' },
  { value: 'tzvi-shapira', label: 'צבי שפירא' },
  { value: 'tzfat', label: 'צפת' },
  { value: 'korolenko', label: 'קורולנקו' },
  { value: 'rozenbaum', label: 'רוזנבאום' },
  { value: 'ruphyn', label: 'רופין' },
  { value: 'rut', label: 'רות' },
  { value: 'reich', label: 'רייך' },
  { value: 'reines', label: 'ריינס' },
  { value: 'herbert-samuel-promenade', label: 'רציף הרברט סמואל' },
  { value: 'shats', label: 'ש"ץ' },
  { value: 'shulamit', label: 'שולמית' },
  { value: 'shtand', label: 'שטנד' },
  { value: 'shlag', label: 'של"ג' },
  { value: 'shalom-aleichem', label: 'שלום עליכם' },
  { value: 'shmaryahu-levin', label: 'שמריהו לוין' },
  { value: 'shimshon', label: 'שמשון' },
  { value: 'spinoza', label: 'שפינוזה' },
  { value: 'tel-chai', label: 'תל חי' },
  { value: 'tarst', label: 'תרס"ט' }
],

    'gelilot': [
    { value: 'shimon-samat', label: 'שמעון סאמט' },
    { value: 'yunichman', label: 'יוניצ\'מן' },
    { value: 'rosenblum-herzl', label: 'רוזנבלום הרצל' },
      
],
    'tochnit-l': [
        
    { value: 'after-yaakov', label: 'אפטר יעקב' },
    { value: 'borla-yehuda', label: 'בורלא יהודה' },
    { value: 'einstein', label: 'אינשטיין' },
    { value: 'levi-eshkol', label: 'לוי אשכול' },
    { value: 'isaac-stern', label: 'אייזק שטרן' },
    { value: 'bareli', label: 'בראלי' },
    { value: 'batya', label: 'בתיה' },
    { value: 'dov-haozner', label: 'דב האוזנר' },
    { value: 'yehuda-amichai', label: 'יהודה עמיחי' },
    { value: 'yuval-neeman', label: "פרופ' יובל נאמן" }    
  
  ],

      'azorie-chen': [
  { value: 'avigor-shaul', label: 'אביגור שאול' },
  { value: 'uri-tzvi-grinberg', label: 'אורי צבי גרינברג' },
  { value: 'eliyahu-berlin', label: 'אליהו ברלין' },
  { value: 'daniel-sambursky', label: 'דניאל סמבורסקי' },
  { value: 'yair-rozenblum', label: 'יאיר רוזנבלום' },
  { value: 'amichai-paglin', label: 'עמיחי פאגלין' },
  { value: 'kdoshei-hashoah', label: 'קדושי השואה' },
  { value: 'mokdi-moshe', label: 'מוקדי משה' },   
  { value: 'shmuel-sch nitzer', label: 'שמואל שניצר' }
        
    ],
 'kochav-hatzafon': [
   
  { value: 'aba-kovner', label: 'אבא קובנר' },
  { value: 'boney-ha-ir', label: 'בוני העיר' },
  { value: 'israel-galili', label: 'גלילי ישראל' },
  { value: 'yaari-meir', label: 'יערי מאיר' },
  { value: 'levi-eshkol', label: 'לוי אשכול' },
  { value: 'maurizio-vitale', label: 'מאוריציו ויטלה' },
  { value: 'maoz-biluya', label: 'מעוז בילויה' },
  { value: 'rofe-hamachtarot', label: 'רופא המחתרות' },
  { value: 'rokach', label: 'רוקח' },
  { value: 'shai-agnon', label: 'ש"י עגנון' }

    ],
    
    
'zamarot-ayalon': [
  
  { value: 'buskowitz', label: 'בוסקוביץ' },
  { value: 'dosh', label: 'דוש' },
  { value: 'harav-shlomo-goren', label: 'הרב שלמה גורן' },
  { value: 'mordechai-namir', label: 'מרדכי נמיר' },
  { value: 'nissim-aloni', label: 'ניסים אלוני' }
],

    
  'afeka':[
  { value: 'aba-achimeir', label: 'אב"א אחימאיר' },
  { value: 'ofakim', label: 'אופקים' },
  { value: 'hamishmar-haezrachi', label: 'המשמר האזרחי' },
  { value: 'hamitnadev', label: 'המתנדב' },
  { value: 'hanoter', label: 'הנוטר' },
  { value: 'harekesh', label: 'הרכש' },
  { value: 'zelig', label: 'זליג' },
  { value: 'chish', label: 'חי"ש' },
  { value: 'chaim-lebanon', label: 'חיים לבנון' },
  { value: 'cheil-hamishmar', label: 'חיל המשמר' },
  { value: 'yehuda-arazi', label: 'יהודה ארזי' },
  { value: 'yosef-aricha', label: 'יוסף אריכא' },
  { value: 'magshimim', label: 'מגשימים' },
  { value: 'menia-ve-yisrael', label: 'מניה וישראל' },
  { value: 'mordechai-motta-gur', label: 'מרדכי (מוטה) גור' },
  { value: 'mishmar-hagvul', label: 'משמר הגבול' },
  { value: 'olamim', label: 'עלומים' },
  { value: 'komemiyut', label: 'קוממיות' },
  { value: 'kalczkin', label: 'קלצ\'קין' },
  { value: 'rekanti', label: 'רקנאטי' },
  { value: 'shai', label: 'ש"י' },
  { value: 'shaike-ofir', label: 'שייקה אופיר' },
  { value: 'shmuel-barkai', label: 'שמואל ברקאי' },
  { value: 'shamir', label: 'שמיר' },
  { value: 'shfeya', label: 'שפיה' }

    ],
    'afeka-a':[
  
  { value: 'mivtza-kadesh', label: 'מבצע קדש' },
  { value: 'kehilat-venezia', label: 'קהילת ונציה' },
  { value: 'kehilat-zhitomir', label: 'קהילת ז\'יטומיר' },
  { value: 'kehilat-saloniki', label: 'קהילת סאלוניקי' },
  { value: 'kehilat-padova', label: 'קהילת פאדובה' },
  { value: 'kehilat-poznan', label: 'קהילת פוזנא' },
  { value: 'kehilat-kovno', label: 'קהילת קובנה' },
  { value: 'kehilat-kiev', label: 'קהילת קייב' },
  { value: 'kehilat-riga', label: 'קהילת ריגה' },
  { value: 'shlonsky', label: 'שלונסקי' }

],
    'afeka-b':[

  { value: 'avigdor-hameiri', label: 'אביגדור המאירי' },
  { value: 'natan-alterman', label: 'אלתרמן נתן' },
  { value: 'bney-ephraim', label: 'בני אפרים' },
  { value: 'gazit', label: 'גזית' },
  { value: 'ginaton', label: 'גינתון' },
  { value: 'gliksberg', label: 'גליקסברג' },
  { value: 'weinschel', label: 'ויינשל' },
  { value: 'zeev', label: 'זאב' },
  { value: 'yifat', label: 'יפעת' },
  { value: 'itzhak-lamdan', label: 'יצחק למדן' },
  { value: 'yatzitz', label: 'יציץ' },
  { value: 'lea', label: 'לאה' },
  { value: 'moroshet', label: 'מורשת' },
  { value: 'menorah', label: 'מנורה' },
  { value: 'marcel-janco', label: 'מרסל ינקו' },
  { value: 'moshe-sneh', label: 'משה סנה' },
  { value: 'reuven-rubin', label: 'ראובן רובין' },
  { value: 'pinchas-rozen', label: 'רוזן פנחס' },
  { value: 'romema', label: 'רוממה' },
  { value: 'shlonsky', label: 'שלונסקי' }

      ],
    
'neve-avivim': [
  
  { value: 'oppenheimer', label: 'אופנהיימר' },
  { value: 'usha', label: 'אושה' },
  { value: 'einstein', label: 'איינשטיין' },
  { value: 'andersen', label: 'אנדרסן' },
  { value: 'arya-pasternak', label: 'אריה פסטרנק' },
  { value: 'bart', label: 'בארט' },
  { value: 'bergson', label: 'ברגסון' },
  { value: 'geiger', label: 'גייגר' },
  { value: 'daniel-moritz', label: 'דניאל מוריץ' },
  { value: 'haamoraim', label: 'האמוראים' },
  { value: 'hophein', label: 'הופיין' },
  { value: 'hasavoraim', label: 'הסבוראים' },
  { value: 'hatanayim', label: 'התנאים' },
  { value: 'tagore-rabindranath', label: 'טאגור רבינדרנארט' },
  { value: 'yehuda-hanasi', label: 'יהודה הנשיא' },
  { value: 'itzhak-levitan', label: 'יצחק לויטן' },
  { value: 'chaim-lebanon', label: 'לבנון חיים' },
  { value: 'nahum-guttman', label: 'נחום גוטמן' },
  { value: 'pilchovsky', label: 'פילכובסקי' },
  { value: 'rav-ashi', label: 'רב אשי' },
  { value: 'ravina', label: 'רבינא' }

   ], 

    'revivim': [
      
  { value: 'amirim', label: 'אמירים' },
  { value: 'arya-disenchik', label: 'אריה דיסנצ\'יק' },
  { value: 'aram-moshe', label: 'ארם משה' },
  { value: 'baruch-chmarinsky', label: 'ברוך צ\'מרינסקי' },
  { value: 'bertonov-yehoshua', label: 'ברטונוב יהושע' },
  { value: 'dov-karami', label: 'דב כרמי' },
  { value: 'devora-haneviya', label: 'דבורה הנביאה' },
  { value: 'hazaz-chaim', label: 'הזז חיים' },
  { value: 'volman-yehuda', label: 'וולמן יהודה' },
  { value: 'tabenkin-yitzhak', label: 'טבנקין יצחק' },
  { value: 'kisufim', label: 'כיסופים' },
  { value: 'pinchas-rozen', label: 'פנחס רוזן' },
  { value: 'ptachya-margenshburg', label: 'פתחיה מרגנשבורג' },
  { value: 'revivim', label: 'רביבים' },
  { value: 'richter-zeev', label: 'רכטר זאב' },
  { value: 'sharon-arya-adr', label: 'שרון אריה אדר\'' },
  { value: 'tirosh', label: 'תירוש' }
], 

    
 'ramat-aviv-g': [
   
  { value: 'aba-achimeir', label: 'אב"א אחימאיר' },
  { value: 'avraham-boyar', label: 'אברהם בויאר' },
  { value: 'avshalom-haviv', label: 'אבשלום חביב' },
  { value: 'eliyahu-hakim', label: 'אליהו חכים' },
  { value: 'eliezer-kashani', label: 'אליעזר קשאני' },
  { value: 'mordechai-elkahi', label: 'אלקחי מרדכי' },
  { value: 'eliyahu-betzuri', label: 'בית צורי אליהו' },
  { value: 'akiva-baron', label: 'ברון עקיבא' },
  { value: 'moshe-barazani', label: 'ברזאני משה' },
  { value: 'shmuel-barkai', label: 'ברקאי שמואל' },
  { value: 'dov-gruner', label: 'גרונר דב' },
  { value: 'yehiel-drezner', label: 'דרזנר יחיאל' },
  { value: 'hanoter', label: 'הנוטר' },
  { value: 'meir-nakar', label: 'מאיר נקר' },
  { value: 'feinstein', label: 'פיינשטיין' },
  { value: 'pinchas-shinman', label: 'פנחס שינמן' },
  { value: 'recanati', label: 'רקנאטי' },
  { value: 'shlomo-ben-yosef', label: 'שלמה בן-יוסף' }

  ],   

    'ramat-aviv-n': [
      
  { value: 'eli-cohen', label: 'אלי כהן' },
  { value: 'arya-dulchin', label: 'אריה דולצ\'ין' },
  { value: 'eshkol-levi', label: 'אשכול לוי' },
  { value: 'yosef-zaritsky', label: 'יוסף זריצקי' },
  { value: 'moshe-perlok', label: 'משה פרלוק' },
  { value: 'natan-axelrod', label: 'נתן אקסלרוד' },
  { value: 'steimatzky', label: 'סטימצקי' },
  { value: 'shmuel-rodensky', label: 'רודנסקי שמואל' },
  { value: 'shmuel-tamir', label: 'שמואל תמיר' },
  { value: 'shraga-friedman', label: 'שרגא פרידמן' }

    ],
    
      'ramat-aviv': [
  
  { value: 'einstein', label: 'איינשטיין' },
  { value: 'asher-barash', label: 'אשר ברש' },
  { value: 'brody', label: 'ברודי' },
  { value: 'brodetsky', label: 'ברודצקי' },
  { value: 'brazil', label: 'ברזיל' },
  { value: 'berliner', label: 'ברלינר' },
  { value: 'gruniman', label: 'גרונימן' },
  { value: 'baron-hirsch', label: 'הברון הירש' },
  { value: 'hartglas', label: 'הרטגלס' },
  { value: 'harari', label: 'הררי' },
  { value: 'haim-lebanon', label: 'חיים לבנון' },
  { value: 'turtsiner', label: 'טורטשינר' },
  { value: 'yehuda-karni', label: 'יהודה קרני' },
  { value: 'yosef-patai', label: 'יוסף פטאי' },
  { value: 'kfar-yona', label: 'כפר יונה' },
  { value: 'lehober', label: 'לחובר' },
  { value: 'leon-blum', label: 'ליאון בלום' },
  { value: 'mordechai-ben-halel', label: 'מרדכי בן-הלל' },
  { value: 'noah', label: 'נח' },
  { value: 'fichman', label: 'פיכמן' },
  { value: 'frankel', label: 'פראנקל' },
  { value: 'tzemach-hayehudim', label: 'צמחי היהודים' },
  { value: 'krois', label: 'קרויס' },
  { value: 'reading', label: 'רדינג' },
  { value: 'shimoni', label: 'שמעוני' }

],
   'nofe-yam': [
{ value: 'amir_gilboa', label: 'אמיר גלבוע' },
{ value: 'arthur_rubinstein', label: 'ארתור רובינשטיין' },
{ value: 'david_oistrakh', label: 'דוד אויסטרך' },
{ value: 'dmitri_shostakovich', label: 'דימטרי שוסטקוביץ' },
{ value: 'jascha_heifetz', label: 'יאשה חפץ' },
{ value: 'yehezkel_streichman', label: 'יחזקאל שטרייכמן' },
{ value: 'levi_eshkol', label: 'לוי אשכול' },
{ value: 'marc_chagall', label: 'מארק שאגאל' },
{ value: 'prof_yuval_neeman', label: 'פרופ\' יובל נאמן' }

     ],
    'tel-baruch': [
 
  { value: 'aharon-maskin', label: 'אהרון מסקין' },
  { value: 'ugarit', label: 'אוגרית' },
  { value: 'ofir', label: 'אופיר' },
  { value: 'beit-horon', label: 'בית חורון' },
  { value: 'bney-ephraim', label: 'בני אפרים' },
  { value: 'zerubavel-yaakov', label: 'זרובבל יעקב' },
  { value: 'haim-shorer', label: 'חיים שורר' },
  { value: 'chana-rubina', label: 'חנה רובינא' },
  { value: 'hatzor', label: 'חצור' },
  { value: 'yigal-musinson', label: 'יגאל מוסינזון' },
  { value: 'yosef-milo', label: 'יוסף מילוא' },
  { value: 'mivtza-kadesh', label: 'מבצע קדש' },
  { value: 'migdal-shorshan', label: 'מגדל שורשן' },
  { value: 'mizan', label: 'מיזאן' },
  { value: 'stefan-zweig', label: 'סטפן צוויג' },
  { value: 'omri', label: 'עמרי' },
  { value: 'kehilat-sofia', label: 'קהילת סופיה' },
  { value: 'cyprus', label: 'קפריסין' },
  { value: 'karl-herbst', label: 'קרל הרבסט' },
  { value: 'keren-kayemet', label: 'קרן קיימת לישראל' },
  { value: 'rozanis', label: 'רוזאניס' },
  { value: 'romano', label: 'רומנו' },
  { value: 'rehov-1326', label: "רח' 1326" },
  { value: 'rafidim', label: 'רפידים' },
  { value: 'snir', label: 'שניר' },
  { value: 'tel-baruch', label: 'תל ברוך' }

    ],
'tel-baruch-n': [
  
  { value: 'aharon-becker', label: 'אהרון בקר' },
  { value: 'alexander-pen', label: 'אלכסנדר פן' },
  { value: 'bney-ephraim', label: 'בני אפרים' },
  { value: 'chana-rubina', label: 'חנה רובינא' },
  { value: 'yocheved-bat-miriam', label: 'יוכבד בת-מרים' },
  { value: 'yaakov-meridor', label: 'יעקב מרידור' },
  { value: 'mordechai-meir', label: 'מרדכי מאייר' },
  { value: 'moshe-sneh', label: 'משה סנה' },
  { value: 'stefan-zweig', label: 'סטפן צוויג' }
],

    
    'ganei-tzahala': [
  { value: 'avuka', label: 'אבוקה' },
  { value: 'avraham-broides', label: 'אברהם ברוידס' },
  { value: 'aharon-itin', label: 'אהרון איתין' },
  { value: 'aharon-moyal', label: 'אהרון מויאל' },
  { value: 'oskar-schindler', label: 'אוסקר שינדלר' },
  { value: 'uri-kisari', label: 'אורי קיסרי' },
  { value: 'arya-galblum', label: 'אריה גלבלום' },
  { value: 'arya-soslik', label: 'אריה סוסליק' },
  { value: 'arya-puchovsky', label: 'אריה פוחובסקי' },
  { value: 'baruch-agadati', label: 'ברוך אגדתי' },
  { value: 'galit', label: 'גלית' },
  { value: 'ganigar', label: 'גניגר' },
  { value: 'gaaton', label: 'געתון' },
  { value: 'gropit', label: 'גרופית' },
  { value: 'dr-ruth-peled', label: 'ד"ר רות פלד' },
  { value: 'dvorah-haneviah', label: 'דבורה הנביאה' },
  { value: 'aluf-moti-hod', label: 'האלוף מרדכי (מוטי) הוד' },
  { value: 'hamatzbiim', label: 'המצבאים' },
  { value: 'hasachkanim', label: 'השחקנים' },
  { value: 'vilhelm-felderman', label: 'וילהלם פלדרמן' },
  { value: 'zlibenski', label: 'זליבנסקי' },
  { value: 'chaim-weissburg', label: 'חיים ויסבורג' },
  { value: 'tolkovsky', label: 'טולקובסקי' },
  { value: 'yehuda-leib-barski', label: 'יהודה לייב ברסקי' },
  { value: 'yosef-hermelin', label: 'יוסף הרמלין' },
  { value: 'yosef-pomeruk', label: 'יוסף פומרוק' },
  { value: 'itzhak-wittenberg', label: 'יצחק ויטנברג' },
  { value: 'yeshayahu-avrakh', label: 'ישעיהו אברך' },
  { value: 'lea-ve-david-izmuzhik', label: 'לאה ודוד איזמוז\'יק' },
  { value: 'michael-ben-gal', label: 'מיכאל בן גל' },
  { value: 'moshe-sneh', label: 'משה סנה' },
  { value: 'matityahu-shoham', label: 'מתתיהו שוהם' },
  { value: 'nahum-weinstein', label: 'נחום וינשטיין' },
  { value: 'nelly-zaks', label: 'נלי זק"ש' },
  { value: 'segal-shmulik', label: 'סגל שמוליק' },
  { value: 'ayin-halel', label: 'ע\' הלל' },
  { value: 'uzi-narkis', label: 'עוזי נרקיס' },
  { value: 'ir-shemesh', label: 'עיר שמש' },
  { value: 'immanuel-zamir', label: 'עמנואל זמיר' },
  { value: 'anatot', label: 'ענתות' },
  { value: 'tzvi-fridlend', label: 'צבי פרידלנד' },
  { value: 'tzahal', label: 'צה"ל' },
  { value: 'rehov-2336', label: 'רח\' 2336' },
  { value: 'rakhel-ve-shmuel-idleson', label: 'רחל ושמואל אידלסון' },
  { value: 'shimon-finkel', label: 'שמעון פינקל' }

     ], 
    'tzahala': [
{ value: 'avishai', label: 'אבישי' },
{ value: 'avner', label: 'אבנר' },
{ value: 'adirim', label: 'אדירים' },
{ value: 'ehud', label: 'אהוד' },
{ value: 'oskar_schindler', label: 'אוסקר שינדלר' },
{ value: 'amnon_vetamar', label: 'אמנון ותמר' },
{ value: 'benayahu', label: 'בניהו' },
{ value: 'barak', label: 'ברק' },
{ value: 'bat_chen', label: 'בת-חן' },
{ value: 'bat_yiftach', label: 'בת-יפתח' },
{ value: 'dvora_hanevia', label: 'דבורה הנביאה' },
{ value: 'hamatzbaim', label: 'המצבאים' },
{ value: 'haparsa', label: 'הפרסה' },
{ value: 'harduf', label: 'הרדוף' },
{ value: 'hashoshanim', label: 'השושנים' },
{ value: 'yehonatan', label: 'יהונתן' },
{ value: 'yoav', label: 'יואב' },
{ value: 'marganit', label: 'מרגנית' },
{ value: 'nurit', label: 'נורית' },
{ value: 'savion', label: 'סביון' },
{ value: 'asahel', label: 'עשהאל' },
{ value: 'tzahal', label: 'צה"ל' },
{ value: 'shamgar', label: 'שמגר' },
{ value: 'shimon_finkel', label: 'שמעון פינקל' }

     ],  

    'ramat-hachayal': [ 
      
  { value: 'biriya', label: 'בירייה' },
  { value: 'gadna', label: 'גדנ"ע' },
  { value: 'golei-kenya-1', label: 'גולי קניה' },
  { value: 'golei-kenya-2', label: 'גולי קניה' },
  { value: 'david-marcus', label: 'דוד מרכוס' },
  { value: 'hagolan', label: 'הגולן' },
  { value: 'hatet-zayin', label: 'הט"ז' },
  { value: 'halamed-hei', label: 'הלמ"ד ה"א' },
  { value: 'harel', label: 'הראל' },
  { value: 'harugei-malchut', label: 'הרוגי מלכות' },
  { value: 'trittsch', label: 'טריטש' },
  { value: 'levita', label: 'לויטה' },
  { value: 'lipa-krapel', label: 'ליפא קרפל' },
  { value: 'nissan-cohen', label: 'ניסן כהן' },
  { value: 'namirover', label: 'נמירובר' },
  { value: 'olei-hagardom', label: 'עולי הגרדום' },
  { value: 'atarot', label: 'עטרות' },
  { value: 'immanuel-tovim', label: 'עמנואל טובים' },
  { value: 'kaf-mem', label: 'ק"ם' },
  { value: 'revadim', label: 'רבדים' },
  { value: 'rozov', label: 'רוזוב' },
  { value: 'ramot-naftali', label: 'רמות נפתלי' },
  { value: 'shteiner', label: 'שטיינר' }
],


    'neve-dan': [ 
            
  { value: 'even-sapir', label: 'אבן ספיר' },
  { value: 'eldad-hadani', label: 'אלדד הדני' },
  { value: 'eliyahu-miperrara', label: 'אליהו מפירארה' },
  { value: 'ashkenazi', label: 'אשכנזי' },
  { value: 'basola', label: 'באסולה' },
  { value: 'benjamin-mitudela', label: 'בנימין מטודלה' },
  { value: 'zigmund-turkov', label: 'זיגמונד טורקוב' },
  { value: 'yosef-de-la-reina', label: 'יוסף דה-לה-ריינה' },
  { value: 'itzhak-chilo', label: 'יצחק חילו' },
  { value: 'mishmar-hayarden', label: 'משמר הירדן' },
  { value: 'nachlaot', label: 'נחלאות' },
  { value: 'pinchas-rozen', label: 'פנחס רוזן' },
  { value: 'ptachya-margenshburg', label: 'פתחיה מרגנשבורג' },
  { value: 'romaneli', label: 'רומנילי' },
  { value: 'tvuot-haaretz', label: 'תבואות הארץ' }
],

     'neve-sharet': [ 
       
  { value: 'avraham-susskin', label: 'אברהם סוסקין' },
  { value: 'adirim-1', label: 'אדירים' },
  { value: 'adirim-2', label: 'אדירים' },
  { value: 'achi-dakar', label: 'אח"י דקר' },
  { value: 'almagor', label: 'אלמגור' },
  { value: 'beit-el', label: 'בית אל' },
  { value: 'daf-hayomi', label: 'הדף היומי' },
  { value: 'haprasa', label: 'הפרסה' },
  { value: 'hatzanchanim', label: 'הצנחנים' },
  { value: 'korazim', label: 'כורזים' },
  { value: 'naharayim', label: 'נהריים' },
  { value: 'philadelphia', label: 'פילדלפיה' },
  { value: 'kehilat-cleveland', label: 'קהילת קליבלנד' },
  { value: 'raoul-wallenberg', label: 'ראול ולנברג' },
  { value: 'rama', label: 'רמה' }
],

'neve-chen': [ 
{ value: 'eliaz_rafael', label: 'אליעז רפאל' },
{ value: 'hatayasim', label: 'הטייסים' },
{ value: 'yehochin_stutschevsky', label: 'יהויכין סטוצ\'בסקי' },
{ value: 'yosef_volker', label: 'יוסף וולקר' },
{ value: 'motza', label: 'מוצא' },
{ value: 'machal', label: 'מח"ל' },
{ value: 'maapilei_egoz', label: 'מעפילי אגוז' },
{ value: 'snapir', label: 'סנפיר' }

  ],
     'hamishtala': [ 
{ value: 'david_avidan', label: 'דוד אבידן' },
{ value: 'wilensky_moshe', label: 'וילינסקי משה' },
{ value: 'hana_orloff', label: 'חנה אורלוב' },
{ value: 'levin_kipnis', label: 'לוין קיפניס' },
{ value: 'max_brod', label: 'מקס ברוד' },
{ value: 'max_seligman', label: 'מקס זליגמן' },
{ value: 'mordechai_zeira', label: 'מרדכי זעירא' },
{ value: 'moshe_kol', label: ' קול משה'},
{ value: 'lili_menachem', label: 'לילי מנחם' },
{ value: 'meir_binet', label: 'מאיר בינט' },
{ value: 'moshe_sneh', label: 'משה סנה' },
{ value: 'kiryat_shaul', label: 'קריית שאול' },
{ value: 'rehov_2421', label: 'רח\' 2421' },
{ value: 'sasha_argov', label: 'סשא ארגוב' },
{ value: 'paul_ben_haim', label: 'פאול בן חיים' },
{ value: 'franz_kafka', label: 'פרנץ קפקא' },
{ value: 'rehov_2280', label: 'רח\' 2280' },
{ value: 'shabtai_yaakov', label: 'שבתאי יעקב' },
{ value: 'shalom_levin', label: 'שלום לוין' },
{ value: 'tavin_eli', label: 'תבין אלי' }

   ],    
    'hadar-yosef': [
  { value: 'emil_brig', label: 'אמיל בריג' },
{ value: 'esh_shalom', label: 'אש שלום' },
{ value: 'ben_zabara', label: 'בן זבארה' },
{ value: 'bnei_efraim', label: 'בני אפרים' },
{ value: 'binyamin_mintz', label: 'בנימין מינץ' },
{ value: 'berechiah_hanakdan', label: 'ברכיהו הנקדן' },
{ value: 'david_hofshi', label: 'דוד חופשי' },
{ value: 'hadar_yosef', label: 'הדר יוסף' },
{ value: 'zechut_moshe', label: 'זכות משה' },
{ value: 'yad_hamaavir', label: 'יד המעביר' },
{ value: 'yehuda_somo', label: 'יהודה סומו' },
{ value: 'yosef_haefrati', label: 'יוסף האפרתי' },
{ value: 'yosef_kitzis', label: 'יוסף קיציס' },
{ value: 'mivtza_kadesh', label: 'מבצע קדש' },
{ value: 'pinchas_rosen', label: 'פנחס רוזן' },
{ value: 'kehilat_odessa', label: 'קהילת אודסה' },
{ value: 'kehilat_budapest', label: 'קהילת בודפסט' },
{ value: 'kehilat_bialystok', label: 'קהילת ביאליסטוק' },
{ value: 'kehilat_brisk', label: 'קהילת בריסק' },
{ value: 'kehilat_warsaw', label: 'קהילת ורשה' },
{ value: 'kehilat_chernovitz', label: 'קהילת טשרנוביץ' },
{ value: 'kehilat_iasi', label: 'קהילת יאסי' },
{ value: 'kehilat_lvov', label: 'קהילת לבוב' },
{ value: 'kehilat_lodz', label: "קהילת לודג'" },
{ value: 'kehilat_kishinev', label: 'קהילת קישינב' },
{ value: 'kehilat_krakow', label: 'קהילת קראקוב' },
{ value: 'shitrit', label: 'שיטרית' }

],

    'city-center': [
  { value: 'aharonson', label: 'אהרונסון' },
  { value: 'idleson-avraham', label: 'אידלסון אברהם' },
  { value: 'allenby', label: 'אלנבי' },
  { value: 'bogroshov', label: 'בוגרשוב' },
  { value: 'bialik', label: 'ביאליק' },
  { value: 'bilu', label: 'ביל"ו' },
  { value: 'ben-yehuda', label: 'בן יהודה' },
  { value: 'borochov', label: 'בורוכוב' },
  { value: 'brener', label: 'ברנר' },
  { value: 'geula', label: 'גאולה' },
  { value: 'grozenberg', label: 'גרוזנברג' },
  { value: 'hakovshim', label: 'הכובשים' },
  { value: 'hashmonaim', label: 'החשמונאים' },
  { value: 'hayarkon', label: 'הירקון' },
  { value: 'king-george', label: 'המלך ג\'ורג\'' },
  { value: 'moshe-has', label: 'הס משה' },
  { value: 'haavoda', label: 'העבודה' },
  { value: 'hakerem', label: 'הכרמל' },
  { value: 'melchett', label: 'מלצ\'ט' },
  { value: 'mishol-yaakov', label: 'משעול יעקב' },
  { value: 'harav-kook', label: 'הרב קוק' },
  { value: 'yonah-hanavi', label: 'יונה הנביא' },
  { value: 'yavne', label: 'יבנה' },
  { value: 'yosef-hanasi', label: 'יוסף הנשיא' },
  { value: 'yehuda-halevi', label: 'יהודה הלוי' },
  { value: 'kalisher', label: 'קלישר' },
  { value: 'mohliver', label: 'מוהליבר' },
  { value: 'maze', label: 'מזא"ה' },
  { value: 'marmorek', label: 'מרמורק' },
  { value: 'merkaz-baaley-melacha', label: 'מרכז בעלי מלאכה' },
  { value: 'nahalat-binyamin', label: 'נחלת בנימין' },
  { value: 'rabinovitz-shapira', label: 'רבינוביץ שפ"ר' },
  { value: 'rambam', label: 'רמב"ם' },
  { value: 'herbert-samuel-promenade', label: 'הרברט סמואל' },
  { value: 'sderot-ben-zion', label: 'שד\' בן ציון' },
  { value: 'sderot-rothschild', label: 'רוטשילד' },
  { value: 'tchernichovsky', label: 'טשרניחובסקי' },
  { value: 'trumpledor', label: 'טרומפלדור' },
  { value: 'chovevei-zion', label: 'חובבי ציון' },
  { value: 'hayot-peretz', label: 'חיות פרץ' },
  { value: 'daniel', label: 'דניאל' },
  { value: 'echad-haam', label: 'אחד העם' },
  { value: 'nahalat-binyamin', label: 'נחלת בנימין' },
  { value: 'ahuzat-beit', label: 'אחוזת בית' },
  { value: 'allenby', label: 'אלנבי' },
  { value: 'montefiore', label: 'מונטיפיורי' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'derech-yafo', label: 'דרך יפו' },
  { value: 'derech-begin', label: 'דרך בגין' },
  { value: 'sheinkin', label: 'שיינקין' },
  { value: 'fierberg', label: 'פיארברג' },
  { value: 'balfur', label: 'בלפור' },
  { value: 'nahmani', label: 'נחמני' },
  { value: 'harakevet', label: 'הרכבת' },
  { value: 'levontin', label: 'לבונטין' },
  { value: 'mikve-israel', label: 'מקוה ישראל' },
  { value: 'hachashmal', label: 'החשמל' },
  { value: 'saadia-gaon', label: 'סעדיה גאון' },
  { value: 'oliphant', label: 'אוליפנט' },
  { value: 'almonit', label: 'אלמונית' },
  { value: 'buki-ben-yogli', label: 'בוקי בן יוגלי' },
  { value: 'beit-hachaim', label: 'בית החיים' },
  { value: 'beit-hashoava', label: 'בית השואבה' },
  { value: 'beit-lechem', label: 'בית לחם' },
  { value: 'ben-tzion', label: 'בן ציון' },
  { value: 'betsalel-yafe', label: 'בצלאל יפה' },
  { value: 'bar-ilan', label: 'בר-אילן' },
  { value: 'bar-kochva', label: 'בר-כוכבא' },
  { value: 'berdichevsky', label: 'ברדיצבסקי' },
  { value: 'bernstein-cohen', label: 'ברנשטיין-כהן' },
  { value: 'george-eliot', label: 'ג\'ורג\' אליוט' },
  { value: 'george-lloyd', label: 'ג\'ורג\' לויד' },
  { value: 'gan-meir', label: 'גן מאיר' },
  { value: 'haor', label: 'האור' },
  { value: 'hagilboa', label: 'הגלבוע' },
  { value: 'heichal-hatalmud', label: 'היכל התלמוד' },
  { value: 'hayarden', label: 'הירדן' },
  { value: 'hamagid', label: 'המגיד' },
  { value: 'hamaccabi', label: 'המכבי' },
  { value: 'hamelitz', label: 'המליץ' },
  { value: 'hashomer', label: 'השומר' },
  { value: 'hashachar', label: 'השחר' },
  { value: 'hatavor', label: 'התבור' },
  { value: 'wilson', label: 'וילסון' },
  { value: 'warburg', label: 'ורבורג' },
  { value: 'chevron', label: 'חברון' },
  { value: 'chaim-veelisha', label: 'חיים ואלישע' },
  { value: 'tveria', label: 'טבריה' },
  { value: 'yochanan-ben-zakkai', label: 'יוחנן בן זכאי' },
  { value: 'yochanan-hasandler', label: 'יוחנן הסנדלר' },
  { value: 'yaavetz', label: 'יעב"ץ' },
  { value: 'itzhak-nafcha', label: 'יצחק נפחא' },
  { value: 'koresh', label: 'כורש' },
  { value: 'karmiya', label: 'כרמיה' },
  { value: 'lean-a', label: 'לאן א' },
  { value: 'lean-b', label: 'לאן ב' },
  { value: 'lunz', label: 'לונץ' },
  { value: 'lilienblum', label: 'לילינבלום' },
  { value: 'mikhal', label: 'מיכ"ל' },
  { value: 'nes-tziona', label: 'נס ציונה' },
  { value: 'ein-vered', label: 'עין ורד' },
  { value: 'amram-gaon', label: 'עמרם גאון' },
  { value: 'pinsker', label: 'פינסקר' },
  { value: 'plonit', label: 'פלונית' },
  { value: 'tzadok-hakohen', label: 'צדוק הכהן' },
  { value: 'tzeclag', label: 'צקלג' },
  { value: 'kiryat-sefer', label: 'קריית ספר' },
  { value: 'karlibach', label: 'קרליבך' },
  { value: 'rabenu-tam', label: 'רבנו תם' },
  { value: 'ramchal', label: 'רמח"ל' },
  { value: 'herbert-samuel-promenade', label: 'רציף הרברט סמואל' },
  { value: 'rashi', label: 'רש"י' },
  { value: 'sheva-hashkmaim', label: 'שבע השקמים' },
  { value: 'shadal', label: 'שד"ל' },
  { value: 'shtrauss', label: 'שטראוס' },
  { value: 'shalom-aleichem', label: 'שלום עליכם' },
  { value: 'shapira', label: 'שפ"ר' },
  { value: 'shapira-rabinovitz', label: 'שפ"ר (רבינוביץ)' },
  { value: 'sara-azaryahu', label: 'שרה עזריהו' },
  { value: 'lincoln', label: 'לינקולן' }
 ],
    'hatikva': [
  { value: 'aviasaf', label: 'אביאסף' },
  { value: 'avital', label: 'אביטל' },
  { value: 'avimelech', label: 'אבימלך' },
  { value: 'avraham-abbas', label: 'אברהם עבאס' },
  { value: 'achimatz', label: 'אחימעץ' },
  { value: 'achi-ezer', label: 'אחיעזר' },
  { value: 'itiel', label: 'איתיאל' },
  { value: 'eitan', label: 'איתן' },
  { value: 'aluf', label: 'אלוף' },
  { value: 'etzel', label: 'אצ"ל' },
  { value: 'ariel', label: 'אריאל' },
  { value: 'boaz', label: 'בועז' },
  { value: 'baytus', label: 'ביתוס' },
  { value: 'balshan', label: 'בלשן' },
  { value: 'ben-chayil', label: 'בן חיל' },
  { value: 'ben-chesed', label: 'בן חסד' },
  { value: 'barkhiya', label: 'ברכיה' },
  { value: 'bat-sheva-katznelson', label: 'בת-שבע כצנלסון' },
  { value: 'givati', label: 'גבעתי' },
  { value: 'gedalia', label: 'גדליה' },
  { value: 'goel', label: 'גואל' },
  { value: 'david-tidhar', label: 'דוד תדהר' },
  { value: 'doron', label: 'דורון' },
  { value: 'dayan-moshe', label: 'דיין משה' },
  { value: 'deuel', label: 'דעואל' },
  { value: 'ha-agmon', label: 'האגמון' },
  { value: 'ha-eucalyptus', label: 'האיקליפטוס' },
  { value: 'habrosh', label: 'הברוש' },
  { value: 'hahagana', label: 'ההגנה' },
  { value: 'hodiya', label: 'הודיה' },
  { value: 'hona', label: 'הונא' },
  { value: 'hayman', label: 'היימן' },
  { value: 'hamachbesh', label: 'המכבש' },
  { value: 'harotem', label: 'הרותם' },
  { value: 'hartuv', label: 'הרטוב' },
  { value: 'haran', label: 'הרן' },
  { value: 'hashita', label: 'השיטה' },
  { value: 'haskel', label: 'השכל' },
  { value: 'hatikva', label: 'התקווה' },
  { value: 'vilon', label: 'וילון' },
  { value: 'vered', label: 'ורד' },
  { value: 'veradiel', label: 'ורדיאל' },
  { value: 'vatik', label: 'ותיק' },
  { value: 'zeved', label: 'זבד' },
  { value: 'zerach', label: 'זרח' },
  { value: 'chanokh', label: 'חנוך' },
  { value: 'chefer', label: 'חפר' },
  { value: 'talmon', label: 'טלמון' },
  { value: 'tarfon', label: 'טרפון' },
  { value: 'yair', label: 'יאיר' },
  { value: 'yonadav', label: 'יונדב' },
  { value: 'yoram', label: 'יורם' },
  { value: 'izhar', label: 'יזהר' },
  { value: 'yechiyam', label: 'יחיעם' },
  { value: 'yamin', label: 'ימין' },
  { value: 'yekutiel', label: 'יקותיאל' },
  { value: 'kavir', label: 'כביר' },
  { value: 'karmi', label: 'כרמי' },
  { value: 'liveluv', label: 'לבלוב' },
  { value: 'lechi', label: 'לח"י' },
  { value: 'lish', label: 'ליש' },
  { value: 'lemuel', label: 'למואל' },
  { value: 'lapidot', label: 'לפידות' },
  { value: 'mivchar', label: 'מבחר' },
  { value: 'mevaser', label: 'מבשר' },
  { value: 'moshia', label: 'מושיע' },
  { value: 'metzuba', label: 'מצובה' },
  { value: 'nadav', label: 'נדב' },
  { value: 'nuriel', label: 'נוריאל' },
  { value: 'netaim', label: 'נטעים' },
  { value: 'naaman', label: 'נעמן' },
  { value: 'natan', label: 'נתן' },
  { value: 'siman-tov', label: 'סימן טוב' },
  { value: 'smadar', label: 'סמדר' },
  { value: 'ivri', label: 'עברי' },
  { value: 'ozer', label: 'עוזר' },
  { value: 'azai', label: 'עזאי' },
  { value: 'plugot', label: 'פלוגות' },
  { value: 'paltiel', label: 'פלטיאל' },
  { value: 'penuel', label: 'פנואל' },
  { value: 'tzuri-shedi', label: 'צורישדי' },
  { value: 'tzafrir', label: 'צפריר' },
  { value: 'kedmiel', label: 'קדמיאל' },
  { value: 'kehilat-new-york', label: 'קהילת ניו יורק' },
  { value: 'kalman', label: 'קלמן' },
  { value: 'kemuel', label: 'קמואל' },
  { value: 'kiryati', label: 'קרייתי' },
  { value: 'roni', label: 'רוני' },
  { value: 'razi', label: 'רזי' },
  { value: 'rechov-fed', label: 'רח\' פד' },
  { value: 'rachel-cohen-kagan', label: 'רחל כהן כגן' },
  { value: 'ratzon', label: 'רצון' },
  { value: 'reshafim', label: 'רשפים' },
  { value: 'shabtai', label: 'שבתאי' },
  { value: 'shalmon', label: 'שלמון' },
  { value: 'simcha', label: 'שמחה' },
  { value: 'sasson', label: 'ששון' },
  { value: 'tardion', label: 'תרדיון' },
  { value: 'tishbi', label: 'תשבי' }
    ],  
    
    'yad-eliyahu': [
     
  { value: 'ani-maamin', label: 'אני מאמין' },
  { value: 'anilevich-mordechai', label: 'אנילביץ מרדכי' },
  { value: 'arya-altman', label: 'אריה אלטמן' },
  { value: 'beit-oren', label: 'בית אורן' },
  { value: 'beit-yerach', label: 'בית ירח' },
  { value: 'binyamin-bergi', label: 'בנימין ברגי' },
  { value: 'bat-tzion', label: 'בת-ציון' },
  { value: 'givati', label: 'גבעתי' },
  { value: 'gush-etzion', label: 'גוש עציון' },
  { value: 'davidka', label: 'דוידקה' },
  { value: 'dimona', label: 'דימונה' },
  { value: 'hagibor-haalmoni', label: 'הגבור האלמוני' },
  { value: 'hagayasot', label: 'הגייסות' },
  { value: 'hahagana', label: 'ההגנה' },
  { value: 'hachotrim', label: 'החותרים' },
  { value: 'hachayal', label: 'החי"ל' },
  { value: 'hamapilim', label: 'המעפילים' },
  { value: 'hama’aracha', label: 'המערכה' },
  { value: 'hasayarim', label: 'הסיירים' },
  { value: 'hapalmach', label: 'הפלמ"ח' },
  { value: 'hapartizan-hayehudi', label: 'הפרטיזן היהודי' },
  { value: 'herodion', label: 'הרודיון' },
  { value: 'hashlosha', label: 'השלושה' },
  { value: 'wedgwood', label: 'ווג\'ווד' },
  { value: 'wingate', label: 'וינגייט' },
  { value: 'winston-churchill', label: 'וינסטון צ\'רצ\'יל' },
  { value: 'jacques-halevi', label: 'ז\'ק הלוי' },
  { value: 'haviva-reik', label: 'חביבה רייק' },
  { value: 'hannah-senesh', label: 'חנה סנש' },
  { value: 'hanita', label: 'חניתה' },
  { value: 'charutz', label: 'חרוץ' },
  { value: 'tur-malka', label: 'טור מלכא' },
  { value: 'yigal-allon', label: 'יגאל אלון' },
  { value: 'yagur', label: 'יגור' },
  { value: 'yad-labanim', label: 'יד לבנים' },
  { value: 'yiftach', label: 'יפתח' },
  { value: 'itzhak-sadeh', label: 'יצחק שדה' },
  { value: 'yetziat-europa', label: 'יציאת אירופה' },
  { value: 'la-guardia', label: 'לה גארדיה' },
  { value: 'lochemei-gallipoli', label: 'לוחמי גליפולי' },
  { value: 'monash', label: 'מונאש' },
  { value: 'mordey-hagetaot', label: 'מורדי הגטאות' },
  { value: 'melilot', label: 'מלילות' },
  { value: 'maslul', label: 'מסלול' },
  { value: 'metzudat-beitar', label: 'מצודת בית"ר' },
  { value: 'margolin', label: 'מרגולין' },
  { value: 'moshe-dayan', label: 'משה דיין' },
  { value: 'moshe-kalmar', label: 'משה קלמר' },
  { value: 'negba', label: 'נגבה' },
  { value: 'nirim', label: 'נירים' },
  { value: 'struma', label: 'סטרומה' },
  { value: 'einot', label: 'עיינות' },
  { value: 'ein-gev', label: 'עין גב' },
  { value: 'emek-ayyalon', label: 'עמק איילון' },
  { value: 'peterson', label: 'פטרסון' },
  { value: 'perazon', label: 'פרזון' },
  { value: 'caesarea', label: 'קיסריה' },
  { value: 'kish', label: 'קיש' },
  { value: 'rehov-1019', label: 'רח\' 1019' },
  { value: 'sha’ar-hagay', label: 'שער הגיא' },
  { value: 'timna', label: 'תמנע' },
  { value: 'taoz', label: 'תעוז' }
],

    'ramat-hatayasim': [
 { value: 'hachavatzelet', label: 'החבצלת' },
 { value: 'hatzvi', label: 'הצבי' },
 { value: 'hashalom', label: 'השלום' },
 { value: 'yosef_asherman', label: 'יוסף אשרמן' },
 { value: 'oded', label: 'עודד' },
 { value: 'amishav', label: 'עמישב' }

],
    'kfar-shalem': [
  
  { value: 'elbaz-natan', label: 'אלבז נתן' },
  { value: 'aluf-dan-lenner', label: 'אלוף דן לנר' },
  { value: 'harav-yosef-tzobari', label: 'הרב יוסף צוברי' },
  { value: 'harav-raphael-ankawa', label: 'הרב רפאל אנקווה' },
  { value: 'chaim-bar-lev', label: 'חיים בר-לב' },
  { value: 'chananel-asher', label: 'חננאל אשר' },
  { value: 'yehuda-hatzair', label: 'יהודה הצעיר' },
  { value: 'yaakov-ben-sira', label: 'יעקב בן סירא' },
  { value: 'itzhak-zuckerman', label: 'יצחק צוקרמן' },
  { value: 'lubetkin-tzivia', label: 'לובטקין צביה' },
  { value: 'monia-mardor', label: 'מוניה מרדור' },
  { value: 'machal', label: 'מח"ל' },
  { value: 'adah', label: 'עדה' },
  { value: 'tzora', label: 'צרעה' },
  { value: 'rehov-le-kefer-shalem', label: 'רח\' לה כפר שלם' },
  { value: 'rehov-sa-ke-shalem', label: 'רח\' סה כ שלם' },
  { value: 'rafi-vaknin', label: 'רפי וקנין' },
  { value: 'shimon-avidan', label: 'שמעון אבידן' },
  { value: 'sheshet-hayamim', label: 'ששת הימים' },
  { value: 'hahagana', label: 'ההגנה' },
  { value: 'harav-elenkawa', label: 'הרב אלנקווה' },
  { value: 'yosef-sarlin', label: 'יוסף סרלין' },
  { value: 'hallel-haadani', label: 'מהלל העדני' },
  { value: 'mordechai-gebirtig', label: 'מרדכי גבירטיג' },
  { value: 'rehov-4845', label: 'רח\' 4845' },
  { value: 'rehov-tet-zayin-kefer-shalem', label: 'רח\' טז כפר שלם' }


],
    'montefiore': [
  { value: 'isralish', label: 'איסרליש' },
  { value: 'begin', label: 'בגין' },
  { value: 'beit-alfa', label: 'בית אלפא' },
  { value: 'beit-hillel', label: 'בית הלל' },
  { value: 'beit-oved', label: 'בית עובד' },
  { value: 'beit-shamai', label: 'בית שמאי' },
  { value: 'ben-abigdor', label: 'בן-אביגדור' },
  { value: 'avigdor-shaul', label: 'אביגדור שאול' },
  { value: 'gershon-gaga-shatz', label: 'גרשון (גגה) שץ' },
  { value: 'david-hakhami', label: 'דוד חכמי' },
  { value: 'haachim-meslavita', label: 'האחים מסלאויטה' },
  { value: 'hamelakha', label: 'המלאכה' },
  { value: 'hamasger', label: 'המסגר' },
  { value: 'hamiktsoa', label: 'המקצוע' },
  { value: 'hanatziv', label: 'הנצי"ב' },
  { value: 'hatsfira', label: 'הצפירה' },
  { value: 'harechev', label: 'הרכב' },
  { value: 'hataasiya', label: 'התעשייה' },
  { value: 'choma-umigdal', label: 'חומה ומגדל' },
  { value: 'tversky', label: 'טברסקי' },
  { value: 'yegia-kapayim', label: 'יגיע כפיים' },
  { value: 'yad-kharutsim', label: 'יד חרוצים' },
  { value: 'yehudit', label: 'יהודית' },
  { value: 'yosef-karo', label: 'יוסף קארו' },
  { value: 'yelin-mor-natan', label: 'ילין מור נתן' },
  { value: 'yitzhak-sadeh', label: 'יצחק שדה' },
  { value: 'yisrael-bak', label: 'ישראל ב"ק' },
  { value: 'la-guardia', label: 'לה גווארדייה' },
  { value: 'mikunis-shmuel', label: 'מיקוניס שמואל' },
  { value: 'nakhal-ayalon', label: 'נחל איילון' },
  { value: 'raam', label: 'ראם' },
  { value: 'rabnitzky', label: 'רבניצקי' },
  { value: 'rehov-1244', label: 'רח\' 1244' },
  { value: 'rehov-1274', label: 'רח\' 1274' },
  { value: 'rehov-1277', label: 'רח\' 1277' },
  { value: 'rehov-1278', label: 'רח\' 1278' },
  { value: 'ribal', label: 'ריב"ל' },
  { value: 'shontsino', label: 'שונצינו' },
  { value: 'shtibel', label: 'שטיבל' },
  { value: 'shefa-tal', label: 'שפע טל' },
  { value: 'tushiya', label: 'תושיה' }

],
    'yafo': [
  { value: 'jerusalem-blvd', label: 'שד\' ירושלים' },
  { value: 'olei-zion', label: 'עולי ציון' },
  { value: 'goldman-nahum', label: 'גולדמן נחום' },
  { value: 'raziel', label: 'רזיאל' },
  { value: 'marzok-ve-ezer', label: 'מרזוק ועזר' },
  { value: 'poriya', label: 'פוריה' },
  { value: 'harav-mi-bachrach', label: 'הרבי מבכרך' },
  { value: 'eylat', label: 'אילת' },
  { value: 'derech-shlomo', label: 'דרך שלמה' },
  { value: 'eliphelet', label: 'אליפלט' },
  { value: 'aboulafia', label: 'אבולעפיה' },
  { value: 'alfasi', label: 'אלפסי' },
  { value: 'rabenu-chananel', label: 'רבנו חננאל' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'ben-tzvi-road', label: 'דרך בן צבי' },
  { value: 'hayesod', label: 'היסוד' },
  { value: 'hazera', label: 'הזרם' },
  { value: 'hatchiya', label: 'התחיה' },
  { value: 'sheerit-yisrael', label: 'שארית ישראל' },
  { value: 'kibbutz-galuyot', label: 'קבוץ גלויות' },
  { value: 'migdalor', label: 'המגדלור' },
  { value: 'mifrats-shlomo', label: 'מפרץ שלמה' },
  { value: 'yefet', label: 'יפת' },
  { value: 'pasteur', label: 'פסטר' },
  { value: 'kedem', label: 'קדם' },
  { value: 'hatzedef', label: 'הצדף' },
  { value: 'haogen', label: 'העוגן' },
  { value: 'hasfina', label: 'הספינה' },
  { value: 'hashachaf', label: 'השחף' },
  { value: 'even-sina', label: 'אבן סינא' },
  { value: 'shmuel-ben-adya', label: 'שמואל בן עדיה' },
  { value: 'yehuda-hayamit', label: 'יהודה הימית' },
  { value: 'haharuv', label: 'החרוב' },
  { value: 'valencia', label: 'ולנסיה' },
  { value: 'shluchot', label: 'שלוחות' },
  { value: 'halotus', label: 'הלוטוס' },
  { value: 'mendes-france', label: 'פייר מנדס פרנס' },
  { value: 'bat-yam', label: 'בת ים' },
  { value: 'toulouse', label: 'טולוז' },
  { value: 'haetrog', label: 'האתרוג' },
  { value: 'magen-avraham', label: 'מגן אברהם' },
  { value: 'yehuda-margoza', label: 'יהודה מרגוזה' },
  { value: 'dror', label: 'דרור' },
  { value: 'michelangelo', label: 'מיכאל אנג\'לו' },
  { value: 'avinari-yitzhak', label: 'אבינרי יצחק' },
  { value: 'shivtei-yisrael', label: 'שבטי ישראל' },
  { value: 'erlich', label: 'ארליך' },
  { value: 'tzevetli', label: 'ציהתל"י' },
  { value: 'nachman-mi-breslav', label: 'נחמן מברסלב' },
  { value: 'baal-shem-tov-blvd', label: 'שד\' הבעש"ט' },
  { value: 'chabad-blvd', label: 'שד\' חב"ד' },
  { value: 'fikus', label: 'פיקוס' },
  { value: 'saharon', label: 'סהרון' },
  { value: 'harif-eizik', label: 'חריף אייזיק' },
  { value: 'aplaton', label: 'אפלטון' },
  { value: 'holtzberg-shimcha', label: 'הולצברג שמחה' },
  { value: 'leagues-of-nations', label: 'חבר הלאומים' },
  { value: 'nes-legoyim', label: 'נס לגויים' },
  { value: 'rabenu-yerucham', label: 'רבנו ירוחם' },
  { value: 'midreshet-tanchuma', label: 'מדרשת תנחומא' },
  { value: 'gruenbaum', label: 'גרינבוים' },
  { value: 'shrira-gaon', label: 'שרירא גאון' },
  { value: 'or-hachaim', label: 'אור החיים' },
  { value: 'ohalei-yaakov', label: 'אהלי יעקב' },
  { value: 'grossman-meir', label: 'גרוסמן מאיר' },
  { value: 'tzunz', label: 'צונץ' },
  { value: 'halohamim', label: 'הלוחמים' },
  { value: 'yigal-yadin', label: 'דרך יגאל ידין' },
  { value: 'tel-giborim', label: 'תל גבורים' },
  { value: 'beer-sheva', label: 'באר שבע' },
  { value: 'chasidei-haumot', label: 'חסידי האומות' },
  { value: 'nahal-habesor', label: 'נחל הבשור' },
  { value: 'harav-haler-chaim', label: 'הרב הלר חיים' },
  { value: 'koch-edward', label: 'קוץ\' אדוארד' },
  { value: 'rubinstein-yitzhak', label: 'רובינשטיין יצחק' },
  { value: 'kehilat-canada', label: 'קהילת קנדה' },
  { value: 'chinanit', label: 'חיננית' },
  { value: 'makhrozet', label: 'מחרוזת' },
  { value: 'paamonit', label: 'פעמונית' }
],
    'nachaltizhack': [
{ value: 'aharon_binyamini', label: 'אהרון בנימיני' },
{ value: 'alon_yigal', label: 'אלון יגאל' },
{ value: 'ben_shemen', label: 'בן שמן' },
{ value: 'bruriah', label: 'ברוריה' },
{ value: 'ginosar', label: 'גינוסר' },
{ value: 'hashalom', label: 'השלום' },
{ value: 'ziman', label: 'זימן' },
{ value: 'hayei_adam', label: 'חיי אדם' },
{ value: 'hafetz_haim', label: 'חפץ חיים' },
{ value: 'tirat_zvi', label: 'טירת צבי' },
{ value: 'yabok', label: 'יבוק' },
{ value: 'yalkut_haroim', label: 'ילקוט הרועים' },
{ value: 'yokneam', label: 'יקנעם' },
{ value: 'moses_yehuda_ve_noach', label: 'מוזס יהודה ונח' },
{ value: 'moreshet_yahadut_lita', label: 'מורשת יהדות ליטא' },
{ value: 'menorat_hamaor', label: 'מנורת המאור' },
{ value: 'nahalal', label: 'נהלל' },
{ value: 'nahalat_yitzhak', label: 'נחלת יצחק' },
{ value: 'neta', label: 'נטע' },
{ value: 'ein_zeitim', label: 'עין זיתים' },
{ value: 'aliyat_hanoar', label: 'עליית הנוער' },
{ value: 'emek_bracha', label: 'עמק ברכה' },
{ value: 'arvei_nahal', label: 'ערבי נחל' },
{ value: 'paat_hashulchan', label: 'פאת השולחן' },
{ value: 'pirchei_aviv', label: 'פרחי אביב' },
{ value: 'pri_megadim', label: 'פרי מגדים' },
{ value: 'shvil_hahalav', label: 'שביל החלב' },
{ value: 'totzeret_haaretz', label: 'תוצרת הארץ' }

     ], 
    'bizaron': [
{ value: 'alon_yigal', label: 'אלון יגאל' },
{ value: 'artar_yitzhak', label: 'ארטר יצחק' },
{ value: 'bitzaron', label: 'ביצרון' },
{ value: 'ben_zeev', label: 'בן זאב' },
{ value: 'ben_yaakov', label: 'בן יעקב' },
{ value: 'gottlober', label: 'גוטלובר' },
{ value: 'ginzburg', label: 'גינצבורג' },
{ value: 'dam_hamaccabim', label: 'דם המכבים' },
{ value: 'haomanim', label: 'האומנים' },
{ value: 'haasparagus', label: 'האספרגוס' },
{ value: 'hagvura', label: 'הגבורה' },
{ value: 'hadmumit', label: 'הדמומית' },
{ value: 'hahaskala', label: 'ההשכלה' },
{ value: 'hahatzav', label: 'החצב' },
{ value: 'hahartzit', label: 'החרצית' },
{ value: 'hayasmin', label: 'היסמין' },
{ value: 'hakalanit', label: 'הכלנית' },
{ value: 'hanitzanim', label: 'הניצנים' },
{ value: 'hasolelim', label: 'הסוללים' },
{ value: 'hapragim', label: 'הפרגים' },
{ value: 'hatzabar', label: 'הצבר' },
{ value: 'hatziporen', label: 'הציפורן' },
{ value: 'hatzalaf', label: 'הצלף' },
{ value: 'harakefet', label: 'הרקפת' },
{ value: 'hashalom', label: 'השלום' },
{ value: 'vicki_shiran', label: 'ויקי שירן' },
{ value: 'walter_moses', label: 'ולטר מוזס' },
{ value: 'zichrini', label: 'זכריני' },
{ value: 'tavyov', label: 'טביוב' },
{ value: 'yona_kremenetzky', label: 'יונה קרמינצקי' },
{ value: 'yosef_buxenbaum', label: 'יוסף בוקסנבאום' },
{ value: 'yinon', label: 'ינון' },
{ value: 'yaniv', label: 'יניב' },
{ value: 'yifrach', label: 'יפרח' },
{ value: 'yitzhak_sadeh', label: 'יצחק שדה' },
{ value: 'meitav', label: 'מיטב' },
{ value: 'mandelkern', label: 'מנדלקרן' },
{ value: 'moshe_dayan', label: 'משה דיין' },
{ value: 'nir_am', label: 'ניר עם' },
{ value: 'slonimsky', label: 'סלונימסקי' },
{ value: 'aminadav', label: 'עמינדב' },
{ value: 'plitei_hasefer', label: 'פליטי הספר' },
{ value: 'tzoifel', label: 'צויפל' },
{ value: 'shulman', label: 'שולמן' },
{ value: 'shlomo_rubin', label: 'שלמה רובין' },
{ value: 'tuval', label: 'תובל' }

],

    'bavli': [
  { value: 'hamishna', label: 'המשנה' },
  { value: 'aharon-magad', label: 'אהרן מגד' },
  { value: 'onkelos', label: 'אונקלוס' },
  { value: 'bavli', label: 'בבלי' },
  { value: 'ben-sira', label: 'בן סירא' },
  { value: 'halacha', label: 'ההלכה' },
  { value: 'hazohar', label: 'הזוהר' },
  { value: 'haknesset-hagdola', label: 'הכנסת הגדולה' },
  { value: 'hanesiim', label: 'הנשיאים' },
  { value: 'harav-haratzog', label: 'הרב הרצוג' },
  { value: 'harav-tolidano', label: 'הרב טולידנו' },
  { value: 'harav-nissim', label: 'הרב ניסים' },
  { value: 'harav-uziel', label: 'הרב עוזיאל' },
  { value: 'zemer-hana', label: 'זמר חנה' },
  { value: 'yosef-peamoni', label: 'יוסף פעמוני' },
  { value: 'shtainman', label: 'שטינמן' },
  { value: 'tossefta', label: 'תוספתא' },
  { value: 'yerushalmi', label: 'ירושלמי' },
  { value: 'mordechai-namir', label: 'מרדכי נמיר' },
  { value: 'sanhedrin', label: 'סנהדרין' },
  { value: 'kosovski', label: 'קוסובסקי' }
    ],
    
    'ganei-sharona': [
  { value: 'even-gvirol', label: 'אבן גבירול' },
  { value: 'itamar-ben-avi', label: 'איתמר בן אב"י' },
  { value: 'kalman-magen', label: 'אלוף קלמן מגן' },
  { value: 'osvaldo-aranha', label: 'אסוולדו ארניה' },
  { value: 'begin', label: 'בגין' },
  { value: 'givon', label: 'גבעון' },
  { value: 'dovnov', label: 'דובנוב' },
  { value: 'daniel-frisch', label: 'דניאל פריש' },
  { value: 'haarba', label: 'הארבעה' },
  { value: 'hashmonaim', label: 'החשמונאים' },
  { value: 'hatfatman', label: 'הפטמן' },
  { value: 'chaim-laskov', label: 'חיים לסקוב' },
  { value: 'yehuda-halevi', label: 'יהודה הלוי' },
  { value: 'leonardo-da-vinci', label: 'לאונרדו דה-וינצ\'י' },
  { value: 'kaplan', label: 'קפלן' },
  { value: 'kiryat-sefer', label: 'קריית ספר' },
  { value: 'karlebach', label: 'קרליבך' },
  { value: 'shaul-hamelech', label: 'שאול המלך' },
  { value: 'shprintzak', label: 'שפרינצק' }
      ],
    'neve shaanan': [
{ value: 'iger-akiva', label: 'איגר עקיבא' },
{ value: 'ayelet-hashachar', label: 'איילת השחר' },
{ value: 'erlinger', label: 'ארלנג\'ר' },
{ value: 'begin', label: 'בגין' },
{ value: 'beit-guvrin', label: 'בית גוברין' },
{ value: 'beit-katzir', label: 'בית קציר' },
{ value: 'bney-brak', label: 'בני ברק' },
{ value: 'hagdud-haivri', label: 'הגדוד העברי' },
{ value: 'hagra', label: 'הגר"א' },
{ value: 'haharash', label: 'החרש' },
{ value: 'hanegev', label: 'הנגב' },
{ value: 'haaliya', label: 'העליה' },
{ value: 'hakongres', label: 'הקונגרס' },
{ value: 'har-tzion', label: 'הר ציון' },
{ value: 'harakevet', label: 'הרכבת' },
{ value: 'hashelekhet', label: 'השלכת' },
{ value: 'hashfela', label: 'השפלה' },
{ value: 'hasharon', label: 'השרון' },
{ value: 'wolfson', label: 'וולפסון' },
{ value: 'haznovich', label: 'חזנוביץ' },
{ value: 'peretz-yl', label: 'י"ל פרץ' },
{ value: 'yavan-metzula', label: 'יוון מצולה' },
{ value: 'yosef-lishansky', label: 'יוסף לישנסקי' },
{ value: 'yesod-hamaala', label: 'יסוד המעלה' },
{ value: 'levanda', label: 'לבנדה' },
{ value: 'lewinzki', label: 'לוינסקי' },
{ value: 'matalon', label: 'מטלון' },
{ value: 'miron', label: 'מירון' },
{ value: 'menashe-ben-israel', label: 'מנשה בן ישראל' },
{ value: 'neve-shaanan', label: 'נוה שאנן' },
{ value: 'salomon', label: 'סלומון' },
{ value: 'ein-hakore', label: 'עין הקורא' },
{ value: 'acco', label: 'עכו' },
{ value: 'anatabi', label: 'ענתבי' },
{ value: 'pin', label: 'פין' },
{ value: 'tchelnov', label: 'צ\'לנוב' },
{ value: 'raavad', label: 'ראב"ד' },
{ value: 'rosh-pina', label: 'ראש פינה' },
{ value: 'shivat-zion', label: 'שיבת ציון' },
{ value: 'shlomo', label: 'שלמה' }

 ],

    'florentin': [

  { value: 'avrahamanel', label: 'אברבנאל' },
  { value: 'uriel-acosta', label: 'אוריאל אקוסטה' },
  { value: 'eilat', label: 'אילת' },
  { value: 'aluf-batzlut', label: 'אלוף בצלות' },
  { value: 'eliphelet', label: 'אליפלט' },
  { value: 'efraim-kishon', label: 'אפרים קישון' },
  { value: 'ben-attar', label: 'בן עטר' },
  { value: 'banbanishti', label: 'בנבנישתי' },
  { value: 'gevulot', label: 'גבולות' },
  { value: 'gannai', label: 'גנני' },
  { value: 'hachalutzim', label: 'החלוצים' },
  { value: 'hamchoga', label: 'המחוגה' },
  { value: 'hamashbir', label: 'המשביר' },
  { value: 'hamashor', label: 'המשור' },
  { value: 'hanagarim', label: 'הנגרים' },
  { value: 'haaliya', label: 'העליה' },
  { value: 'harav-frenkel', label: 'הרב פרנקל' },
  { value: 'harabi-mibacherach', label: 'הרבי מבכרך' },
  { value: 'herzl', label: 'הרצל' },
  { value: 'hashuk', label: 'השוק' },
  { value: 'wolfson', label: 'וולפסון' },
  { value: 'washington', label: 'וושינגטון' },
  { value: 'vital-haim', label: 'ויטל חיים' },
  { value: 'zevulun', label: 'זבולון' },
  { value: 'hatzarim', label: 'חצרים' },
  { value: 'yaffo', label: 'יפו' },
  { value: 'kfar-giladi', label: 'כפר גלעדי' },
  { value: 'levinsky', label: 'לוינסקי' },
  { value: 'mizrachi', label: 'מזרחי' },
  { value: 'matlon', label: 'מטלון' },
  { value: 'mesilat-wolfson', label: 'מסילת וולפסון' },
  { value: 'maon', label: 'מעון' },
  { value: 'merchavya', label: 'מרחביה' },
  { value: 'markolet', label: 'מרכולת' },
  { value: 'nahalat-binyamin', label: 'נחלת בנימין' },
  { value: 'simtat-hashuk', label: 'סמטת השוק' },
  { value: 'florentin', label: 'פלורנטין' },
  { value: 'kompert', label: 'קומפרט' },
  { value: 'cordovero', label: 'קורדובירו' },
  { value: 'rehov-1249', label: "רח' 1249" },
  { value: 'rehov-3361', label: "רח' 3361" },
  { value: 'rehov-3813', label: "רח' 3813" },
  { value: 'raanan', label: 'רענן' },
  { value: 'stern', label: 'שטרן' },
  { value: 'shlomo', label: 'שלמה' }
     ], 
     'keremhatemanim': [
  { value: 'a-shikh', label: 'א-שיח\'' },
  { value: 'aharonson', label: 'אהרונסון' },
  { value: 'elyashiv', label: 'אלישיב' },
  { value: 'allenby', label: 'אלנבי' },
  { value: 'beit-yosef', label: 'בית יוסף' },
  { value: 'geula', label: 'גאולה' },
  { value: 'gedera', label: 'גדרה' },
  { value: 'daniel', label: 'דניאל' },
  { value: 'haari', label: 'האר"י' },
  { value: 'hayarkon', label: 'הירקון' },
  { value: 'hakovshim', label: 'הכובשים' },
  { value: 'hakarmel', label: 'הכרמל' },
  { value: 'hillel-hazaken', label: 'הלל הזקן' },
  { value: 'harav-kook', label: 'הרב קוק' },
  { value: 'zerubavel', label: 'זרובבל' },
  { value: 'chaim-chabshush', label: 'חיים חבשוש' },
  { value: 'yom-tov', label: 'יום-טוב' },
  { value: 'yonah-hanavi', label: 'יונה הנביא' },
  { value: 'yihya-kapach', label: 'יחיא קאפח' },
  { value: 'yishkon', label: 'ישכון' },
  { value: 'yisrael-nagara', label: 'ישראל נג\'ארה' },
  { value: 'knafay-nesharim', label: 'כנפי נשרים' },
  { value: 'kerem-hatemanim', label: 'כרם התימנים' },
  { value: 'karmelit', label: 'כרמלית' },
  { value: 'malan', label: 'מל"ן' },
  { value: 'nahaliel', label: 'נחליאל' },
  { value: 'nehemia', label: 'נחמיה' },
  { value: 'ezra-hasopher', label: 'עזרא הסופר' },
  { value: 'kehilat-eden', label: 'קהילת עדן' },
  { value: 'rabbi-meir', label: 'רבי מאיר' },
  { value: 'rabbi-akiva', label: 'רבי עקיבא' },
  { value: 'rabban-gamliel', label: 'רבן גמליאל' },
  { value: 'herbert-samuel-promenade', label: 'רציף הרברט סמואל' },
  { value: 'tarmab', label: 'תרמ"ב' }
],

    'neve-tzedek': [
  
  { value: 'echad-haam', label: 'אחד העם' },
  { value: 'achva', label: 'אחווה' },
  { value: 'eilat', label: 'אילת' },
  { value: 'elazar-rokach', label: 'אלעזר רוקח' },
  { value: 'elroi', label: 'אלרואי' },
  { value: 'amzaleg', label: 'אמזלג' },
  { value: 'arya-shenkar', label: 'אריה שנקר' },
  { value: 'beer-yaakov', label: 'באר יעקב' },
  { value: 'bustanai', label: 'בוסתנאי' },
  { value: 'beit-habad', label: 'בית הבד' },
  { value: 'brant', label: 'ברנט' },
  { value: 'grozenberg', label: 'גרוזנברג' },
  { value: 'degania', label: 'דגניה' },
  { value: 'hermon', label: 'החרמון' },
  { value: 'hayarkon', label: 'הירקון' },
  { value: 'hakarmel', label: 'הכרמל' },
  { value: 'hamered', label: 'המרד' },
  { value: 'hashenit', label: 'השנית' },
  { value: 'hatavor', label: 'התבור' },
  { value: 'chevrat-shas', label: 'חברת ש"ס' },
  { value: 'yavneel', label: 'יבנאל' },
  { value: 'yehuda-hachasid', label: 'יהודה החסיד' },
  { value: 'yehuda-halevi', label: 'יהודה הלוי' },
  { value: 'yehoshua-hatalmi', label: 'יהושע התלמי' },
  { value: 'yechieli', label: 'יחאלי' },
  { value: 'yehezkel-kaufman', label: 'יחזקאל קויפמן' },
  { value: 'yaavetz', label: 'יעבץ' },
  { value: 'yafo', label: 'יפו' },
  { value: 'itzhak-elchanan', label: 'יצחק אלחנן' },
  { value: 'yakinton', label: 'יקינתון' },
  { value: 'yeshivat-volozhin', label: 'ישיבת וולוז\'ין' },
  { value: 'kineret', label: 'כינרת' },
  { value: 'kol-yisrael-chaverim', label: 'כל ישראל חברים' },
  { value: 'kfar-saba', label: 'כפר סבא' },
  { value: 'lilienblum', label: 'לילינבלום' },
  { value: 'lupin', label: 'לפין' },
  { value: 'migdal', label: 'מגדל' },
  { value: 'mohliver', label: 'מוהליבר' },
  { value: 'machane-yosef', label: 'מחנה יוסף' },
  { value: 'metula', label: 'מטולה' },
  { value: 'neve-tzedek', label: 'נוה צדק' },
  { value: 'neve-shalom', label: 'נוה שלום' },
  { value: 'ein-ganim', label: 'עין גנים' },
  { value: 'ein-yaakov', label: 'עין יעקב' },
  { value: 'atzmon', label: 'עצמון' },
  { value: 'pines', label: 'פינס' },
  { value: 'rishonim', label: 'ראשונים' },
  { value: 'rokach-shimon', label: 'רוקח שמעון' },
  { value: 'raanan', label: 'רענן' },
  { value: 'shabazi', label: 'שבזי' },
  { value: 'shtein', label: 'שטיין' },
  { value: 'shalosh', label: 'שלוש' },
  { value: 'shlomo-molcho', label: 'שלמה מולכו' },
  { value: 'shmerling', label: 'שמרלינג' },
  { value: 'sharabi', label: 'שרעבי' },
  { value: 'tahkemoni', label: 'תחכמוני' },
  { value: 'tartza-vav', label: 'תרצ"ו' }

],
    'kiryat-shalom': [
{ value: 'optoshu_yosef', label: 'אופטושו יוסף' },
{ value: 'aharon_yosef', label: 'אחרון יוסף' },
{ value: 'elikim_zunzer', label: 'אליקום צונזר' },
{ value: 'alexander_zaid', label: 'אלכסנדר זייד' },
{ value: 'anda_amir', label: 'אנדה עמיר' },
{ value: 'anski', label: 'אנסקי' },
{ value: 'asirey_zion_1', label: 'אסירי ציון' },
{ value: 'asirey_zion_2', label: 'אסירי ציון' },
{ value: 'asirey_zion_3', label: 'אסירי ציון' },
{ value: 'busel', label: 'בוסל' },
{ value: 'burma', label: 'בורמה' },
{ value: 'beit_yatzkar', label: 'בית יצקר' },
{ value: 'ben_zvi', label: 'בן צבי' },
{ value: 'givat_koach', label: 'גבעת כ"ח' },
{ value: 'gozhikov', label: "גוז'קוב" },
{ value: 'goldfaden', label: 'גולדפאדן' },
{ value: 'guri_israel', label: 'גורי ישראל' },
{ value: 'gitit', label: 'גיתית' },
{ value: 'de_rossi', label: 'די רוסי' },
{ value: 'dik', label: 'דיק' },
{ value: 'dreyfus', label: 'דרייפוס' },
{ value: 'dashavsky', label: 'דשבסקי' },
{ value: 'hadegel', label: 'הדגל' },
{ value: 'havatikim', label: 'הותיקים' },
{ value: 'hazamir', label: 'הזמיר' },
{ value: 'hahizayon', label: 'החיזיון' },
{ value: 'hahatzotzra', label: 'החצוצרה' },
{ value: 'hahermesh', label: 'החרמש' },
{ value: 'hayehudi_ziss', label: 'היהודי זיס' },
{ value: 'hirshbein', label: 'הירשביין' },
{ value: 'hakinor', label: 'הכינור' },
{ value: 'halapid', label: 'הלפיד' },
{ value: 'hamivtzaim', label: 'המבצעים' },
{ value: 'hamagen', label: 'המגן' },
{ value: 'hamatzpen', label: 'המצפן' },
{ value: 'hamishlatim', label: 'המשלטים' },
{ value: 'haogav', label: 'העוגב' },
{ value: 'haklaim', label: 'הקלעים' },
{ value: 'hakanaim', label: 'הקנאים' },
{ value: 'hakeren', label: 'הקרן' },
{ value: 'hakeshet', label: 'הקשת' },
{ value: 'hashofar', label: 'השופר' },
{ value: 'hashayarot', label: 'השיירות' },
{ value: 'hasharvit', label: 'השרביט' },
{ value: 'varshavsky', label: 'ורשבסקי' },
{ value: 'zultzer', label: 'זולצר' },
{ value: 'zigelboim', label: 'זיגלבוים' },
{ value: 'levandovsky', label: 'לבנדובסקי' },
{ value: 'leivik', label: 'ליוויק' },
{ value: 'leib_glantz', label: 'לייב גלאנץ' },
{ value: 'lekert', label: 'לקרט' },
{ value: 'meirbar', label: 'מאירבר' },
{ value: 'mavkiim', label: 'מבקיעים' },
{ value: 'minkovsky', label: 'מינקובסקי' },
{ value: 'misgav_am', label: 'משגב עם' },
{ value: 'nili', label: 'ניל"י' },
{ value: 'nes_harim', label: 'נס הרים' },
{ value: 'amikam', label: 'עמיקם' },
{ value: 'kibbutz_galuyot', label: 'קיבוץ גלויות' },
{ value: 'kaminska', label: 'קמינסקה' },
{ value: 'kaplansky', label: 'קפלנסקי' },
{ value: 'rehov_3628', label: 'רח\' 3628' },
{ value: 'ringelblum', label: 'רינגלבלום' },
{ value: 'shiller', label: 'שילר' },
{ value: 'shloshet_hahitzim', label: 'שלושת החצים' },
{ value: 'shmuel_cohen_yohananoff', label: 'שמואל כהן-יוחננוף' },
{ value: 'tarpa', label: 'תרפ"א' }
],
    'shapira': [
      { value: 'abudraham', label: 'אבודרהם' },
{ value: 'avraham_rovigo', label: 'אברהם רוויגו' },
{ value: 'aryeh_de_modena', label: 'אריה דה-מודינה' },
{ value: 'bayit_hadash', label: 'בית חדש' },
{ value: 'ben_asher', label: 'בן אשר' },
{ value: 'baal_haakeda', label: 'בעל העקידה' },
{ value: 'bar_yohai', label: 'בר-יוחאי' },
{ value: 'givat_ben_yehuda', label: 'גבעת בן יהודה' },
{ value: 'golomb', label: 'גולומב' },
{ value: 'haasif', label: 'האסיף' },
{ value: 'hahagana', label: 'ההגנה' },
{ value: 'har_zion', label: 'הר ציון' },
{ value: 'haraavah', label: 'הראב"ע' },
{ value: 'hashiloach', label: 'השילוח' },
{ value: 'hatibonim', label: 'התיבונים' },
{ value: 'hovot_halevavot', label: 'חובות הלבבות' },
{ value: 'hizkiyahu_hamelech', label: 'חזקיהו המלך' },
{ value: 'heil_hashiryon', label: 'חיל השריון' },
{ value: 'hachmei_atuna', label: 'חכמי אתונה' },
{ value: 'hachmei_israel', label: 'חכמי ישראל' },
{ value: 'hachmei_lublin', label: 'חכמי לובלין' },
{ value: 'hasdai_crescas', label: 'חסדאי קרשקש' },
{ value: 'turei_zahav', label: 'טורי זהב' },
{ value: 'yedayah_hapenini', label: 'ידעיה הפניני' },
{ value: 'yehuda_hayuj', label: "יהודה חיוג'" },
{ value: 'yitzhak_kochavi', label: 'יצחק כוכבי' },
{ value: 'yashar_mikandia', label: 'יש"ר מקנדיאה' },
{ value: 'israel_misalant', label: 'ישראל מסלנט' },
{ value: 'kerem_hemed', label: 'כרם חמד' },
{ value: 'lavanda', label: 'לבנדה' },
{ value: 'ludvipol', label: 'לודויפול' },
{ value: 'levinsky', label: 'לוינסקי' },
{ value: 'lasker', label: 'לסקר' },
{ value: 'maor_hagola', label: 'מאור הגולה' },
{ value: 'meir_balaban', label: 'מאיר בלבן' },
{ value: 'maharsha', label: 'מהרש"א' },
{ value: 'maimon_shlomo', label: 'מימון שלמה' },
{ value: 'malbim', label: 'מלבי"ם' },
{ value: 'mesila_a', label: 'מסילה א' },
{ value: 'mesila_b', label: 'מסילה ב' },
{ value: 'mesilat_yesharim', label: 'מסילת ישרים' },
{ value: 'mekor_haim', label: 'מקור חיים' },
{ value: 'oved', label: 'עובד' },
{ value: 'palkira', label: 'פלקירה' },
{ value: 'kibbutz_galuyot', label: 'קבוץ גלויות' },
{ value: 'kantor', label: 'קנטור' },
{ value: 'raavad', label: 'ראב"ד' },
{ value: 'rabi_meir_baal_hanes', label: 'רבי מאיר בעל הנס' },
{ value: 'rabi_pozilov', label: 'רבי פוזילוב' },
{ value: 'rehov_3677', label: 'רח\' 3677' },
{ value: 'ralbag', label: 'רלב"ג' },
{ value: 'shahal', label: 'שח"ל' },
{ value: 'steinberg', label: 'שטינברג' },
{ value: 'shiper', label: 'שיפר' },
{ value: 'shlomo', label: 'שלמה' }
],
  },
  'eilat': {
    'ben-gurion': [
      { value: 'ehad-haam', label: 'אחד העם' },
      { value: 'ben-gurion-blvd', label: 'שד\' בן גוריון' },
      { value: 'kaplan', label: 'קפלן' },
      { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
      { value: 'katznelson', label: 'כצנלסון' }
    ],
    'hotels': [
      { value: 'antib', label: 'אנטיב' },
      { value: 'tarshish', label: 'תרשיש' },
      { value: 'durban', label: 'דרבן' },
      { value: 'arava-road', label: 'דרך הערבה' },
      { value: 'mitzrayim-road', label: 'דרך מצריים' }
    ],
    'center': [
      { value: 'negev-brigade', label: 'חטיבת הנגב' },
      { value: 'eilot', label: 'אילות' },
      { value: 'gan-binyamin', label: 'גן בנימין' },
      { value: 'yotam-road', label: 'דרך יותם' },
      { value: 'tmarim-blvd', label: 'שד\' התמרים' }
    ],
    'industrial': [
      { value: 'sheshet-hayamim-blvd', label: 'שד\' ששת הימים' },
      { value: 'yozma', label: 'יוזמה' },
      { value: 'golani-brigade', label: 'חטיבת גולני' },
      { value: 'tvuna', label: 'התבונה' },
      { value: 'arava-road', label: 'דרך הערבה' }
    ],
    'yealim': [
      { value: 'horev', label: 'החורב' },
      { value: 'yealim-blvd', label: 'שד\' יעלים' },
      { value: 'golani-brigade', label: 'חטיבת גולני' },
      { value: 'tmarim-blvd', label: 'שד\' התמרים' },
      { value: 'neve-midbar', label: 'נווה מדבר' }
    ],
    'dekel': [
      { value: 'nachshon', label: 'נחשון' },
      { value: 'barnea', label: 'ברנע' },
      { value: 'gishron', label: 'גשרון' },
      { value: 'yerushalaim-hashlema', label: 'ירושלים השלמה' },
      { value: 'tmarim-blvd', label: 'שד\' התמרים' }
    ],
    'eshel': [
      { value: 'eilot', label: 'אילות' },
      { value: 'yotam-road', label: 'דרך יותם' },
      { value: 'hashita', label: 'השיטה' },
      { value: 'lohamei-hagetaot', label: 'לוחמי הגטאות' },
      { value: 'edom', label: 'אדום' }
    ],
    'west-2': [
      { value: 'sheshet-hayamim-blvd', label: 'שד\' ששת הימים' },
      { value: 'yerushalaim-hashlema', label: 'ירושלים השלמה' },
      { value: 'tzin', label: 'צין' },
      { value: 'los-angeles', label: 'לוס אנג\'לס' },
      { value: 'shor', label: 'שור' }
    ],
    'urim': [
      { value: 'sheshet-hayamim-blvd', label: 'שד\' ששת הימים' },
      { value: 'sportaim', label: 'הספורטאים' },
      { value: 'malchit', label: 'סמ מלכית' },
      { value: 'tzur', label: 'צור' },
      { value: 'malkat-shva', label: 'מלכת שבא' }
    ],
    'west-1': [
      { value: 'sportaim', label: 'הספורטאים' },
      { value: 'argaman-blvd', label: 'שד\' ארגמן' },
      { value: 'hotrim', label: 'החותרים' },
      { value: 'sigalit', label: 'הסיגלית' },
      { value: 'yahel', label: 'יהל' }
    ],
    'mitzpe-yam': [
      { value: 'deker', label: 'דקר' },
      { value: 'zaharon', label: 'זהרון' },
      { value: 'karish', label: 'כריש' },
      { value: 'argaman-blvd', label: 'שד\' ארגמן' },
      { value: 'sheshet-hayamim-blvd', label: 'שד\' ששת הימים' }
    ],
    'ofir': [
      { value: 'eilot', label: 'אילות' },
      { value: 'grupit', label: 'גרופית' },
      { value: 'shchoret', label: 'שחורת' },
      { value: 'yotam-road', label: 'דרך יותם' },
      { value: 'los-angeles', label: 'לוס אנג\'לס' }
    ],
    'build-your-home': [
      { value: 'eilot', label: 'אילות' },
      { value: 'yotam-road', label: 'דרך יותם' },
      { value: 'hanesher', label: 'הנשר' },
      { value: 'negev-brigade', label: 'חטיבת הנגב' },
      { value: 'di-zahav', label: 'די זהב' }
    ],
    'ganim': [
      { value: 'tzaelon', label: 'הצאלון' },
      { value: 'tzaftzafa', label: 'הצפצפה' },
      { value: 'barkan', label: 'ברקן' },
      { value: 'yotam-road', label: 'דרך יותם' },
      { value: 'habrosh', label: 'הברוש' }
    ],
    'shahmon-nw': [
      { value: 'hashmonaim', label: 'החשמונאים' },
      { value: 'hanvatim', label: 'הנבטים' },
      { value: 'hashomronim', label: 'השומרונים' },
      { value: 'ein-netafim', label: 'עין נטפים' },
      { value: 'sheshet-hayamim-blvd', label: 'שד\' ששת הימים' }
    ],
    'shahmon-e': [
      { value: 'duvdevan', label: 'דובדבן' },
      { value: 'ein-netafim', label: 'עין נטפים' },
      { value: 'mishol-haagass', label: 'משעול האגס' },
      { value: 'haafarsek', label: 'האפרסק' },
      { value: 'mishol-eshkoliot', label: 'משעול אשכולית' }
    ],
    'shahmon-sw': [
      { value: 'derech-harim', label: 'דרך הרים' },
      { value: 'ein-yahav', label: 'עין יהב' },
      { value: 'ein-mor', label: 'עין מור' },
      { value: 'ein-netafim', label: 'עין נטפים' },
      { value: 'ein-gedi', label: 'עין גדי' }
    ],
    'shahmon-s': [
      { value: 'ein-yahav', label: 'עין יהב' },
      { value: 'ein-netafim', label: 'עין נטפים' },
      { value: 'nahal-hiyon', label: 'נחל חיון' },
      { value: 'nahal-shchoret', label: 'נחל שחרות' },
      { value: 'sheshet-hayamim-blvd', label: 'שד\' ששת הימים' }
    ]
  },
  'ashdod': {
    'industrial-3': [
      { value: 'hamechkar', label: 'המחקר' },
      { value: 'habetichut', label: 'הבטיחות' },
      { value: 'hamada', label: 'המדע' },
      { value: 'hayozma', label: 'היזמה' },
      { value: 'haneft', label: 'הנפט' }
    ],
    'industrial-1-2': [
      { value: 'hayahalomim', label: 'היהלומים' },
      { value: 'haorgim', label: 'האורגים' },
      { value: 'habosem', label: 'הבושם' },
      { value: 'habanaim', label: 'הבנאים' },
      { value: 'haavoda', label: 'העבודה' }
    ],
    'port': [
      { value: 'leskov', label: 'דרך לסקוב' },
      { value: 'tel-mor', label: 'דרך תל מור' },
      { value: 'hayamim', label: 'הימאים' },
      { value: 'hasapanim', label: 'מבוא הספנים' }
    ],
    'quarter-q': [
      { value: 'sitrin', label: 'סיטרין' },
      { value: 'sapir', label: 'ספיר' },
      { value: 'tel-hai', label: 'שד\' תל חי' },
      { value: 'shoham', label: 'שהם' }
    ]
  },
  'ashkelon': {
    'barnea-bg': [
      { value: 'yerushalayim-blvd', label: 'שד\' ירושלים' },
      { value: 'bikurei-anavim', label: 'ביכורי ענבים' },
      { value: 'zichron-yaakov', label: 'זכרון יעקב' },
      { value: 'katzrin', label: 'קצרין' },
      { value: 'rishon-lezion', label: 'ראשון לציון' }
    ],
    'ganei-barnea': [
      { value: 'yerushalayim-blvd', label: 'שד\' ירושלים' },
      { value: 'balfour', label: 'בלפור' },
      { value: 'holzberg-simcha', label: 'הולצברג שמחה' },
      { value: 'hatzionut', label: 'הציונות' },
      { value: 'navon-ofira', label: 'נבון אופירה' }
    ],
    'neot-barnea': [
      { value: 'ahad-haam', label: 'אחד העם' },
      { value: 'hatzionut', label: 'הציונות' },
      { value: 'etzel-blvd', label: 'שד\' אצ"ל' },
      { value: 'cohen-shlomo', label: 'כהן שלמה' },
      { value: 'montefiore-blvd', label: 'שד\' מונטיפיורי' }
    ],
    'barnea-a': [
      { value: 'bar-kochba', label: 'בר כוכבא' },
      { value: 'yerushalayim-blvd', label: 'שד\' ירושלים' },
      { value: 'yiftach-hagiladi', label: 'יפתח הגלעדי' },
      { value: 'ben-yoash-gidon', label: 'בן יואש גדעון' },
      { value: 'segal-zvi', label: 'סגל צבי' }
    ],
    'marina-area': [
      { value: 'golani', label: 'גולני' },
      { value: 'dorot-moshe', label: 'דורות משה' },
      { value: 'hatayas', label: 'הטייסים' },
      { value: 'yafe-nof', label: 'יפה נוף' },
      { value: 'yekutiel-adam', label: 'יקותיאל אדם' }
    ],
    'afridar-west': [
      { value: 'harakefet', label: 'הרקפת' },
      { value: 'hatayas', label: 'הטייסים' },
      { value: 'bar-kochba', label: 'בר כוכבא' },
      { value: 'south-africa-blvd', label: 'שד\' דרום אפריקה' },
      { value: 'givati', label: 'גבעתי' }
    ],
    'afridar-east': [
      { value: 'ben-zvi', label: 'בן צבי' },
      { value: 'johannesburg', label: 'יוהנסבורג' },
      { value: 'haatzmaut', label: 'העצמאות' },
      { value: 'hashikma', label: 'השקמה' },
      { value: 'south-africa-blvd', label: 'שד\' דרום אפריקה' }
    ],
    'afridar-south': [
      { value: 'hadror', label: 'הדרור' },
      { value: 'hanasi', label: 'הנשיא' },
      { value: 'ben-zvi', label: 'בן צבי' },
      { value: 'ort', label: 'אורט' },
      { value: 'malchei-israel', label: 'מלכי ישראל' }
    ],
    'eshkolei-paz': [
      { value: 'ort', label: 'אורט' },
      { value: 'eli-cohen', label: 'אלי כהן' },
      { value: 'eshkolei-paz', label: 'אשכולי פז' },
      { value: 'hanasi', label: 'הנשיא' },
      { value: 'hatapuz', label: 'התפוז' }
    ],
    'ashkelon-city': [
      { value: 'eshtaol', label: 'אשתאול' },
      { value: 'beit-el', label: 'בית אל' },
      { value: 'hanasi', label: 'הנשיא' },
      { value: 'ben-gurion-blvd', label: 'שד\' בן גוריון' },
      { value: 'geva', label: 'גבע' }
    ],
    'merkaz-nifti': [
      { value: 'ben-zvi', label: 'בן צבי' },
      { value: 'hagvura', label: 'הגבורה' },
      { value: 'ben-gurion-blvd', label: 'שד\' בן גוריון' },
      { value: 'kibbutz-galuyot', label: 'קבוץ גלויות' },
      { value: 'eli-cohen', label: 'אלי כהן' }
    ],
    'neot-ashkelon': [
      { value: 'remez-david', label: 'רמז דוד' },
      { value: 'ayala', label: 'איילה' },
      { value: 'aryeh', label: 'אריה' },
      { value: 'neve-shalom', label: 'נוה שלום' },
      { value: 'namer', label: 'נמר' }
    ],
    'neve-ilan': [
      { value: 'remez-david', label: 'רמז דוד' },
      { value: 'pekiin', label: 'פקיעין' },
      { value: 'lachish', label: 'לכיש' },
      { value: 'eli-cohen', label: 'אלי כהן' },
      { value: 'tiberias', label: 'טבריה' }
    ],
    'neve-hadarim': [
      { value: 'iyar', label: 'אייר' },
      { value: 'eli-cohen', label: 'אלי כהן' },
      { value: 'begin-menachem', label: 'בגין מנחם' },
      { value: 'sivan', label: 'סיון' },
      { value: 'tishrei', label: 'תשרי' }
    ],
    'neve-dekalim-s': [
      { value: 'kanfei-nesharim', label: 'כנפי נשרים' },
      { value: 'amishav', label: 'עמישב' },
      { value: 'amiad', label: 'עמיעד' },
      { value: 'exodus', label: 'אקסודוס' },
      { value: 'yahadut-sfarad', label: 'יהדות ספרד' }
    ],
    'neve-dekalim-n': [
      { value: 'exodus', label: 'אקסודוס' },
      { value: 'kol-israel-chaverim', label: 'כל ישראל חברים' },
      { value: 'kanfei-nesharim', label: 'כנפי נשרים' },
      { value: 'amishav', label: 'עמישב' },
      { value: 'shear-yashuv', label: 'שאר ישוב' }
    ],
    'kochav-hatzafon': [
      { value: 'begin-menachem', label: 'בגין מנחם' },
      { value: 'rambam', label: 'רמב"ם' },
      { value: 'eli-cohen', label: 'אלי כהן' },
      { value: 'ibn-ezra', label: 'אבן עזרא' },
      { value: 'hasofrim-hayehudim', label: 'הסופרים היהודים' }
    ],
    'migdal': [
      { value: 'ussishkin', label: 'אוסישקין' },
      { value: 'eli-cohen', label: 'אלי כהן' },
      { value: 'herzl', label: 'הרצל' },
      { value: 'tzahal', label: 'צה"ל' },
      { value: 'remez-david', label: 'רמז דוד' }
    ],
    'ramat-eshkol': [
      { value: 'sh-b-yeshayahu', label: 'ש ב ישעיהו' },
      { value: 'ibn-ezra', label: 'אבן עזרא' },
      { value: 'haavoda', label: 'העבודה' },
      { value: 'tzahal', label: 'צה"ל' },
      { value: 'raziel-david', label: 'רזיאל דוד' }
    ],
    'industrial-n': [
      { value: 'hapninim', label: 'הפנינים' },
      { value: 'tzahal', label: 'צה"ל' },
      { value: 'ben-gurion-blvd', label: 'שד\' בן גוריון' },
      { value: 'hataasia-blvd', label: 'שד\' התעשיה' },
      { value: 'hakishur', label: 'הכישור' }
    ],
    'givat-flowers': [
      { value: 'avimelech', label: 'אבימלך' },
      { value: 'hashvatim', label: 'השבטים' },
      { value: 'eliav-uri', label: 'אליאב אורי' },
      { value: 'binyamin', label: 'בנימין' },
      { value: 'reuven', label: 'ראובן' }
    ],
    'givat-zion': [
      { value: 'hashoftim', label: 'השופטים' },
      { value: 'shivat-zion', label: 'שיבת ציון' },
      { value: 'hatchiya', label: 'התחיה' },
      { value: 'eliyahu-hanavi', label: 'אליהו הנביא' },
      { value: 'haneviim', label: 'הנביאים' }
    ],
    'gan-vradim': [
      { value: 'bialik', label: 'ביאליק' },
      { value: 'hasochnut-hayehudit', label: 'הסוכנות היהודית' },
      { value: 'hatzofim', label: 'הצופים' },
      { value: 'ofer-avraham', label: 'עופר אברהם' },
      { value: 'keren-hayesod', label: 'קרן היסוד' }
    ],
    'shimshon-e': [
      { value: 'ofer-avraham', label: 'עופר אברהם' }
    ],
    'shikmim': [
      { value: 'bialik', label: 'ביאליק' },
      { value: 'milrod-eliezer', label: 'מילרוד אליעזר' },
      { value: 'tzur-efraim', label: 'צור אפרים' },
      { value: 'ofer-avraham', label: 'עופר אברהם' },
      { value: 'yoseftal', label: 'יוספטל' }
    ],
    'jabotinsky': [
      { value: 'bialik', label: 'ביאליק' },
      { value: 'histadrut', label: 'ההסתדרות' },
      { value: 'jabotinsky', label: 'ז\'בוטינסקי' },
      { value: 'yoseftal', label: 'יוספטל' },
      { value: 'haportzim', label: 'הפורצים' }
    ],
    'shimshon-c': [
      { value: 'tchernichovsky', label: 'טשרניחובסקי' },
      { value: 'mendele-mocher-sfarim', label: 'מנדלי מוכר ספרים' },
      { value: 'histadrut', label: 'ההסתדרות' },
      { value: 'bialik', label: 'ביאליק' },
      { value: 'peretz-y-l', label: 'פרץ י ל' }
    ],
    'ben-gurion': [
      { value: 'bialik', label: 'ביאליק' },
      { value: 'histadrut', label: 'ההסתדרות' },
      { value: 'chatam-sofer', label: 'חתם סופר' },
      { value: 'harav-uziel', label: 'הרב עוזיאל' },
      { value: 'spinoza', label: 'שפינוזה' }
    ],
    'barzilai': [
      { value: 'harav-nissim-yitzhak', label: 'הרב נסים יצחק' },
      { value: 'histadrut', label: 'ההסתדרות' },
      { value: 'agnon', label: 'עגנון' },
      { value: 'shapira-blvd', label: 'שד\' שפירא' },
      { value: 'ben-gurion-blvd', label: 'שד\' בן גוריון' }
    ],
    'neve-alonim': [
      { value: 'moshe', label: 'משה' },
      { value: 'nitzanim', label: 'ניצנים' },
      { value: 'agnon', label: 'עגנון' },
      { value: 'shapira-blvd', label: 'שד\' שפירא' },
      { value: 'histadrut', label: 'ההסתדרות' }
    ],
    'golda': [
      { value: 'shani-eliyahu', label: 'שני אליהו' },
      { value: 'ben-yehuda-eliezer', label: 'בן יהודה אליעזר' },
      { value: 'olei-hagardom', label: 'עולי הגרדום' },
      { value: 'plugot', label: 'פלוגות' },
      { value: 'shapira-blvd', label: 'שד\' שפירא' }
    ],
    'industrial-s': [
      { value: 'bar-lev-blvd', label: 'שד\' חיים בר-לב' },
      { value: 'hutzot-hayotzer', label: 'חוצות היוצר' },
      { value: 'haamal', label: 'העמל' },
      { value: 'ben-yehuda-eliezer', label: 'בן יהודה אליעזר' },
      { value: 'hametachnen', label: 'המתכנן' }
    ]
  }
};
